const __vite__mapDeps = (
  i,
  m = __vite__mapDeps,
  d = m.f ||
    (m.f = [
      './cart-drawer-items-Bh2R4wgB.js',
      './cart-items-BrQubsXJ.js',
      './fetch-config-ExtzPtay.js',
      './product-form-B5zVRFIO.js',
    ])
) => i.map(i => d[i])
;(function () {
  const e = document.createElement('link').relList
  if (e && e.supports && e.supports('modulepreload')) return
  for (const r of document.querySelectorAll('link[rel="modulepreload"]')) s(r)
  new MutationObserver(r => {
    for (const a of r)
      if (a.type === 'childList')
        for (const p of a.addedNodes)
          p.tagName === 'LINK' && p.rel === 'modulepreload' && s(p)
  }).observe(document, { childList: !0, subtree: !0 })
  function t(r) {
    const a = {}
    return (
      r.integrity && (a.integrity = r.integrity),
      r.referrerPolicy && (a.referrerPolicy = r.referrerPolicy),
      r.crossOrigin === 'use-credentials'
        ? (a.credentials = 'include')
        : r.crossOrigin === 'anonymous'
          ? (a.credentials = 'omit')
          : (a.credentials = 'same-origin'),
      a
    )
  }
  function s(r) {
    if (r.ep) return
    r.ep = !0
    const a = t(r)
    fetch(r.href, a)
  }
})()
function at(i) {
  return (
    i !== null &&
    typeof i == 'object' &&
    'constructor' in i &&
    i.constructor === Object
  )
}
function it(i, e) {
  ;(i === void 0 && (i = {}), e === void 0 && (e = {}))
  const t = ['__proto__', 'constructor', 'prototype']
  Object.keys(e)
    .filter(s => t.indexOf(s) < 0)
    .forEach(s => {
      typeof i[s] > 'u'
        ? (i[s] = e[s])
        : at(e[s]) && at(i[s]) && Object.keys(e[s]).length > 0 && it(i[s], e[s])
    })
}
const ht = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: { blur() {}, nodeName: '' },
  querySelector() {
    return null
  },
  querySelectorAll() {
    return []
  },
  getElementById() {
    return null
  },
  createEvent() {
    return { initEvent() {} }
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return []
      },
    }
  },
  createElementNS() {
    return {}
  },
  importNode() {
    return null
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: '',
  },
}
function W() {
  const i = typeof document < 'u' ? document : {}
  return (it(i, ht), i)
}
const Mt = {
  document: ht,
  navigator: { userAgent: '' },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: '',
  },
  history: { replaceState() {}, pushState() {}, go() {}, back() {} },
  CustomEvent: function () {
    return this
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return ''
      },
    }
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {}
  },
  requestAnimationFrame(i) {
    return typeof setTimeout > 'u' ? (i(), null) : setTimeout(i, 0)
  },
  cancelAnimationFrame(i) {
    typeof setTimeout > 'u' || clearTimeout(i)
  },
}
function X() {
  const i = typeof window < 'u' ? window : {}
  return (it(i, Mt), i)
}
function de(i) {
  return (
    i === void 0 && (i = ''),
    i
      .trim()
      .split(' ')
      .filter(e => !!e.trim())
  )
}
function Ct(i) {
  const e = i
  Object.keys(e).forEach(t => {
    try {
      e[t] = null
    } catch {}
    try {
      delete e[t]
    } catch {}
  })
}
function ge(i, e) {
  return (e === void 0 && (e = 0), setTimeout(i, e))
}
function J() {
  return Date.now()
}
function Pt(i) {
  const e = X()
  let t
  return (
    e.getComputedStyle && (t = e.getComputedStyle(i, null)),
    !t && i.currentStyle && (t = i.currentStyle),
    t || (t = i.style),
    t
  )
}
function Ze(i, e) {
  e === void 0 && (e = 'x')
  const t = X()
  let s, r, a
  const p = Pt(i)
  return (
    t.WebKitCSSMatrix
      ? ((r = p.transform || p.webkitTransform),
        r.split(',').length > 6 &&
          (r = r
            .split(', ')
            .map(c => c.replace(',', '.'))
            .join(', ')),
        (a = new t.WebKitCSSMatrix(r === 'none' ? '' : r)))
      : ((a =
          p.MozTransform ||
          p.OTransform ||
          p.MsTransform ||
          p.msTransform ||
          p.transform ||
          p
            .getPropertyValue('transform')
            .replace('translate(', 'matrix(1, 0, 0, 1,')),
        (s = a.toString().split(','))),
    e === 'x' &&
      (t.WebKitCSSMatrix
        ? (r = a.m41)
        : s.length === 16
          ? (r = parseFloat(s[12]))
          : (r = parseFloat(s[4]))),
    e === 'y' &&
      (t.WebKitCSSMatrix
        ? (r = a.m42)
        : s.length === 16
          ? (r = parseFloat(s[13]))
          : (r = parseFloat(s[5]))),
    r || 0
  )
}
function xe(i) {
  return (
    typeof i == 'object' &&
    i !== null &&
    i.constructor &&
    Object.prototype.toString.call(i).slice(8, -1) === 'Object'
  )
}
function Lt(i) {
  return typeof window < 'u' && typeof window.HTMLElement < 'u'
    ? i instanceof HTMLElement
    : i && (i.nodeType === 1 || i.nodeType === 11)
}
function Z() {
  const i = Object(arguments.length <= 0 ? void 0 : arguments[0]),
    e = ['__proto__', 'constructor', 'prototype']
  for (let t = 1; t < arguments.length; t += 1) {
    const s = t < 0 || arguments.length <= t ? void 0 : arguments[t]
    if (s != null && !Lt(s)) {
      const r = Object.keys(Object(s)).filter(a => e.indexOf(a) < 0)
      for (let a = 0, p = r.length; a < p; a += 1) {
        const c = r[a],
          f = Object.getOwnPropertyDescriptor(s, c)
        f !== void 0 &&
          f.enumerable &&
          (xe(i[c]) && xe(s[c])
            ? s[c].__swiper__
              ? (i[c] = s[c])
              : Z(i[c], s[c])
            : !xe(i[c]) && xe(s[c])
              ? ((i[c] = {}), s[c].__swiper__ ? (i[c] = s[c]) : Z(i[c], s[c]))
              : (i[c] = s[c]))
      }
    }
  }
  return i
}
function Te(i, e, t) {
  i.style.setProperty(e, t)
}
function gt(i) {
  let { swiper: e, targetPosition: t, side: s } = i
  const r = X(),
    a = -e.translate
  let p = null,
    c
  const f = e.params.speed
  ;((e.wrapperEl.style.scrollSnapType = 'none'),
    r.cancelAnimationFrame(e.cssModeFrameID))
  const d = t > a ? 'next' : 'prev',
    l = (w, h) => (d === 'next' && w >= h) || (d === 'prev' && w <= h),
    u = () => {
      ;((c = new Date().getTime()), p === null && (p = c))
      const w = Math.max(Math.min((c - p) / f, 1), 0),
        h = 0.5 - Math.cos(w * Math.PI) / 2
      let n = a + h * (t - a)
      if ((l(n, t) && (n = t), e.wrapperEl.scrollTo({ [s]: n }), l(n, t))) {
        ;((e.wrapperEl.style.overflow = 'hidden'),
          (e.wrapperEl.style.scrollSnapType = ''),
          setTimeout(() => {
            ;((e.wrapperEl.style.overflow = ''),
              e.wrapperEl.scrollTo({ [s]: n }))
          }),
          r.cancelAnimationFrame(e.cssModeFrameID))
        return
      }
      e.cssModeFrameID = r.requestAnimationFrame(u)
    }
  u()
}
function fe(i) {
  return (
    i.querySelector('.swiper-slide-transform') ||
    (i.shadowRoot && i.shadowRoot.querySelector('.swiper-slide-transform')) ||
    i
  )
}
function j(i, e) {
  e === void 0 && (e = '')
  const t = X(),
    s = [...i.children]
  return (
    t.HTMLSlotElement &&
      i instanceof HTMLSlotElement &&
      s.push(...i.assignedElements()),
    e ? s.filter(r => r.matches(e)) : s
  )
}
function zt(i, e) {
  const t = [e]
  for (; t.length > 0; ) {
    const s = t.shift()
    if (i === s) return !0
    t.push(
      ...s.children,
      ...(s.shadowRoot ? s.shadowRoot.children : []),
      ...(s.assignedElements ? s.assignedElements() : [])
    )
  }
}
function It(i, e) {
  const t = X()
  let s = e.contains(i)
  return (
    !s &&
      t.HTMLSlotElement &&
      e instanceof HTMLSlotElement &&
      ((s = [...e.assignedElements()].includes(i)), s || (s = zt(i, e))),
    s
  )
}
function De(i) {
  try {
    console.warn(i)
    return
  } catch {}
}
function Q(i, e) {
  e === void 0 && (e = [])
  const t = document.createElement(i)
  return (t.classList.add(...(Array.isArray(e) ? e : de(e))), t)
}
function $e(i) {
  const e = X(),
    t = W(),
    s = i.getBoundingClientRect(),
    r = t.body,
    a = i.clientTop || r.clientTop || 0,
    p = i.clientLeft || r.clientLeft || 0,
    c = i === e ? e.scrollY : i.scrollTop,
    f = i === e ? e.scrollX : i.scrollLeft
  return { top: s.top + c - a, left: s.left + f - p }
}
function At(i, e) {
  const t = []
  for (; i.previousElementSibling; ) {
    const s = i.previousElementSibling
    ;(e ? s.matches(e) && t.push(s) : t.push(s), (i = s))
  }
  return t
}
function Ot(i, e) {
  const t = []
  for (; i.nextElementSibling; ) {
    const s = i.nextElementSibling
    ;(e ? s.matches(e) && t.push(s) : t.push(s), (i = s))
  }
  return t
}
function ce(i, e) {
  return X().getComputedStyle(i, null).getPropertyValue(e)
}
function Ce(i) {
  let e = i,
    t
  if (e) {
    for (t = 0; (e = e.previousSibling) !== null; ) e.nodeType === 1 && (t += 1)
    return t
  }
}
function pe(i, e) {
  const t = []
  let s = i.parentElement
  for (; s; ) (e ? s.matches(e) && t.push(s) : t.push(s), (s = s.parentElement))
  return t
}
function Me(i, e) {
  function t(s) {
    s.target === i && (e.call(i, s), i.removeEventListener('transitionend', t))
  }
  e && i.addEventListener('transitionend', t)
}
function Qe(i, e, t) {
  const s = X()
  return (
    i[e === 'width' ? 'offsetWidth' : 'offsetHeight'] +
    parseFloat(
      s
        .getComputedStyle(i, null)
        .getPropertyValue(e === 'width' ? 'margin-right' : 'margin-top')
    ) +
    parseFloat(
      s
        .getComputedStyle(i, null)
        .getPropertyValue(e === 'width' ? 'margin-left' : 'margin-bottom')
    )
  )
}
function H(i) {
  return (Array.isArray(i) ? i : [i]).filter(e => !!e)
}
function _e(i) {
  return e =>
    Math.abs(e) > 0 &&
    i.browser &&
    i.browser.need3dFix &&
    Math.abs(e) % 90 === 0
      ? e + 0.001
      : e
}
function ee(i, e) {
  ;(e === void 0 && (e = ''),
    typeof trustedTypes < 'u'
      ? (i.innerHTML = trustedTypes
          .createPolicy('html', { createHTML: t => t })
          .createHTML(e))
      : (i.innerHTML = e))
}
let Ye
function Dt() {
  const i = X(),
    e = W()
  return {
    smoothScroll:
      e.documentElement &&
      e.documentElement.style &&
      'scrollBehavior' in e.documentElement.style,
    touch: !!(
      'ontouchstart' in i ||
      (i.DocumentTouch && e instanceof i.DocumentTouch)
    ),
  }
}
function wt() {
  return (Ye || (Ye = Dt()), Ye)
}
let Ne
function $t(i) {
  let { userAgent: e } = i === void 0 ? {} : i
  const t = wt(),
    s = X(),
    r = s.navigator.platform,
    a = e || s.navigator.userAgent,
    p = { ios: !1, android: !1 },
    c = s.screen.width,
    f = s.screen.height,
    d = a.match(/(Android);?[\s\/]+([\d.]+)?/)
  let l = a.match(/(iPad).*OS\s([\d_]+)/)
  const u = a.match(/(iPod)(.*OS\s([\d_]+))?/),
    w = !l && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
    h = r === 'Win32'
  let n = r === 'MacIntel'
  const o = [
    '1024x1366',
    '1366x1024',
    '834x1194',
    '1194x834',
    '834x1112',
    '1112x834',
    '768x1024',
    '1024x768',
    '820x1180',
    '1180x820',
    '810x1080',
    '1080x810',
  ]
  return (
    !l &&
      n &&
      t.touch &&
      o.indexOf(`${c}x${f}`) >= 0 &&
      ((l = a.match(/(Version)\/([\d.]+)/)),
      l || (l = [0, 1, '13_0_0']),
      (n = !1)),
    d && !h && ((p.os = 'android'), (p.android = !0)),
    (l || w || u) && ((p.os = 'ios'), (p.ios = !0)),
    p
  )
}
function vt(i) {
  return (i === void 0 && (i = {}), Ne || (Ne = $t(i)), Ne)
}
let Fe
function _t() {
  const i = X(),
    e = vt()
  let t = !1
  function s() {
    const c = i.navigator.userAgent.toLowerCase()
    return (
      c.indexOf('safari') >= 0 &&
      c.indexOf('chrome') < 0 &&
      c.indexOf('android') < 0
    )
  }
  if (s()) {
    const c = String(i.navigator.userAgent)
    if (c.includes('Version/')) {
      const [f, d] = c
        .split('Version/')[1]
        .split(' ')[0]
        .split('.')
        .map(l => Number(l))
      t = f < 16 || (f === 16 && d < 2)
    }
  }
  const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
      i.navigator.userAgent
    ),
    a = s(),
    p = a || (r && e.ios)
  return { isSafari: t || a, needPerspectiveFix: t, need3dFix: p, isWebView: r }
}
function bt() {
  return (Fe || (Fe = _t()), Fe)
}
function kt(i) {
  let { swiper: e, on: t, emit: s } = i
  const r = X()
  let a = null,
    p = null
  const c = () => {
      !e || e.destroyed || !e.initialized || (s('beforeResize'), s('resize'))
    },
    f = () => {
      !e ||
        e.destroyed ||
        !e.initialized ||
        ((a = new ResizeObserver(u => {
          p = r.requestAnimationFrame(() => {
            const { width: w, height: h } = e
            let n = w,
              o = h
            ;(u.forEach(v => {
              let { contentBoxSize: b, contentRect: g, target: m } = v
              ;(m && m !== e.el) ||
                ((n = g ? g.width : (b[0] || b).inlineSize),
                (o = g ? g.height : (b[0] || b).blockSize))
            }),
              (n !== w || o !== h) && c())
          })
        })),
        a.observe(e.el))
    },
    d = () => {
      ;(p && r.cancelAnimationFrame(p),
        a && a.unobserve && e.el && (a.unobserve(e.el), (a = null)))
    },
    l = () => {
      !e || e.destroyed || !e.initialized || s('orientationchange')
    }
  ;(t('init', () => {
    if (e.params.resizeObserver && typeof r.ResizeObserver < 'u') {
      f()
      return
    }
    ;(r.addEventListener('resize', c),
      r.addEventListener('orientationchange', l))
  }),
    t('destroy', () => {
      ;(d(),
        r.removeEventListener('resize', c),
        r.removeEventListener('orientationchange', l))
    }))
}
function Rt(i) {
  let { swiper: e, extendParams: t, on: s, emit: r } = i
  const a = [],
    p = X(),
    c = function (l, u) {
      u === void 0 && (u = {})
      const w = p.MutationObserver || p.WebkitMutationObserver,
        h = new w(n => {
          if (e.__preventObserver__) return
          if (n.length === 1) {
            r('observerUpdate', n[0])
            return
          }
          const o = function () {
            r('observerUpdate', n[0])
          }
          p.requestAnimationFrame
            ? p.requestAnimationFrame(o)
            : p.setTimeout(o, 0)
        })
      ;(h.observe(l, {
        attributes: typeof u.attributes > 'u' ? !0 : u.attributes,
        childList: e.isElement || (typeof u.childList > 'u' ? !0 : u).childList,
        characterData: typeof u.characterData > 'u' ? !0 : u.characterData,
      }),
        a.push(h))
    },
    f = () => {
      if (e.params.observer) {
        if (e.params.observeParents) {
          const l = pe(e.hostEl)
          for (let u = 0; u < l.length; u += 1) c(l[u])
        }
        ;(c(e.hostEl, { childList: e.params.observeSlideChildren }),
          c(e.wrapperEl, { attributes: !1 }))
      }
    },
    d = () => {
      ;(a.forEach(l => {
        l.disconnect()
      }),
        a.splice(0, a.length))
    }
  ;(t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
    s('init', f),
    s('destroy', d))
}
var Bt = {
  on(i, e, t) {
    const s = this
    if (!s.eventsListeners || s.destroyed || typeof e != 'function') return s
    const r = t ? 'unshift' : 'push'
    return (
      i.split(' ').forEach(a => {
        ;(s.eventsListeners[a] || (s.eventsListeners[a] = []),
          s.eventsListeners[a][r](e))
      }),
      s
    )
  },
  once(i, e, t) {
    const s = this
    if (!s.eventsListeners || s.destroyed || typeof e != 'function') return s
    function r() {
      ;(s.off(i, r), r.__emitterProxy && delete r.__emitterProxy)
      for (var a = arguments.length, p = new Array(a), c = 0; c < a; c++)
        p[c] = arguments[c]
      e.apply(s, p)
    }
    return ((r.__emitterProxy = e), s.on(i, r, t))
  },
  onAny(i, e) {
    const t = this
    if (!t.eventsListeners || t.destroyed || typeof i != 'function') return t
    const s = e ? 'unshift' : 'push'
    return (
      t.eventsAnyListeners.indexOf(i) < 0 && t.eventsAnyListeners[s](i),
      t
    )
  },
  offAny(i) {
    const e = this
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e
    const t = e.eventsAnyListeners.indexOf(i)
    return (t >= 0 && e.eventsAnyListeners.splice(t, 1), e)
  },
  off(i, e) {
    const t = this
    return (
      !t.eventsListeners ||
        t.destroyed ||
        !t.eventsListeners ||
        i.split(' ').forEach(s => {
          typeof e > 'u'
            ? (t.eventsListeners[s] = [])
            : t.eventsListeners[s] &&
              t.eventsListeners[s].forEach((r, a) => {
                ;(r === e || (r.__emitterProxy && r.__emitterProxy === e)) &&
                  t.eventsListeners[s].splice(a, 1)
              })
        }),
      t
    )
  },
  emit() {
    const i = this
    if (!i.eventsListeners || i.destroyed || !i.eventsListeners) return i
    let e, t, s
    for (var r = arguments.length, a = new Array(r), p = 0; p < r; p++)
      a[p] = arguments[p]
    return (
      typeof a[0] == 'string' || Array.isArray(a[0])
        ? ((e = a[0]), (t = a.slice(1, a.length)), (s = i))
        : ((e = a[0].events), (t = a[0].data), (s = a[0].context || i)),
      t.unshift(s),
      (Array.isArray(e) ? e : e.split(' ')).forEach(f => {
        ;(i.eventsAnyListeners &&
          i.eventsAnyListeners.length &&
          i.eventsAnyListeners.forEach(d => {
            d.apply(s, [f, ...t])
          }),
          i.eventsListeners &&
            i.eventsListeners[f] &&
            i.eventsListeners[f].forEach(d => {
              d.apply(s, t)
            }))
      }),
      i
    )
  },
}
function Gt() {
  const i = this
  let e, t
  const s = i.el
  ;(typeof i.params.width < 'u' && i.params.width !== null
    ? (e = i.params.width)
    : (e = s.clientWidth),
    typeof i.params.height < 'u' && i.params.height !== null
      ? (t = i.params.height)
      : (t = s.clientHeight),
    !((e === 0 && i.isHorizontal()) || (t === 0 && i.isVertical())) &&
      ((e =
        e -
        parseInt(ce(s, 'padding-left') || 0, 10) -
        parseInt(ce(s, 'padding-right') || 0, 10)),
      (t =
        t -
        parseInt(ce(s, 'padding-top') || 0, 10) -
        parseInt(ce(s, 'padding-bottom') || 0, 10)),
      Number.isNaN(e) && (e = 0),
      Number.isNaN(t) && (t = 0),
      Object.assign(i, {
        width: e,
        height: t,
        size: i.isHorizontal() ? e : t,
      })))
}
function Ht() {
  const i = this
  function e(T, I) {
    return parseFloat(T.getPropertyValue(i.getDirectionLabel(I)) || 0)
  }
  const t = i.params,
    { wrapperEl: s, slidesEl: r, size: a, rtlTranslate: p, wrongRTL: c } = i,
    f = i.virtual && t.virtual.enabled,
    d = f ? i.virtual.slides.length : i.slides.length,
    l = j(r, `.${i.params.slideClass}, swiper-slide`),
    u = f ? i.virtual.slides.length : l.length
  let w = []
  const h = [],
    n = []
  let o = t.slidesOffsetBefore
  typeof o == 'function' && (o = t.slidesOffsetBefore.call(i))
  let v = t.slidesOffsetAfter
  typeof v == 'function' && (v = t.slidesOffsetAfter.call(i))
  const b = i.snapGrid.length,
    g = i.slidesGrid.length
  let m = t.spaceBetween,
    y = -o,
    x = 0,
    O = 0
  if (typeof a > 'u') return
  ;(typeof m == 'string' && m.indexOf('%') >= 0
    ? (m = (parseFloat(m.replace('%', '')) / 100) * a)
    : typeof m == 'string' && (m = parseFloat(m)),
    (i.virtualSize = -m),
    l.forEach(T => {
      ;(p ? (T.style.marginLeft = '') : (T.style.marginRight = ''),
        (T.style.marginBottom = ''),
        (T.style.marginTop = ''))
    }),
    t.centeredSlides &&
      t.cssMode &&
      (Te(s, '--swiper-centered-offset-before', ''),
      Te(s, '--swiper-centered-offset-after', '')))
  const L = t.grid && t.grid.rows > 1 && i.grid
  L ? i.grid.initSlides(l) : i.grid && i.grid.unsetSlides()
  let z
  const S =
    t.slidesPerView === 'auto' &&
    t.breakpoints &&
    Object.keys(t.breakpoints).filter(
      T => typeof t.breakpoints[T].slidesPerView < 'u'
    ).length > 0
  for (let T = 0; T < u; T += 1) {
    z = 0
    let I
    if (
      (l[T] && (I = l[T]),
      L && i.grid.updateSlide(T, I, l),
      !(l[T] && ce(I, 'display') === 'none'))
    ) {
      if (t.slidesPerView === 'auto') {
        S && (l[T].style[i.getDirectionLabel('width')] = '')
        const P = getComputedStyle(I),
          C = I.style.transform,
          A = I.style.webkitTransform
        if (
          (C && (I.style.transform = 'none'),
          A && (I.style.webkitTransform = 'none'),
          t.roundLengths)
        )
          z = i.isHorizontal() ? Qe(I, 'width') : Qe(I, 'height')
        else {
          const $ = e(P, 'width'),
            k = e(P, 'padding-left'),
            E = e(P, 'padding-right'),
            M = e(P, 'margin-left'),
            B = e(P, 'margin-right'),
            G = P.getPropertyValue('box-sizing')
          if (G && G === 'border-box') z = $ + M + B
          else {
            const { clientWidth: Y, offsetWidth: F } = I
            z = $ + k + E + M + B + (F - Y)
          }
        }
        ;(C && (I.style.transform = C),
          A && (I.style.webkitTransform = A),
          t.roundLengths && (z = Math.floor(z)))
      } else
        ((z = (a - (t.slidesPerView - 1) * m) / t.slidesPerView),
          t.roundLengths && (z = Math.floor(z)),
          l[T] && (l[T].style[i.getDirectionLabel('width')] = `${z}px`))
      ;(l[T] && (l[T].swiperSlideSize = z),
        n.push(z),
        t.centeredSlides
          ? ((y = y + z / 2 + x / 2 + m),
            x === 0 && T !== 0 && (y = y - a / 2 - m),
            T === 0 && (y = y - a / 2 - m),
            Math.abs(y) < 1 / 1e3 && (y = 0),
            t.roundLengths && (y = Math.floor(y)),
            O % t.slidesPerGroup === 0 && w.push(y),
            h.push(y))
          : (t.roundLengths && (y = Math.floor(y)),
            (O - Math.min(i.params.slidesPerGroupSkip, O)) %
              i.params.slidesPerGroup ===
              0 && w.push(y),
            h.push(y),
            (y = y + z + m)),
        (i.virtualSize += z + m),
        (x = z),
        (O += 1))
    }
  }
  if (
    ((i.virtualSize = Math.max(i.virtualSize, a) + v),
    p &&
      c &&
      (t.effect === 'slide' || t.effect === 'coverflow') &&
      (s.style.width = `${i.virtualSize + m}px`),
    t.setWrapperSize &&
      (s.style[i.getDirectionLabel('width')] = `${i.virtualSize + m}px`),
    L && i.grid.updateWrapperSize(z, w),
    !t.centeredSlides)
  ) {
    const T = []
    for (let I = 0; I < w.length; I += 1) {
      let P = w[I]
      ;(t.roundLengths && (P = Math.floor(P)),
        w[I] <= i.virtualSize - a && T.push(P))
    }
    ;((w = T),
      Math.floor(i.virtualSize - a) - Math.floor(w[w.length - 1]) > 1 &&
        w.push(i.virtualSize - a))
  }
  if (f && t.loop) {
    const T = n[0] + m
    if (t.slidesPerGroup > 1) {
      const I = Math.ceil(
          (i.virtual.slidesBefore + i.virtual.slidesAfter) / t.slidesPerGroup
        ),
        P = T * t.slidesPerGroup
      for (let C = 0; C < I; C += 1) w.push(w[w.length - 1] + P)
    }
    for (let I = 0; I < i.virtual.slidesBefore + i.virtual.slidesAfter; I += 1)
      (t.slidesPerGroup === 1 && w.push(w[w.length - 1] + T),
        h.push(h[h.length - 1] + T),
        (i.virtualSize += T))
  }
  if ((w.length === 0 && (w = [0]), m !== 0)) {
    const T =
      i.isHorizontal() && p ? 'marginLeft' : i.getDirectionLabel('marginRight')
    l.filter((I, P) =>
      !t.cssMode || t.loop ? !0 : P !== l.length - 1
    ).forEach(I => {
      I.style[T] = `${m}px`
    })
  }
  if (t.centeredSlides && t.centeredSlidesBounds) {
    let T = 0
    ;(n.forEach(P => {
      T += P + (m || 0)
    }),
      (T -= m))
    const I = T > a ? T - a : 0
    w = w.map(P => (P <= 0 ? -o : P > I ? I + v : P))
  }
  if (t.centerInsufficientSlides) {
    let T = 0
    ;(n.forEach(P => {
      T += P + (m || 0)
    }),
      (T -= m))
    const I = (t.slidesOffsetBefore || 0) + (t.slidesOffsetAfter || 0)
    if (T + I < a) {
      const P = (a - T - I) / 2
      ;(w.forEach((C, A) => {
        w[A] = C - P
      }),
        h.forEach((C, A) => {
          h[A] = C + P
        }))
    }
  }
  if (
    (Object.assign(i, {
      slides: l,
      snapGrid: w,
      slidesGrid: h,
      slidesSizesGrid: n,
    }),
    t.centeredSlides && t.cssMode && !t.centeredSlidesBounds)
  ) {
    ;(Te(s, '--swiper-centered-offset-before', `${-w[0]}px`),
      Te(
        s,
        '--swiper-centered-offset-after',
        `${i.size / 2 - n[n.length - 1] / 2}px`
      ))
    const T = -i.snapGrid[0],
      I = -i.slidesGrid[0]
    ;((i.snapGrid = i.snapGrid.map(P => P + T)),
      (i.slidesGrid = i.slidesGrid.map(P => P + I)))
  }
  if (
    (u !== d && i.emit('slidesLengthChange'),
    w.length !== b &&
      (i.params.watchOverflow && i.checkOverflow(),
      i.emit('snapGridLengthChange')),
    h.length !== g && i.emit('slidesGridLengthChange'),
    t.watchSlidesProgress && i.updateSlidesOffset(),
    i.emit('slidesUpdated'),
    !f && !t.cssMode && (t.effect === 'slide' || t.effect === 'fade'))
  ) {
    const T = `${t.containerModifierClass}backface-hidden`,
      I = i.el.classList.contains(T)
    u <= t.maxBackfaceHiddenSlides
      ? I || i.el.classList.add(T)
      : I && i.el.classList.remove(T)
  }
}
function Vt(i) {
  const e = this,
    t = [],
    s = e.virtual && e.params.virtual.enabled
  let r = 0,
    a
  typeof i == 'number'
    ? e.setTransition(i)
    : i === !0 && e.setTransition(e.params.speed)
  const p = c => (s ? e.slides[e.getSlideIndexByData(c)] : e.slides[c])
  if (e.params.slidesPerView !== 'auto' && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach(c => {
        t.push(c)
      })
    else
      for (a = 0; a < Math.ceil(e.params.slidesPerView); a += 1) {
        const c = e.activeIndex + a
        if (c > e.slides.length && !s) break
        t.push(p(c))
      }
  else t.push(p(e.activeIndex))
  for (a = 0; a < t.length; a += 1)
    if (typeof t[a] < 'u') {
      const c = t[a].offsetHeight
      r = c > r ? c : r
    }
  ;(r || r === 0) && (e.wrapperEl.style.height = `${r}px`)
}
function Xt() {
  const i = this,
    e = i.slides,
    t = i.isElement
      ? i.isHorizontal()
        ? i.wrapperEl.offsetLeft
        : i.wrapperEl.offsetTop
      : 0
  for (let s = 0; s < e.length; s += 1)
    e[s].swiperSlideOffset =
      (i.isHorizontal() ? e[s].offsetLeft : e[s].offsetTop) -
      t -
      i.cssOverflowAdjustment()
}
const nt = (i, e, t) => {
  e && !i.classList.contains(t)
    ? i.classList.add(t)
    : !e && i.classList.contains(t) && i.classList.remove(t)
}
function Yt(i) {
  i === void 0 && (i = (this && this.translate) || 0)
  const e = this,
    t = e.params,
    { slides: s, rtlTranslate: r, snapGrid: a } = e
  if (s.length === 0) return
  typeof s[0].swiperSlideOffset > 'u' && e.updateSlidesOffset()
  let p = -i
  ;(r && (p = i), (e.visibleSlidesIndexes = []), (e.visibleSlides = []))
  let c = t.spaceBetween
  typeof c == 'string' && c.indexOf('%') >= 0
    ? (c = (parseFloat(c.replace('%', '')) / 100) * e.size)
    : typeof c == 'string' && (c = parseFloat(c))
  for (let f = 0; f < s.length; f += 1) {
    const d = s[f]
    let l = d.swiperSlideOffset
    t.cssMode && t.centeredSlides && (l -= s[0].swiperSlideOffset)
    const u =
        (p + (t.centeredSlides ? e.minTranslate() : 0) - l) /
        (d.swiperSlideSize + c),
      w =
        (p - a[0] + (t.centeredSlides ? e.minTranslate() : 0) - l) /
        (d.swiperSlideSize + c),
      h = -(p - l),
      n = h + e.slidesSizesGrid[f],
      o = h >= 0 && h <= e.size - e.slidesSizesGrid[f],
      v =
        (h >= 0 && h < e.size - 1) ||
        (n > 1 && n <= e.size) ||
        (h <= 0 && n >= e.size)
    ;(v && (e.visibleSlides.push(d), e.visibleSlidesIndexes.push(f)),
      nt(d, v, t.slideVisibleClass),
      nt(d, o, t.slideFullyVisibleClass),
      (d.progress = r ? -u : u),
      (d.originalProgress = r ? -w : w))
  }
}
function Nt(i) {
  const e = this
  if (typeof i > 'u') {
    const l = e.rtlTranslate ? -1 : 1
    i = (e && e.translate && e.translate * l) || 0
  }
  const t = e.params,
    s = e.maxTranslate() - e.minTranslate()
  let { progress: r, isBeginning: a, isEnd: p, progressLoop: c } = e
  const f = a,
    d = p
  if (s === 0) ((r = 0), (a = !0), (p = !0))
  else {
    r = (i - e.minTranslate()) / s
    const l = Math.abs(i - e.minTranslate()) < 1,
      u = Math.abs(i - e.maxTranslate()) < 1
    ;((a = l || r <= 0), (p = u || r >= 1), l && (r = 0), u && (r = 1))
  }
  if (t.loop) {
    const l = e.getSlideIndexByData(0),
      u = e.getSlideIndexByData(e.slides.length - 1),
      w = e.slidesGrid[l],
      h = e.slidesGrid[u],
      n = e.slidesGrid[e.slidesGrid.length - 1],
      o = Math.abs(i)
    ;(o >= w ? (c = (o - w) / n) : (c = (o + n - h) / n), c > 1 && (c -= 1))
  }
  ;(Object.assign(e, {
    progress: r,
    progressLoop: c,
    isBeginning: a,
    isEnd: p,
  }),
    (t.watchSlidesProgress || (t.centeredSlides && t.autoHeight)) &&
      e.updateSlidesProgress(i),
    a && !f && e.emit('reachBeginning toEdge'),
    p && !d && e.emit('reachEnd toEdge'),
    ((f && !a) || (d && !p)) && e.emit('fromEdge'),
    e.emit('progress', r))
}
const We = (i, e, t) => {
  e && !i.classList.contains(t)
    ? i.classList.add(t)
    : !e && i.classList.contains(t) && i.classList.remove(t)
}
function Ft() {
  const i = this,
    { slides: e, params: t, slidesEl: s, activeIndex: r } = i,
    a = i.virtual && t.virtual.enabled,
    p = i.grid && t.grid && t.grid.rows > 1,
    c = u => j(s, `.${t.slideClass}${u}, swiper-slide${u}`)[0]
  let f, d, l
  if (a)
    if (t.loop) {
      let u = r - i.virtual.slidesBefore
      ;(u < 0 && (u = i.virtual.slides.length + u),
        u >= i.virtual.slides.length && (u -= i.virtual.slides.length),
        (f = c(`[data-swiper-slide-index="${u}"]`)))
    } else f = c(`[data-swiper-slide-index="${r}"]`)
  else
    p
      ? ((f = e.find(u => u.column === r)),
        (l = e.find(u => u.column === r + 1)),
        (d = e.find(u => u.column === r - 1)))
      : (f = e[r])
  ;(f &&
    (p ||
      ((l = Ot(f, `.${t.slideClass}, swiper-slide`)[0]),
      t.loop && !l && (l = e[0]),
      (d = At(f, `.${t.slideClass}, swiper-slide`)[0]),
      t.loop && !d === 0 && (d = e[e.length - 1]))),
    e.forEach(u => {
      ;(We(u, u === f, t.slideActiveClass),
        We(u, u === l, t.slideNextClass),
        We(u, u === d, t.slidePrevClass))
    }),
    i.emitSlidesClasses())
}
const Ae = (i, e) => {
    if (!i || i.destroyed || !i.params) return
    const t = () => (i.isElement ? 'swiper-slide' : `.${i.params.slideClass}`),
      s = e.closest(t())
    if (s) {
      let r = s.querySelector(`.${i.params.lazyPreloaderClass}`)
      ;(!r &&
        i.isElement &&
        (s.shadowRoot
          ? (r = s.shadowRoot.querySelector(`.${i.params.lazyPreloaderClass}`))
          : requestAnimationFrame(() => {
              s.shadowRoot &&
                ((r = s.shadowRoot.querySelector(
                  `.${i.params.lazyPreloaderClass}`
                )),
                r && r.remove())
            })),
        r && r.remove())
    }
  },
  je = (i, e) => {
    if (!i.slides[e]) return
    const t = i.slides[e].querySelector('[loading="lazy"]')
    t && t.removeAttribute('loading')
  },
  Je = i => {
    if (!i || i.destroyed || !i.params) return
    let e = i.params.lazyPreloadPrevNext
    const t = i.slides.length
    if (!t || !e || e < 0) return
    e = Math.min(e, t)
    const s =
        i.params.slidesPerView === 'auto'
          ? i.slidesPerViewDynamic()
          : Math.ceil(i.params.slidesPerView),
      r = i.activeIndex
    if (i.params.grid && i.params.grid.rows > 1) {
      const p = r,
        c = [p - e]
      ;(c.push(...Array.from({ length: e }).map((f, d) => p + s + d)),
        i.slides.forEach((f, d) => {
          c.includes(f.column) && je(i, d)
        }))
      return
    }
    const a = r + s - 1
    if (i.params.rewind || i.params.loop)
      for (let p = r - e; p <= a + e; p += 1) {
        const c = ((p % t) + t) % t
        ;(c < r || c > a) && je(i, c)
      }
    else
      for (let p = Math.max(r - e, 0); p <= Math.min(a + e, t - 1); p += 1)
        p !== r && (p > a || p < r) && je(i, p)
  }
function Wt(i) {
  const { slidesGrid: e, params: t } = i,
    s = i.rtlTranslate ? i.translate : -i.translate
  let r
  for (let a = 0; a < e.length; a += 1)
    typeof e[a + 1] < 'u'
      ? s >= e[a] && s < e[a + 1] - (e[a + 1] - e[a]) / 2
        ? (r = a)
        : s >= e[a] && s < e[a + 1] && (r = a + 1)
      : s >= e[a] && (r = a)
  return (t.normalizeSlideIndex && (r < 0 || typeof r > 'u') && (r = 0), r)
}
function jt(i) {
  const e = this,
    t = e.rtlTranslate ? e.translate : -e.translate,
    { snapGrid: s, params: r, activeIndex: a, realIndex: p, snapIndex: c } = e
  let f = i,
    d
  const l = h => {
    let n = h - e.virtual.slidesBefore
    return (
      n < 0 && (n = e.virtual.slides.length + n),
      n >= e.virtual.slides.length && (n -= e.virtual.slides.length),
      n
    )
  }
  if ((typeof f > 'u' && (f = Wt(e)), s.indexOf(t) >= 0)) d = s.indexOf(t)
  else {
    const h = Math.min(r.slidesPerGroupSkip, f)
    d = h + Math.floor((f - h) / r.slidesPerGroup)
  }
  if ((d >= s.length && (d = s.length - 1), f === a && !e.params.loop)) {
    d !== c && ((e.snapIndex = d), e.emit('snapIndexChange'))
    return
  }
  if (f === a && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = l(f)
    return
  }
  const u = e.grid && r.grid && r.grid.rows > 1
  let w
  if (e.virtual && r.virtual.enabled && r.loop) w = l(f)
  else if (u) {
    const h = e.slides.find(o => o.column === f)
    let n = parseInt(h.getAttribute('data-swiper-slide-index'), 10)
    ;(Number.isNaN(n) && (n = Math.max(e.slides.indexOf(h), 0)),
      (w = Math.floor(n / r.grid.rows)))
  } else if (e.slides[f]) {
    const h = e.slides[f].getAttribute('data-swiper-slide-index')
    h ? (w = parseInt(h, 10)) : (w = f)
  } else w = f
  ;(Object.assign(e, {
    previousSnapIndex: c,
    snapIndex: d,
    previousRealIndex: p,
    realIndex: w,
    previousIndex: a,
    activeIndex: f,
  }),
    e.initialized && Je(e),
    e.emit('activeIndexChange'),
    e.emit('snapIndexChange'),
    (e.initialized || e.params.runCallbacksOnInit) &&
      (p !== w && e.emit('realIndexChange'), e.emit('slideChange')))
}
function qt(i, e) {
  const t = this,
    s = t.params
  let r = i.closest(`.${s.slideClass}, swiper-slide`)
  !r &&
    t.isElement &&
    e &&
    e.length > 1 &&
    e.includes(i) &&
    [...e.slice(e.indexOf(i) + 1, e.length)].forEach(c => {
      !r && c.matches && c.matches(`.${s.slideClass}, swiper-slide`) && (r = c)
    })
  let a = !1,
    p
  if (r) {
    for (let c = 0; c < t.slides.length; c += 1)
      if (t.slides[c] === r) {
        ;((a = !0), (p = c))
        break
      }
  }
  if (r && a)
    ((t.clickedSlide = r),
      t.virtual && t.params.virtual.enabled
        ? (t.clickedIndex = parseInt(
            r.getAttribute('data-swiper-slide-index'),
            10
          ))
        : (t.clickedIndex = p))
  else {
    ;((t.clickedSlide = void 0), (t.clickedIndex = void 0))
    return
  }
  s.slideToClickedSlide &&
    t.clickedIndex !== void 0 &&
    t.clickedIndex !== t.activeIndex &&
    t.slideToClickedSlide()
}
var Ut = {
  updateSize: Gt,
  updateSlides: Ht,
  updateAutoHeight: Vt,
  updateSlidesOffset: Xt,
  updateSlidesProgress: Yt,
  updateProgress: Nt,
  updateSlidesClasses: Ft,
  updateActiveIndex: jt,
  updateClickedSlide: qt,
}
function Kt(i) {
  i === void 0 && (i = this.isHorizontal() ? 'x' : 'y')
  const e = this,
    { params: t, rtlTranslate: s, translate: r, wrapperEl: a } = e
  if (t.virtualTranslate) return s ? -r : r
  if (t.cssMode) return r
  let p = Ze(a, i)
  return ((p += e.cssOverflowAdjustment()), s && (p = -p), p || 0)
}
function Zt(i, e) {
  const t = this,
    { rtlTranslate: s, params: r, wrapperEl: a, progress: p } = t
  let c = 0,
    f = 0
  const d = 0
  ;(t.isHorizontal() ? (c = s ? -i : i) : (f = i),
    r.roundLengths && ((c = Math.floor(c)), (f = Math.floor(f))),
    (t.previousTranslate = t.translate),
    (t.translate = t.isHorizontal() ? c : f),
    r.cssMode
      ? (a[t.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = t.isHorizontal()
          ? -c
          : -f)
      : r.virtualTranslate ||
        (t.isHorizontal()
          ? (c -= t.cssOverflowAdjustment())
          : (f -= t.cssOverflowAdjustment()),
        (a.style.transform = `translate3d(${c}px, ${f}px, ${d}px)`)))
  let l
  const u = t.maxTranslate() - t.minTranslate()
  ;(u === 0 ? (l = 0) : (l = (i - t.minTranslate()) / u),
    l !== p && t.updateProgress(i),
    t.emit('setTranslate', t.translate, e))
}
function Qt() {
  return -this.snapGrid[0]
}
function Jt() {
  return -this.snapGrid[this.snapGrid.length - 1]
}
function ei(i, e, t, s, r) {
  ;(i === void 0 && (i = 0),
    e === void 0 && (e = this.params.speed),
    t === void 0 && (t = !0),
    s === void 0 && (s = !0))
  const a = this,
    { params: p, wrapperEl: c } = a
  if (a.animating && p.preventInteractionOnTransition) return !1
  const f = a.minTranslate(),
    d = a.maxTranslate()
  let l
  if (
    (s && i > f ? (l = f) : s && i < d ? (l = d) : (l = i),
    a.updateProgress(l),
    p.cssMode)
  ) {
    const u = a.isHorizontal()
    if (e === 0) c[u ? 'scrollLeft' : 'scrollTop'] = -l
    else {
      if (!a.support.smoothScroll)
        return (
          gt({ swiper: a, targetPosition: -l, side: u ? 'left' : 'top' }),
          !0
        )
      c.scrollTo({ [u ? 'left' : 'top']: -l, behavior: 'smooth' })
    }
    return !0
  }
  return (
    e === 0
      ? (a.setTransition(0),
        a.setTranslate(l),
        t && (a.emit('beforeTransitionStart', e, r), a.emit('transitionEnd')))
      : (a.setTransition(e),
        a.setTranslate(l),
        t && (a.emit('beforeTransitionStart', e, r), a.emit('transitionStart')),
        a.animating ||
          ((a.animating = !0),
          a.onTranslateToWrapperTransitionEnd ||
            (a.onTranslateToWrapperTransitionEnd = function (w) {
              !a ||
                a.destroyed ||
                (w.target === this &&
                  (a.wrapperEl.removeEventListener(
                    'transitionend',
                    a.onTranslateToWrapperTransitionEnd
                  ),
                  (a.onTranslateToWrapperTransitionEnd = null),
                  delete a.onTranslateToWrapperTransitionEnd,
                  (a.animating = !1),
                  t && a.emit('transitionEnd')))
            }),
          a.wrapperEl.addEventListener(
            'transitionend',
            a.onTranslateToWrapperTransitionEnd
          ))),
    !0
  )
}
var ti = {
  getTranslate: Kt,
  setTranslate: Zt,
  minTranslate: Qt,
  maxTranslate: Jt,
  translateTo: ei,
}
function ii(i, e) {
  const t = this
  ;(t.params.cssMode ||
    ((t.wrapperEl.style.transitionDuration = `${i}ms`),
    (t.wrapperEl.style.transitionDelay = i === 0 ? '0ms' : '')),
    t.emit('setTransition', i, e))
}
function yt(i) {
  let { swiper: e, runCallbacks: t, direction: s, step: r } = i
  const { activeIndex: a, previousIndex: p } = e
  let c = s
  ;(c || (a > p ? (c = 'next') : a < p ? (c = 'prev') : (c = 'reset')),
    e.emit(`transition${r}`),
    t && c === 'reset'
      ? e.emit(`slideResetTransition${r}`)
      : t &&
        a !== p &&
        (e.emit(`slideChangeTransition${r}`),
        c === 'next'
          ? e.emit(`slideNextTransition${r}`)
          : e.emit(`slidePrevTransition${r}`)))
}
function si(i, e) {
  i === void 0 && (i = !0)
  const t = this,
    { params: s } = t
  s.cssMode ||
    (s.autoHeight && t.updateAutoHeight(),
    yt({ swiper: t, runCallbacks: i, direction: e, step: 'Start' }))
}
function ri(i, e) {
  i === void 0 && (i = !0)
  const t = this,
    { params: s } = t
  ;((t.animating = !1),
    !s.cssMode &&
      (t.setTransition(0),
      yt({ swiper: t, runCallbacks: i, direction: e, step: 'End' })))
}
var ai = { setTransition: ii, transitionStart: si, transitionEnd: ri }
function ni(i, e, t, s, r) {
  ;(i === void 0 && (i = 0),
    t === void 0 && (t = !0),
    typeof i == 'string' && (i = parseInt(i, 10)))
  const a = this
  let p = i
  p < 0 && (p = 0)
  const {
    params: c,
    snapGrid: f,
    slidesGrid: d,
    previousIndex: l,
    activeIndex: u,
    rtlTranslate: w,
    wrapperEl: h,
    enabled: n,
  } = a
  if (
    (!n && !s && !r) ||
    a.destroyed ||
    (a.animating && c.preventInteractionOnTransition)
  )
    return !1
  typeof e > 'u' && (e = a.params.speed)
  const o = Math.min(a.params.slidesPerGroupSkip, p)
  let v = o + Math.floor((p - o) / a.params.slidesPerGroup)
  v >= f.length && (v = f.length - 1)
  const b = -f[v]
  if (c.normalizeSlideIndex)
    for (let L = 0; L < d.length; L += 1) {
      const z = -Math.floor(b * 100),
        S = Math.floor(d[L] * 100),
        T = Math.floor(d[L + 1] * 100)
      typeof d[L + 1] < 'u'
        ? z >= S && z < T - (T - S) / 2
          ? (p = L)
          : z >= S && z < T && (p = L + 1)
        : z >= S && (p = L)
    }
  if (
    a.initialized &&
    p !== u &&
    ((!a.allowSlideNext &&
      (w
        ? b > a.translate && b > a.minTranslate()
        : b < a.translate && b < a.minTranslate())) ||
      (!a.allowSlidePrev &&
        b > a.translate &&
        b > a.maxTranslate() &&
        (u || 0) !== p))
  )
    return !1
  ;(p !== (l || 0) && t && a.emit('beforeSlideChangeStart'),
    a.updateProgress(b))
  let g
  p > u ? (g = 'next') : p < u ? (g = 'prev') : (g = 'reset')
  const m = a.virtual && a.params.virtual.enabled
  if (!(m && r) && ((w && -b === a.translate) || (!w && b === a.translate)))
    return (
      a.updateActiveIndex(p),
      c.autoHeight && a.updateAutoHeight(),
      a.updateSlidesClasses(),
      c.effect !== 'slide' && a.setTranslate(b),
      g !== 'reset' && (a.transitionStart(t, g), a.transitionEnd(t, g)),
      !1
    )
  if (c.cssMode) {
    const L = a.isHorizontal(),
      z = w ? b : -b
    if (e === 0)
      (m &&
        ((a.wrapperEl.style.scrollSnapType = 'none'),
        (a._immediateVirtual = !0)),
        m && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0
          ? ((a._cssModeVirtualInitialSet = !0),
            requestAnimationFrame(() => {
              h[L ? 'scrollLeft' : 'scrollTop'] = z
            }))
          : (h[L ? 'scrollLeft' : 'scrollTop'] = z),
        m &&
          requestAnimationFrame(() => {
            ;((a.wrapperEl.style.scrollSnapType = ''),
              (a._immediateVirtual = !1))
          }))
    else {
      if (!a.support.smoothScroll)
        return (
          gt({ swiper: a, targetPosition: z, side: L ? 'left' : 'top' }),
          !0
        )
      h.scrollTo({ [L ? 'left' : 'top']: z, behavior: 'smooth' })
    }
    return !0
  }
  const O = bt().isSafari
  return (
    m && !r && O && a.isElement && a.virtual.update(!1, !1, p),
    a.setTransition(e),
    a.setTranslate(b),
    a.updateActiveIndex(p),
    a.updateSlidesClasses(),
    a.emit('beforeTransitionStart', e, s),
    a.transitionStart(t, g),
    e === 0
      ? a.transitionEnd(t, g)
      : a.animating ||
        ((a.animating = !0),
        a.onSlideToWrapperTransitionEnd ||
          (a.onSlideToWrapperTransitionEnd = function (z) {
            !a ||
              a.destroyed ||
              (z.target === this &&
                (a.wrapperEl.removeEventListener(
                  'transitionend',
                  a.onSlideToWrapperTransitionEnd
                ),
                (a.onSlideToWrapperTransitionEnd = null),
                delete a.onSlideToWrapperTransitionEnd,
                a.transitionEnd(t, g)))
          }),
        a.wrapperEl.addEventListener(
          'transitionend',
          a.onSlideToWrapperTransitionEnd
        )),
    !0
  )
}
function oi(i, e, t, s) {
  ;(i === void 0 && (i = 0),
    t === void 0 && (t = !0),
    typeof i == 'string' && (i = parseInt(i, 10)))
  const r = this
  if (r.destroyed) return
  typeof e > 'u' && (e = r.params.speed)
  const a = r.grid && r.params.grid && r.params.grid.rows > 1
  let p = i
  if (r.params.loop)
    if (r.virtual && r.params.virtual.enabled) p = p + r.virtual.slidesBefore
    else {
      let c
      if (a) {
        const w = p * r.params.grid.rows
        c = r.slides.find(
          h => h.getAttribute('data-swiper-slide-index') * 1 === w
        ).column
      } else c = r.getSlideIndexByData(p)
      const f = a
          ? Math.ceil(r.slides.length / r.params.grid.rows)
          : r.slides.length,
        { centeredSlides: d } = r.params
      let l = r.params.slidesPerView
      l === 'auto'
        ? (l = r.slidesPerViewDynamic())
        : ((l = Math.ceil(parseFloat(r.params.slidesPerView, 10))),
          d && l % 2 === 0 && (l = l + 1))
      let u = f - c < l
      if (
        (d && (u = u || c < Math.ceil(l / 2)),
        s && d && r.params.slidesPerView !== 'auto' && !a && (u = !1),
        u)
      ) {
        const w = d
          ? c < r.activeIndex
            ? 'prev'
            : 'next'
          : c - r.activeIndex - 1 < r.params.slidesPerView
            ? 'next'
            : 'prev'
        r.loopFix({
          direction: w,
          slideTo: !0,
          activeSlideIndex: w === 'next' ? c + 1 : c - f + 1,
          slideRealIndex: w === 'next' ? r.realIndex : void 0,
        })
      }
      if (a) {
        const w = p * r.params.grid.rows
        p = r.slides.find(
          h => h.getAttribute('data-swiper-slide-index') * 1 === w
        ).column
      } else p = r.getSlideIndexByData(p)
    }
  return (
    requestAnimationFrame(() => {
      r.slideTo(p, e, t, s)
    }),
    r
  )
}
function li(i, e, t) {
  e === void 0 && (e = !0)
  const s = this,
    { enabled: r, params: a, animating: p } = s
  if (!r || s.destroyed) return s
  typeof i > 'u' && (i = s.params.speed)
  let c = a.slidesPerGroup
  a.slidesPerView === 'auto' &&
    a.slidesPerGroup === 1 &&
    a.slidesPerGroupAuto &&
    (c = Math.max(s.slidesPerViewDynamic('current', !0), 1))
  const f = s.activeIndex < a.slidesPerGroupSkip ? 1 : c,
    d = s.virtual && a.virtual.enabled
  if (a.loop) {
    if (p && !d && a.loopPreventsSliding) return !1
    if (
      (s.loopFix({ direction: 'next' }),
      (s._clientLeft = s.wrapperEl.clientLeft),
      s.activeIndex === s.slides.length - 1 && a.cssMode)
    )
      return (
        requestAnimationFrame(() => {
          s.slideTo(s.activeIndex + f, i, e, t)
        }),
        !0
      )
  }
  return a.rewind && s.isEnd
    ? s.slideTo(0, i, e, t)
    : s.slideTo(s.activeIndex + f, i, e, t)
}
function di(i, e, t) {
  e === void 0 && (e = !0)
  const s = this,
    {
      params: r,
      snapGrid: a,
      slidesGrid: p,
      rtlTranslate: c,
      enabled: f,
      animating: d,
    } = s
  if (!f || s.destroyed) return s
  typeof i > 'u' && (i = s.params.speed)
  const l = s.virtual && r.virtual.enabled
  if (r.loop) {
    if (d && !l && r.loopPreventsSliding) return !1
    ;(s.loopFix({ direction: 'prev' }),
      (s._clientLeft = s.wrapperEl.clientLeft))
  }
  const u = c ? s.translate : -s.translate
  function w(g) {
    return g < 0 ? -Math.floor(Math.abs(g)) : Math.floor(g)
  }
  const h = w(u),
    n = a.map(g => w(g)),
    o = r.freeMode && r.freeMode.enabled
  let v = a[n.indexOf(h) - 1]
  if (typeof v > 'u' && (r.cssMode || o)) {
    let g
    ;(a.forEach((m, y) => {
      h >= m && (g = y)
    }),
      typeof g < 'u' && (v = o ? a[g] : a[g > 0 ? g - 1 : g]))
  }
  let b = 0
  if (
    (typeof v < 'u' &&
      ((b = p.indexOf(v)),
      b < 0 && (b = s.activeIndex - 1),
      r.slidesPerView === 'auto' &&
        r.slidesPerGroup === 1 &&
        r.slidesPerGroupAuto &&
        ((b = b - s.slidesPerViewDynamic('previous', !0) + 1),
        (b = Math.max(b, 0)))),
    r.rewind && s.isBeginning)
  ) {
    const g =
      s.params.virtual && s.params.virtual.enabled && s.virtual
        ? s.virtual.slides.length - 1
        : s.slides.length - 1
    return s.slideTo(g, i, e, t)
  } else if (r.loop && s.activeIndex === 0 && r.cssMode)
    return (
      requestAnimationFrame(() => {
        s.slideTo(b, i, e, t)
      }),
      !0
    )
  return s.slideTo(b, i, e, t)
}
function ci(i, e, t) {
  e === void 0 && (e = !0)
  const s = this
  if (!s.destroyed)
    return (
      typeof i > 'u' && (i = s.params.speed),
      s.slideTo(s.activeIndex, i, e, t)
    )
}
function pi(i, e, t, s) {
  ;(e === void 0 && (e = !0), s === void 0 && (s = 0.5))
  const r = this
  if (r.destroyed) return
  typeof i > 'u' && (i = r.params.speed)
  let a = r.activeIndex
  const p = Math.min(r.params.slidesPerGroupSkip, a),
    c = p + Math.floor((a - p) / r.params.slidesPerGroup),
    f = r.rtlTranslate ? r.translate : -r.translate
  if (f >= r.snapGrid[c]) {
    const d = r.snapGrid[c],
      l = r.snapGrid[c + 1]
    f - d > (l - d) * s && (a += r.params.slidesPerGroup)
  } else {
    const d = r.snapGrid[c - 1],
      l = r.snapGrid[c]
    f - d <= (l - d) * s && (a -= r.params.slidesPerGroup)
  }
  return (
    (a = Math.max(a, 0)),
    (a = Math.min(a, r.slidesGrid.length - 1)),
    r.slideTo(a, i, e, t)
  )
}
function fi() {
  const i = this
  if (i.destroyed) return
  const { params: e, slidesEl: t } = i,
    s = e.slidesPerView === 'auto' ? i.slidesPerViewDynamic() : e.slidesPerView
  let r = i.getSlideIndexWhenGrid(i.clickedIndex),
    a
  const p = i.isElement ? 'swiper-slide' : `.${e.slideClass}`,
    c = i.grid && i.params.grid && i.params.grid.rows > 1
  if (e.loop) {
    if (i.animating) return
    ;((a = parseInt(
      i.clickedSlide.getAttribute('data-swiper-slide-index'),
      10
    )),
      e.centeredSlides
        ? i.slideToLoop(a)
        : r >
            (c
              ? (i.slides.length - s) / 2 - (i.params.grid.rows - 1)
              : i.slides.length - s)
          ? (i.loopFix(),
            (r = i.getSlideIndex(
              j(t, `${p}[data-swiper-slide-index="${a}"]`)[0]
            )),
            ge(() => {
              i.slideTo(r)
            }))
          : i.slideTo(r))
  } else i.slideTo(r)
}
var ui = {
  slideTo: ni,
  slideToLoop: oi,
  slideNext: li,
  slidePrev: di,
  slideReset: ci,
  slideToClosest: pi,
  slideToClickedSlide: fi,
}
function mi(i, e) {
  const t = this,
    { params: s, slidesEl: r } = t
  if (!s.loop || (t.virtual && t.params.virtual.enabled)) return
  const a = () => {
      j(r, `.${s.slideClass}, swiper-slide`).forEach((h, n) => {
        h.setAttribute('data-swiper-slide-index', n)
      })
    },
    p = () => {
      const w = j(r, `.${s.slideBlankClass}`)
      ;(w.forEach(h => {
        h.remove()
      }),
        w.length > 0 && (t.recalcSlides(), t.updateSlides()))
    },
    c = t.grid && s.grid && s.grid.rows > 1
  s.loopAddBlankSlides && (s.slidesPerGroup > 1 || c) && p()
  const f = s.slidesPerGroup * (c ? s.grid.rows : 1),
    d = t.slides.length % f !== 0,
    l = c && t.slides.length % s.grid.rows !== 0,
    u = w => {
      for (let h = 0; h < w; h += 1) {
        const n = t.isElement
          ? Q('swiper-slide', [s.slideBlankClass])
          : Q('div', [s.slideClass, s.slideBlankClass])
        t.slidesEl.append(n)
      }
    }
  if (d) {
    if (s.loopAddBlankSlides) {
      const w = f - (t.slides.length % f)
      ;(u(w), t.recalcSlides(), t.updateSlides())
    } else
      De(
        'Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
      )
    a()
  } else if (l) {
    if (s.loopAddBlankSlides) {
      const w = s.grid.rows - (t.slides.length % s.grid.rows)
      ;(u(w), t.recalcSlides(), t.updateSlides())
    } else
      De(
        'Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
      )
    a()
  } else a()
  t.loopFix({
    slideRealIndex: i,
    direction: s.centeredSlides ? void 0 : 'next',
    initial: e,
  })
}
function hi(i) {
  let {
    slideRealIndex: e,
    slideTo: t = !0,
    direction: s,
    setTranslate: r,
    activeSlideIndex: a,
    initial: p,
    byController: c,
    byMousewheel: f,
  } = i === void 0 ? {} : i
  const d = this
  if (!d.params.loop) return
  d.emit('beforeLoopFix')
  const {
      slides: l,
      allowSlidePrev: u,
      allowSlideNext: w,
      slidesEl: h,
      params: n,
    } = d,
    { centeredSlides: o, initialSlide: v } = n
  if (
    ((d.allowSlidePrev = !0),
    (d.allowSlideNext = !0),
    d.virtual && n.virtual.enabled)
  ) {
    ;(t &&
      (!n.centeredSlides && d.snapIndex === 0
        ? d.slideTo(d.virtual.slides.length, 0, !1, !0)
        : n.centeredSlides && d.snapIndex < n.slidesPerView
          ? d.slideTo(d.virtual.slides.length + d.snapIndex, 0, !1, !0)
          : d.snapIndex === d.snapGrid.length - 1 &&
            d.slideTo(d.virtual.slidesBefore, 0, !1, !0)),
      (d.allowSlidePrev = u),
      (d.allowSlideNext = w),
      d.emit('loopFix'))
    return
  }
  let b = n.slidesPerView
  b === 'auto'
    ? (b = d.slidesPerViewDynamic())
    : ((b = Math.ceil(parseFloat(n.slidesPerView, 10))),
      o && b % 2 === 0 && (b = b + 1))
  const g = n.slidesPerGroupAuto ? b : n.slidesPerGroup
  let m = o ? Math.max(g, Math.ceil(b / 2)) : g
  ;(m % g !== 0 && (m += g - (m % g)),
    (m += n.loopAdditionalSlides),
    (d.loopedSlides = m))
  const y = d.grid && n.grid && n.grid.rows > 1
  l.length < b + m || (d.params.effect === 'cards' && l.length < b + m * 2)
    ? De(
        'Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters'
      )
    : y &&
      n.grid.fill === 'row' &&
      De(
        'Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`'
      )
  const x = [],
    O = [],
    L = y ? Math.ceil(l.length / n.grid.rows) : l.length,
    z = p && L - v < b && !o
  let S = z ? v : d.activeIndex
  typeof a > 'u'
    ? (a = d.getSlideIndex(
        l.find(k => k.classList.contains(n.slideActiveClass))
      ))
    : (S = a)
  const T = s === 'next' || !s,
    I = s === 'prev' || !s
  let P = 0,
    C = 0
  const $ = (y ? l[a].column : a) + (o && typeof r > 'u' ? -b / 2 + 0.5 : 0)
  if ($ < m) {
    P = Math.max(m - $, g)
    for (let k = 0; k < m - $; k += 1) {
      const E = k - Math.floor(k / L) * L
      if (y) {
        const M = L - E - 1
        for (let B = l.length - 1; B >= 0; B -= 1)
          l[B].column === M && x.push(B)
      } else x.push(L - E - 1)
    }
  } else if ($ + b > L - m) {
    ;((C = Math.max($ - (L - m * 2), g)), z && (C = Math.max(C, b - L + v + 1)))
    for (let k = 0; k < C; k += 1) {
      const E = k - Math.floor(k / L) * L
      y
        ? l.forEach((M, B) => {
            M.column === E && O.push(B)
          })
        : O.push(E)
    }
  }
  if (
    ((d.__preventObserver__ = !0),
    requestAnimationFrame(() => {
      d.__preventObserver__ = !1
    }),
    d.params.effect === 'cards' &&
      l.length < b + m * 2 &&
      (O.includes(a) && O.splice(O.indexOf(a), 1),
      x.includes(a) && x.splice(x.indexOf(a), 1)),
    I &&
      x.forEach(k => {
        ;((l[k].swiperLoopMoveDOM = !0),
          h.prepend(l[k]),
          (l[k].swiperLoopMoveDOM = !1))
      }),
    T &&
      O.forEach(k => {
        ;((l[k].swiperLoopMoveDOM = !0),
          h.append(l[k]),
          (l[k].swiperLoopMoveDOM = !1))
      }),
    d.recalcSlides(),
    n.slidesPerView === 'auto'
      ? d.updateSlides()
      : y &&
        ((x.length > 0 && I) || (O.length > 0 && T)) &&
        d.slides.forEach((k, E) => {
          d.grid.updateSlide(E, k, d.slides)
        }),
    n.watchSlidesProgress && d.updateSlidesOffset(),
    t)
  ) {
    if (x.length > 0 && I) {
      if (typeof e > 'u') {
        const k = d.slidesGrid[S],
          M = d.slidesGrid[S + P] - k
        f
          ? d.setTranslate(d.translate - M)
          : (d.slideTo(S + Math.ceil(P), 0, !1, !0),
            r &&
              ((d.touchEventsData.startTranslate =
                d.touchEventsData.startTranslate - M),
              (d.touchEventsData.currentTranslate =
                d.touchEventsData.currentTranslate - M)))
      } else if (r) {
        const k = y ? x.length / n.grid.rows : x.length
        ;(d.slideTo(d.activeIndex + k, 0, !1, !0),
          (d.touchEventsData.currentTranslate = d.translate))
      }
    } else if (O.length > 0 && T)
      if (typeof e > 'u') {
        const k = d.slidesGrid[S],
          M = d.slidesGrid[S - C] - k
        f
          ? d.setTranslate(d.translate - M)
          : (d.slideTo(S - C, 0, !1, !0),
            r &&
              ((d.touchEventsData.startTranslate =
                d.touchEventsData.startTranslate - M),
              (d.touchEventsData.currentTranslate =
                d.touchEventsData.currentTranslate - M)))
      } else {
        const k = y ? O.length / n.grid.rows : O.length
        d.slideTo(d.activeIndex - k, 0, !1, !0)
      }
  }
  if (
    ((d.allowSlidePrev = u),
    (d.allowSlideNext = w),
    d.controller && d.controller.control && !c)
  ) {
    const k = {
      slideRealIndex: e,
      direction: s,
      setTranslate: r,
      activeSlideIndex: a,
      byController: !0,
    }
    Array.isArray(d.controller.control)
      ? d.controller.control.forEach(E => {
          !E.destroyed &&
            E.params.loop &&
            E.loopFix({
              ...k,
              slideTo: E.params.slidesPerView === n.slidesPerView ? t : !1,
            })
        })
      : d.controller.control instanceof d.constructor &&
        d.controller.control.params.loop &&
        d.controller.control.loopFix({
          ...k,
          slideTo:
            d.controller.control.params.slidesPerView === n.slidesPerView
              ? t
              : !1,
        })
  }
  d.emit('loopFix')
}
function gi() {
  const i = this,
    { params: e, slidesEl: t } = i
  if (!e.loop || !t || (i.virtual && i.params.virtual.enabled)) return
  i.recalcSlides()
  const s = []
  ;(i.slides.forEach(r => {
    const a =
      typeof r.swiperSlideIndex > 'u'
        ? r.getAttribute('data-swiper-slide-index') * 1
        : r.swiperSlideIndex
    s[a] = r
  }),
    i.slides.forEach(r => {
      r.removeAttribute('data-swiper-slide-index')
    }),
    s.forEach(r => {
      t.append(r)
    }),
    i.recalcSlides(),
    i.slideTo(i.realIndex, 0))
}
var wi = { loopCreate: mi, loopFix: hi, loopDestroy: gi }
function vi(i) {
  const e = this
  if (
    !e.params.simulateTouch ||
    (e.params.watchOverflow && e.isLocked) ||
    e.params.cssMode
  )
    return
  const t = e.params.touchEventsTarget === 'container' ? e.el : e.wrapperEl
  ;(e.isElement && (e.__preventObserver__ = !0),
    (t.style.cursor = 'move'),
    (t.style.cursor = i ? 'grabbing' : 'grab'),
    e.isElement &&
      requestAnimationFrame(() => {
        e.__preventObserver__ = !1
      }))
}
function bi() {
  const i = this
  ;(i.params.watchOverflow && i.isLocked) ||
    i.params.cssMode ||
    (i.isElement && (i.__preventObserver__ = !0),
    (i[
      i.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'
    ].style.cursor = ''),
    i.isElement &&
      requestAnimationFrame(() => {
        i.__preventObserver__ = !1
      }))
}
var yi = { setGrabCursor: vi, unsetGrabCursor: bi }
function Si(i, e) {
  e === void 0 && (e = this)
  function t(s) {
    if (!s || s === W() || s === X()) return null
    s.assignedSlot && (s = s.assignedSlot)
    const r = s.closest(i)
    return !r && !s.getRootNode ? null : r || t(s.getRootNode().host)
  }
  return t(e)
}
function ot(i, e, t) {
  const s = X(),
    { params: r } = i,
    a = r.edgeSwipeDetection,
    p = r.edgeSwipeThreshold
  return a && (t <= p || t >= s.innerWidth - p)
    ? a === 'prevent'
      ? (e.preventDefault(), !0)
      : !1
    : !0
}
function Ei(i) {
  const e = this,
    t = W()
  let s = i
  s.originalEvent && (s = s.originalEvent)
  const r = e.touchEventsData
  if (s.type === 'pointerdown') {
    if (r.pointerId !== null && r.pointerId !== s.pointerId) return
    r.pointerId = s.pointerId
  } else
    s.type === 'touchstart' &&
      s.targetTouches.length === 1 &&
      (r.touchId = s.targetTouches[0].identifier)
  if (s.type === 'touchstart') {
    ot(e, s, s.targetTouches[0].pageX)
    return
  }
  const { params: a, touches: p, enabled: c } = e
  if (
    !c ||
    (!a.simulateTouch && s.pointerType === 'mouse') ||
    (e.animating && a.preventInteractionOnTransition)
  )
    return
  !e.animating && a.cssMode && a.loop && e.loopFix()
  let f = s.target
  if (
    (a.touchEventsTarget === 'wrapper' && !It(f, e.wrapperEl)) ||
    ('which' in s && s.which === 3) ||
    ('button' in s && s.button > 0) ||
    (r.isTouched && r.isMoved)
  )
    return
  const d = !!a.noSwipingClass && a.noSwipingClass !== '',
    l = s.composedPath ? s.composedPath() : s.path
  d && s.target && s.target.shadowRoot && l && (f = l[0])
  const u = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`,
    w = !!(s.target && s.target.shadowRoot)
  if (a.noSwiping && (w ? Si(u, f) : f.closest(u))) {
    e.allowClick = !0
    return
  }
  if (a.swipeHandler && !f.closest(a.swipeHandler)) return
  ;((p.currentX = s.pageX), (p.currentY = s.pageY))
  const h = p.currentX,
    n = p.currentY
  if (!ot(e, s, h)) return
  ;(Object.assign(r, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0,
  }),
    (p.startX = h),
    (p.startY = n),
    (r.touchStartTime = J()),
    (e.allowClick = !0),
    e.updateSize(),
    (e.swipeDirection = void 0),
    a.threshold > 0 && (r.allowThresholdMove = !1))
  let o = !0
  ;(f.matches(r.focusableElements) &&
    ((o = !1), f.nodeName === 'SELECT' && (r.isTouched = !1)),
    t.activeElement &&
      t.activeElement.matches(r.focusableElements) &&
      t.activeElement !== f &&
      (s.pointerType === 'mouse' ||
        (s.pointerType !== 'mouse' && !f.matches(r.focusableElements))) &&
      t.activeElement.blur())
  const v = o && e.allowTouchMove && a.touchStartPreventDefault
  ;((a.touchStartForcePreventDefault || v) &&
    !f.isContentEditable &&
    s.preventDefault(),
    a.freeMode &&
      a.freeMode.enabled &&
      e.freeMode &&
      e.animating &&
      !a.cssMode &&
      e.freeMode.onTouchStart(),
    e.emit('touchStart', s))
}
function xi(i) {
  const e = W(),
    t = this,
    s = t.touchEventsData,
    { params: r, touches: a, rtlTranslate: p, enabled: c } = t
  if (!c || (!r.simulateTouch && i.pointerType === 'mouse')) return
  let f = i
  if (
    (f.originalEvent && (f = f.originalEvent),
    f.type === 'pointermove' &&
      (s.touchId !== null || f.pointerId !== s.pointerId))
  )
    return
  let d
  if (f.type === 'touchmove') {
    if (
      ((d = [...f.changedTouches].find(x => x.identifier === s.touchId)),
      !d || d.identifier !== s.touchId)
    )
      return
  } else d = f
  if (!s.isTouched) {
    s.startMoving && s.isScrolling && t.emit('touchMoveOpposite', f)
    return
  }
  const l = d.pageX,
    u = d.pageY
  if (f.preventedByNestedSwiper) {
    ;((a.startX = l), (a.startY = u))
    return
  }
  if (!t.allowTouchMove) {
    ;(f.target.matches(s.focusableElements) || (t.allowClick = !1),
      s.isTouched &&
        (Object.assign(a, { startX: l, startY: u, currentX: l, currentY: u }),
        (s.touchStartTime = J())))
    return
  }
  if (r.touchReleaseOnEdges && !r.loop)
    if (t.isVertical()) {
      if (
        (u < a.startY && t.translate <= t.maxTranslate()) ||
        (u > a.startY && t.translate >= t.minTranslate())
      ) {
        ;((s.isTouched = !1), (s.isMoved = !1))
        return
      }
    } else {
      if (
        p &&
        ((l > a.startX && -t.translate <= t.maxTranslate()) ||
          (l < a.startX && -t.translate >= t.minTranslate()))
      )
        return
      if (
        !p &&
        ((l < a.startX && t.translate <= t.maxTranslate()) ||
          (l > a.startX && t.translate >= t.minTranslate()))
      )
        return
    }
  if (
    (e.activeElement &&
      e.activeElement.matches(s.focusableElements) &&
      e.activeElement !== f.target &&
      f.pointerType !== 'mouse' &&
      e.activeElement.blur(),
    e.activeElement &&
      f.target === e.activeElement &&
      f.target.matches(s.focusableElements))
  ) {
    ;((s.isMoved = !0), (t.allowClick = !1))
    return
  }
  ;(s.allowTouchCallbacks && t.emit('touchMove', f),
    (a.previousX = a.currentX),
    (a.previousY = a.currentY),
    (a.currentX = l),
    (a.currentY = u))
  const w = a.currentX - a.startX,
    h = a.currentY - a.startY
  if (t.params.threshold && Math.sqrt(w ** 2 + h ** 2) < t.params.threshold)
    return
  if (typeof s.isScrolling > 'u') {
    let x
    ;(t.isHorizontal() && a.currentY === a.startY) ||
    (t.isVertical() && a.currentX === a.startX)
      ? (s.isScrolling = !1)
      : w * w + h * h >= 25 &&
        ((x = (Math.atan2(Math.abs(h), Math.abs(w)) * 180) / Math.PI),
        (s.isScrolling = t.isHorizontal()
          ? x > r.touchAngle
          : 90 - x > r.touchAngle))
  }
  if (
    (s.isScrolling && t.emit('touchMoveOpposite', f),
    typeof s.startMoving > 'u' &&
      (a.currentX !== a.startX || a.currentY !== a.startY) &&
      (s.startMoving = !0),
    s.isScrolling ||
      (f.type === 'touchmove' && s.preventTouchMoveFromPointerMove))
  ) {
    s.isTouched = !1
    return
  }
  if (!s.startMoving) return
  ;((t.allowClick = !1),
    !r.cssMode && f.cancelable && f.preventDefault(),
    r.touchMoveStopPropagation && !r.nested && f.stopPropagation())
  let n = t.isHorizontal() ? w : h,
    o = t.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY
  ;(r.oneWayMovement &&
    ((n = Math.abs(n) * (p ? 1 : -1)), (o = Math.abs(o) * (p ? 1 : -1))),
    (a.diff = n),
    (n *= r.touchRatio),
    p && ((n = -n), (o = -o)))
  const v = t.touchesDirection
  ;((t.swipeDirection = n > 0 ? 'prev' : 'next'),
    (t.touchesDirection = o > 0 ? 'prev' : 'next'))
  const b = t.params.loop && !r.cssMode,
    g =
      (t.touchesDirection === 'next' && t.allowSlideNext) ||
      (t.touchesDirection === 'prev' && t.allowSlidePrev)
  if (!s.isMoved) {
    if (
      (b && g && t.loopFix({ direction: t.swipeDirection }),
      (s.startTranslate = t.getTranslate()),
      t.setTransition(0),
      t.animating)
    ) {
      const x = new window.CustomEvent('transitionend', {
        bubbles: !0,
        cancelable: !0,
        detail: { bySwiperTouchMove: !0 },
      })
      t.wrapperEl.dispatchEvent(x)
    }
    ;((s.allowMomentumBounce = !1),
      r.grabCursor &&
        (t.allowSlideNext === !0 || t.allowSlidePrev === !0) &&
        t.setGrabCursor(!0),
      t.emit('sliderFirstMove', f))
  }
  if (
    (new Date().getTime(),
    r._loopSwapReset !== !1 &&
      s.isMoved &&
      s.allowThresholdMove &&
      v !== t.touchesDirection &&
      b &&
      g &&
      Math.abs(n) >= 1)
  ) {
    ;(Object.assign(a, {
      startX: l,
      startY: u,
      currentX: l,
      currentY: u,
      startTranslate: s.currentTranslate,
    }),
      (s.loopSwapReset = !0),
      (s.startTranslate = s.currentTranslate))
    return
  }
  ;(t.emit('sliderMove', f),
    (s.isMoved = !0),
    (s.currentTranslate = n + s.startTranslate))
  let m = !0,
    y = r.resistanceRatio
  if (
    (r.touchReleaseOnEdges && (y = 0),
    n > 0
      ? (b &&
          g &&
          s.allowThresholdMove &&
          s.currentTranslate >
            (r.centeredSlides
              ? t.minTranslate() -
                t.slidesSizesGrid[t.activeIndex + 1] -
                (r.slidesPerView !== 'auto' &&
                t.slides.length - r.slidesPerView >= 2
                  ? t.slidesSizesGrid[t.activeIndex + 1] + t.params.spaceBetween
                  : 0) -
                t.params.spaceBetween
              : t.minTranslate()) &&
          t.loopFix({
            direction: 'prev',
            setTranslate: !0,
            activeSlideIndex: 0,
          }),
        s.currentTranslate > t.minTranslate() &&
          ((m = !1),
          r.resistance &&
            (s.currentTranslate =
              t.minTranslate() -
              1 +
              (-t.minTranslate() + s.startTranslate + n) ** y)))
      : n < 0 &&
        (b &&
          g &&
          s.allowThresholdMove &&
          s.currentTranslate <
            (r.centeredSlides
              ? t.maxTranslate() +
                t.slidesSizesGrid[t.slidesSizesGrid.length - 1] +
                t.params.spaceBetween +
                (r.slidesPerView !== 'auto' &&
                t.slides.length - r.slidesPerView >= 2
                  ? t.slidesSizesGrid[t.slidesSizesGrid.length - 1] +
                    t.params.spaceBetween
                  : 0)
              : t.maxTranslate()) &&
          t.loopFix({
            direction: 'next',
            setTranslate: !0,
            activeSlideIndex:
              t.slides.length -
              (r.slidesPerView === 'auto'
                ? t.slidesPerViewDynamic()
                : Math.ceil(parseFloat(r.slidesPerView, 10))),
          }),
        s.currentTranslate < t.maxTranslate() &&
          ((m = !1),
          r.resistance &&
            (s.currentTranslate =
              t.maxTranslate() +
              1 -
              (t.maxTranslate() - s.startTranslate - n) ** y))),
    m && (f.preventedByNestedSwiper = !0),
    !t.allowSlideNext &&
      t.swipeDirection === 'next' &&
      s.currentTranslate < s.startTranslate &&
      (s.currentTranslate = s.startTranslate),
    !t.allowSlidePrev &&
      t.swipeDirection === 'prev' &&
      s.currentTranslate > s.startTranslate &&
      (s.currentTranslate = s.startTranslate),
    !t.allowSlidePrev &&
      !t.allowSlideNext &&
      (s.currentTranslate = s.startTranslate),
    r.threshold > 0)
  )
    if (Math.abs(n) > r.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        ;((s.allowThresholdMove = !0),
          (a.startX = a.currentX),
          (a.startY = a.currentY),
          (s.currentTranslate = s.startTranslate),
          (a.diff = t.isHorizontal()
            ? a.currentX - a.startX
            : a.currentY - a.startY))
        return
      }
    } else {
      s.currentTranslate = s.startTranslate
      return
    }
  !r.followFinger ||
    r.cssMode ||
    (((r.freeMode && r.freeMode.enabled && t.freeMode) ||
      r.watchSlidesProgress) &&
      (t.updateActiveIndex(), t.updateSlidesClasses()),
    r.freeMode && r.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(),
    t.updateProgress(s.currentTranslate),
    t.setTranslate(s.currentTranslate))
}
function Ti(i) {
  const e = this,
    t = e.touchEventsData
  let s = i
  s.originalEvent && (s = s.originalEvent)
  let r
  if (s.type === 'touchend' || s.type === 'touchcancel') {
    if (
      ((r = [...s.changedTouches].find(x => x.identifier === t.touchId)),
      !r || r.identifier !== t.touchId)
    )
      return
  } else {
    if (t.touchId !== null || s.pointerId !== t.pointerId) return
    r = s
  }
  if (
    ['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(
      s.type
    ) &&
    !(
      ['pointercancel', 'contextmenu'].includes(s.type) &&
      (e.browser.isSafari || e.browser.isWebView)
    )
  )
    return
  ;((t.pointerId = null), (t.touchId = null))
  const {
    params: p,
    touches: c,
    rtlTranslate: f,
    slidesGrid: d,
    enabled: l,
  } = e
  if (!l || (!p.simulateTouch && s.pointerType === 'mouse')) return
  if (
    (t.allowTouchCallbacks && e.emit('touchEnd', s),
    (t.allowTouchCallbacks = !1),
    !t.isTouched)
  ) {
    ;(t.isMoved && p.grabCursor && e.setGrabCursor(!1),
      (t.isMoved = !1),
      (t.startMoving = !1))
    return
  }
  p.grabCursor &&
    t.isMoved &&
    t.isTouched &&
    (e.allowSlideNext === !0 || e.allowSlidePrev === !0) &&
    e.setGrabCursor(!1)
  const u = J(),
    w = u - t.touchStartTime
  if (e.allowClick) {
    const x = s.path || (s.composedPath && s.composedPath())
    ;(e.updateClickedSlide((x && x[0]) || s.target, x),
      e.emit('tap click', s),
      w < 300 &&
        u - t.lastClickTime < 300 &&
        e.emit('doubleTap doubleClick', s))
  }
  if (
    ((t.lastClickTime = J()),
    ge(() => {
      e.destroyed || (e.allowClick = !0)
    }),
    !t.isTouched ||
      !t.isMoved ||
      !e.swipeDirection ||
      (c.diff === 0 && !t.loopSwapReset) ||
      (t.currentTranslate === t.startTranslate && !t.loopSwapReset))
  ) {
    ;((t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1))
    return
  }
  ;((t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1))
  let h
  if (
    (p.followFinger
      ? (h = f ? e.translate : -e.translate)
      : (h = -t.currentTranslate),
    p.cssMode)
  )
    return
  if (p.freeMode && p.freeMode.enabled) {
    e.freeMode.onTouchEnd({ currentPos: h })
    return
  }
  const n = h >= -e.maxTranslate() && !e.params.loop
  let o = 0,
    v = e.slidesSizesGrid[0]
  for (
    let x = 0;
    x < d.length;
    x += x < p.slidesPerGroupSkip ? 1 : p.slidesPerGroup
  ) {
    const O = x < p.slidesPerGroupSkip - 1 ? 1 : p.slidesPerGroup
    typeof d[x + O] < 'u'
      ? (n || (h >= d[x] && h < d[x + O])) && ((o = x), (v = d[x + O] - d[x]))
      : (n || h >= d[x]) && ((o = x), (v = d[d.length - 1] - d[d.length - 2]))
  }
  let b = null,
    g = null
  p.rewind &&
    (e.isBeginning
      ? (g =
          p.virtual && p.virtual.enabled && e.virtual
            ? e.virtual.slides.length - 1
            : e.slides.length - 1)
      : e.isEnd && (b = 0))
  const m = (h - d[o]) / v,
    y = o < p.slidesPerGroupSkip - 1 ? 1 : p.slidesPerGroup
  if (w > p.longSwipesMs) {
    if (!p.longSwipes) {
      e.slideTo(e.activeIndex)
      return
    }
    ;(e.swipeDirection === 'next' &&
      (m >= p.longSwipesRatio
        ? e.slideTo(p.rewind && e.isEnd ? b : o + y)
        : e.slideTo(o)),
      e.swipeDirection === 'prev' &&
        (m > 1 - p.longSwipesRatio
          ? e.slideTo(o + y)
          : g !== null && m < 0 && Math.abs(m) > p.longSwipesRatio
            ? e.slideTo(g)
            : e.slideTo(o)))
  } else {
    if (!p.shortSwipes) {
      e.slideTo(e.activeIndex)
      return
    }
    e.navigation &&
    (s.target === e.navigation.nextEl || s.target === e.navigation.prevEl)
      ? s.target === e.navigation.nextEl
        ? e.slideTo(o + y)
        : e.slideTo(o)
      : (e.swipeDirection === 'next' && e.slideTo(b !== null ? b : o + y),
        e.swipeDirection === 'prev' && e.slideTo(g !== null ? g : o))
  }
}
function lt() {
  const i = this,
    { params: e, el: t } = i
  if (t && t.offsetWidth === 0) return
  e.breakpoints && i.setBreakpoint()
  const { allowSlideNext: s, allowSlidePrev: r, snapGrid: a } = i,
    p = i.virtual && i.params.virtual.enabled
  ;((i.allowSlideNext = !0),
    (i.allowSlidePrev = !0),
    i.updateSize(),
    i.updateSlides(),
    i.updateSlidesClasses())
  const c = p && e.loop
  ;((e.slidesPerView === 'auto' || e.slidesPerView > 1) &&
  i.isEnd &&
  !i.isBeginning &&
  !i.params.centeredSlides &&
  !c
    ? i.slideTo(i.slides.length - 1, 0, !1, !0)
    : i.params.loop && !p
      ? i.slideToLoop(i.realIndex, 0, !1, !0)
      : i.slideTo(i.activeIndex, 0, !1, !0),
    i.autoplay &&
      i.autoplay.running &&
      i.autoplay.paused &&
      (clearTimeout(i.autoplay.resizeTimeout),
      (i.autoplay.resizeTimeout = setTimeout(() => {
        i.autoplay &&
          i.autoplay.running &&
          i.autoplay.paused &&
          i.autoplay.resume()
      }, 500))),
    (i.allowSlidePrev = r),
    (i.allowSlideNext = s),
    i.params.watchOverflow && a !== i.snapGrid && i.checkOverflow())
}
function Mi(i) {
  const e = this
  e.enabled &&
    (e.allowClick ||
      (e.params.preventClicks && i.preventDefault(),
      e.params.preventClicksPropagation &&
        e.animating &&
        (i.stopPropagation(), i.stopImmediatePropagation())))
}
function Ci() {
  const i = this,
    { wrapperEl: e, rtlTranslate: t, enabled: s } = i
  if (!s) return
  ;((i.previousTranslate = i.translate),
    i.isHorizontal()
      ? (i.translate = -e.scrollLeft)
      : (i.translate = -e.scrollTop),
    i.translate === 0 && (i.translate = 0),
    i.updateActiveIndex(),
    i.updateSlidesClasses())
  let r
  const a = i.maxTranslate() - i.minTranslate()
  ;(a === 0 ? (r = 0) : (r = (i.translate - i.minTranslate()) / a),
    r !== i.progress && i.updateProgress(t ? -i.translate : i.translate),
    i.emit('setTranslate', i.translate, !1))
}
function Pi(i) {
  const e = this
  ;(Ae(e, i.target),
    !(
      e.params.cssMode ||
      (e.params.slidesPerView !== 'auto' && !e.params.autoHeight)
    ) && e.update())
}
function Li() {
  const i = this
  i.documentTouchHandlerProceeded ||
    ((i.documentTouchHandlerProceeded = !0),
    i.params.touchReleaseOnEdges && (i.el.style.touchAction = 'auto'))
}
const St = (i, e) => {
  const t = W(),
    { params: s, el: r, wrapperEl: a, device: p } = i,
    c = !!s.nested,
    f = e === 'on' ? 'addEventListener' : 'removeEventListener',
    d = e
  !r ||
    typeof r == 'string' ||
    (t[f]('touchstart', i.onDocumentTouchStart, { passive: !1, capture: c }),
    r[f]('touchstart', i.onTouchStart, { passive: !1 }),
    r[f]('pointerdown', i.onTouchStart, { passive: !1 }),
    t[f]('touchmove', i.onTouchMove, { passive: !1, capture: c }),
    t[f]('pointermove', i.onTouchMove, { passive: !1, capture: c }),
    t[f]('touchend', i.onTouchEnd, { passive: !0 }),
    t[f]('pointerup', i.onTouchEnd, { passive: !0 }),
    t[f]('pointercancel', i.onTouchEnd, { passive: !0 }),
    t[f]('touchcancel', i.onTouchEnd, { passive: !0 }),
    t[f]('pointerout', i.onTouchEnd, { passive: !0 }),
    t[f]('pointerleave', i.onTouchEnd, { passive: !0 }),
    t[f]('contextmenu', i.onTouchEnd, { passive: !0 }),
    (s.preventClicks || s.preventClicksPropagation) &&
      r[f]('click', i.onClick, !0),
    s.cssMode && a[f]('scroll', i.onScroll),
    s.updateOnWindowResize
      ? i[d](
          p.ios || p.android
            ? 'resize orientationchange observerUpdate'
            : 'resize observerUpdate',
          lt,
          !0
        )
      : i[d]('observerUpdate', lt, !0),
    r[f]('load', i.onLoad, { capture: !0 }))
}
function zi() {
  const i = this,
    { params: e } = i
  ;((i.onTouchStart = Ei.bind(i)),
    (i.onTouchMove = xi.bind(i)),
    (i.onTouchEnd = Ti.bind(i)),
    (i.onDocumentTouchStart = Li.bind(i)),
    e.cssMode && (i.onScroll = Ci.bind(i)),
    (i.onClick = Mi.bind(i)),
    (i.onLoad = Pi.bind(i)),
    St(i, 'on'))
}
function Ii() {
  St(this, 'off')
}
var Ai = { attachEvents: zi, detachEvents: Ii }
const dt = (i, e) => i.grid && e.grid && e.grid.rows > 1
function Oi() {
  const i = this,
    { realIndex: e, initialized: t, params: s, el: r } = i,
    a = s.breakpoints
  if (!a || (a && Object.keys(a).length === 0)) return
  const p = W(),
    c =
      s.breakpointsBase === 'window' || !s.breakpointsBase
        ? s.breakpointsBase
        : 'container',
    f =
      ['window', 'container'].includes(s.breakpointsBase) || !s.breakpointsBase
        ? i.el
        : p.querySelector(s.breakpointsBase),
    d = i.getBreakpoint(a, c, f)
  if (!d || i.currentBreakpoint === d) return
  const u = (d in a ? a[d] : void 0) || i.originalParams,
    w = dt(i, s),
    h = dt(i, u),
    n = i.params.grabCursor,
    o = u.grabCursor,
    v = s.enabled
  ;(w && !h
    ? (r.classList.remove(
        `${s.containerModifierClass}grid`,
        `${s.containerModifierClass}grid-column`
      ),
      i.emitContainerClasses())
    : !w &&
      h &&
      (r.classList.add(`${s.containerModifierClass}grid`),
      ((u.grid.fill && u.grid.fill === 'column') ||
        (!u.grid.fill && s.grid.fill === 'column')) &&
        r.classList.add(`${s.containerModifierClass}grid-column`),
      i.emitContainerClasses()),
    n && !o ? i.unsetGrabCursor() : !n && o && i.setGrabCursor(),
    ['navigation', 'pagination', 'scrollbar'].forEach(O => {
      if (typeof u[O] > 'u') return
      const L = s[O] && s[O].enabled,
        z = u[O] && u[O].enabled
      ;(L && !z && i[O].disable(), !L && z && i[O].enable())
    }))
  const b = u.direction && u.direction !== s.direction,
    g = s.loop && (u.slidesPerView !== s.slidesPerView || b),
    m = s.loop
  ;(b && t && i.changeDirection(), Z(i.params, u))
  const y = i.params.enabled,
    x = i.params.loop
  ;(Object.assign(i, {
    allowTouchMove: i.params.allowTouchMove,
    allowSlideNext: i.params.allowSlideNext,
    allowSlidePrev: i.params.allowSlidePrev,
  }),
    v && !y ? i.disable() : !v && y && i.enable(),
    (i.currentBreakpoint = d),
    i.emit('_beforeBreakpoint', u),
    t &&
      (g
        ? (i.loopDestroy(), i.loopCreate(e), i.updateSlides())
        : !m && x
          ? (i.loopCreate(e), i.updateSlides())
          : m && !x && i.loopDestroy()),
    i.emit('breakpoint', u))
}
function Di(i, e, t) {
  if ((e === void 0 && (e = 'window'), !i || (e === 'container' && !t))) return
  let s = !1
  const r = X(),
    a = e === 'window' ? r.innerHeight : t.clientHeight,
    p = Object.keys(i).map(c => {
      if (typeof c == 'string' && c.indexOf('@') === 0) {
        const f = parseFloat(c.substr(1))
        return { value: a * f, point: c }
      }
      return { value: c, point: c }
    })
  p.sort((c, f) => parseInt(c.value, 10) - parseInt(f.value, 10))
  for (let c = 0; c < p.length; c += 1) {
    const { point: f, value: d } = p[c]
    e === 'window'
      ? r.matchMedia(`(min-width: ${d}px)`).matches && (s = f)
      : d <= t.clientWidth && (s = f)
  }
  return s || 'max'
}
var $i = { setBreakpoint: Oi, getBreakpoint: Di }
function _i(i, e) {
  const t = []
  return (
    i.forEach(s => {
      typeof s == 'object'
        ? Object.keys(s).forEach(r => {
            s[r] && t.push(e + r)
          })
        : typeof s == 'string' && t.push(e + s)
    }),
    t
  )
}
function ki() {
  const i = this,
    { classNames: e, params: t, rtl: s, el: r, device: a } = i,
    p = _i(
      [
        'initialized',
        t.direction,
        { 'free-mode': i.params.freeMode && t.freeMode.enabled },
        { autoheight: t.autoHeight },
        { rtl: s },
        { grid: t.grid && t.grid.rows > 1 },
        {
          'grid-column': t.grid && t.grid.rows > 1 && t.grid.fill === 'column',
        },
        { android: a.android },
        { ios: a.ios },
        { 'css-mode': t.cssMode },
        { centered: t.cssMode && t.centeredSlides },
        { 'watch-progress': t.watchSlidesProgress },
      ],
      t.containerModifierClass
    )
  ;(e.push(...p), r.classList.add(...e), i.emitContainerClasses())
}
function Ri() {
  const i = this,
    { el: e, classNames: t } = i
  !e ||
    typeof e == 'string' ||
    (e.classList.remove(...t), i.emitContainerClasses())
}
var Bi = { addClasses: ki, removeClasses: Ri }
function Gi() {
  const i = this,
    { isLocked: e, params: t } = i,
    { slidesOffsetBefore: s } = t
  if (s) {
    const r = i.slides.length - 1,
      a = i.slidesGrid[r] + i.slidesSizesGrid[r] + s * 2
    i.isLocked = i.size > a
  } else i.isLocked = i.snapGrid.length === 1
  ;(t.allowSlideNext === !0 && (i.allowSlideNext = !i.isLocked),
    t.allowSlidePrev === !0 && (i.allowSlidePrev = !i.isLocked),
    e && e !== i.isLocked && (i.isEnd = !1),
    e !== i.isLocked && i.emit(i.isLocked ? 'lock' : 'unlock'))
}
var Hi = { checkOverflow: Gi },
  et = {
    init: !0,
    direction: 'horizontal',
    oneWayMovement: !1,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: 'swiper',
    enabled: !0,
    focusableElements: 'input, select, option, textarea, button, video, label',
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: 'slide',
    breakpoints: void 0,
    breakpointsBase: 'window',
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: 'swiper-',
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  }
function Vi(i, e) {
  return function (s) {
    s === void 0 && (s = {})
    const r = Object.keys(s)[0],
      a = s[r]
    if (typeof a != 'object' || a === null) {
      Z(e, s)
      return
    }
    if (
      (i[r] === !0 && (i[r] = { enabled: !0 }),
      r === 'navigation' &&
        i[r] &&
        i[r].enabled &&
        !i[r].prevEl &&
        !i[r].nextEl &&
        (i[r].auto = !0),
      ['pagination', 'scrollbar'].indexOf(r) >= 0 &&
        i[r] &&
        i[r].enabled &&
        !i[r].el &&
        (i[r].auto = !0),
      !(r in i && 'enabled' in a))
    ) {
      Z(e, s)
      return
    }
    ;(typeof i[r] == 'object' && !('enabled' in i[r]) && (i[r].enabled = !0),
      i[r] || (i[r] = { enabled: !1 }),
      Z(e, s))
  }
}
const qe = {
    eventsEmitter: Bt,
    update: Ut,
    translate: ti,
    transition: ai,
    slide: ui,
    loop: wi,
    grabCursor: yi,
    events: Ai,
    breakpoints: $i,
    checkOverflow: Hi,
    classes: Bi,
  },
  Ue = {}
class K {
  constructor() {
    let e, t
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a]
    ;(r.length === 1 &&
    r[0].constructor &&
    Object.prototype.toString.call(r[0]).slice(8, -1) === 'Object'
      ? (t = r[0])
      : ([e, t] = r),
      t || (t = {}),
      (t = Z({}, t)),
      e && !t.el && (t.el = e))
    const p = W()
    if (
      t.el &&
      typeof t.el == 'string' &&
      p.querySelectorAll(t.el).length > 1
    ) {
      const l = []
      return (
        p.querySelectorAll(t.el).forEach(u => {
          const w = Z({}, t, { el: u })
          l.push(new K(w))
        }),
        l
      )
    }
    const c = this
    ;((c.__swiper__ = !0),
      (c.support = wt()),
      (c.device = vt({ userAgent: t.userAgent })),
      (c.browser = bt()),
      (c.eventsListeners = {}),
      (c.eventsAnyListeners = []),
      (c.modules = [...c.__modules__]),
      t.modules && Array.isArray(t.modules) && c.modules.push(...t.modules))
    const f = {}
    c.modules.forEach(l => {
      l({
        params: t,
        swiper: c,
        extendParams: Vi(t, f),
        on: c.on.bind(c),
        once: c.once.bind(c),
        off: c.off.bind(c),
        emit: c.emit.bind(c),
      })
    })
    const d = Z({}, et, f)
    return (
      (c.params = Z({}, d, Ue, t)),
      (c.originalParams = Z({}, c.params)),
      (c.passedParams = Z({}, t)),
      c.params &&
        c.params.on &&
        Object.keys(c.params.on).forEach(l => {
          c.on(l, c.params.on[l])
        }),
      c.params && c.params.onAny && c.onAny(c.params.onAny),
      Object.assign(c, {
        enabled: c.params.enabled,
        el: e,
        classNames: [],
        slides: [],
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        isHorizontal() {
          return c.params.direction === 'horizontal'
        },
        isVertical() {
          return c.params.direction === 'vertical'
        },
        activeIndex: 0,
        realIndex: 0,
        isBeginning: !0,
        isEnd: !1,
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: !1,
        cssOverflowAdjustment() {
          return Math.trunc(this.translate / 2 ** 23) * 2 ** 23
        },
        allowSlideNext: c.params.allowSlideNext,
        allowSlidePrev: c.params.allowSlidePrev,
        touchEventsData: {
          isTouched: void 0,
          isMoved: void 0,
          allowTouchCallbacks: void 0,
          touchStartTime: void 0,
          isScrolling: void 0,
          currentTranslate: void 0,
          startTranslate: void 0,
          allowThresholdMove: void 0,
          focusableElements: c.params.focusableElements,
          lastClickTime: 0,
          clickTimeout: void 0,
          velocities: [],
          allowMomentumBounce: void 0,
          startMoving: void 0,
          pointerId: null,
          touchId: null,
        },
        allowClick: !0,
        allowTouchMove: c.params.allowTouchMove,
        touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
        imagesToLoad: [],
        imagesLoaded: 0,
      }),
      c.emit('_swiper'),
      c.params.init && c.init(),
      c
    )
  }
  getDirectionLabel(e) {
    return this.isHorizontal()
      ? e
      : {
          width: 'height',
          'margin-top': 'margin-left',
          'margin-bottom ': 'margin-right',
          'margin-left': 'margin-top',
          'margin-right': 'margin-bottom',
          'padding-left': 'padding-top',
          'padding-right': 'padding-bottom',
          marginRight: 'marginBottom',
        }[e]
  }
  getSlideIndex(e) {
    const { slidesEl: t, params: s } = this,
      r = j(t, `.${s.slideClass}, swiper-slide`),
      a = Ce(r[0])
    return Ce(e) - a
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(
      this.slides.find(t => t.getAttribute('data-swiper-slide-index') * 1 === e)
    )
  }
  getSlideIndexWhenGrid(e) {
    return (
      this.grid &&
        this.params.grid &&
        this.params.grid.rows > 1 &&
        (this.params.grid.fill === 'column'
          ? (e = Math.floor(e / this.params.grid.rows))
          : this.params.grid.fill === 'row' &&
            (e = e % Math.ceil(this.slides.length / this.params.grid.rows))),
      e
    )
  }
  recalcSlides() {
    const e = this,
      { slidesEl: t, params: s } = e
    e.slides = j(t, `.${s.slideClass}, swiper-slide`)
  }
  enable() {
    const e = this
    e.enabled ||
      ((e.enabled = !0),
      e.params.grabCursor && e.setGrabCursor(),
      e.emit('enable'))
  }
  disable() {
    const e = this
    e.enabled &&
      ((e.enabled = !1),
      e.params.grabCursor && e.unsetGrabCursor(),
      e.emit('disable'))
  }
  setProgress(e, t) {
    const s = this
    e = Math.min(Math.max(e, 0), 1)
    const r = s.minTranslate(),
      p = (s.maxTranslate() - r) * e + r
    ;(s.translateTo(p, typeof t > 'u' ? 0 : t),
      s.updateActiveIndex(),
      s.updateSlidesClasses())
  }
  emitContainerClasses() {
    const e = this
    if (!e.params._emitClasses || !e.el) return
    const t = e.el.className
      .split(' ')
      .filter(
        s =>
          s.indexOf('swiper') === 0 ||
          s.indexOf(e.params.containerModifierClass) === 0
      )
    e.emit('_containerClasses', t.join(' '))
  }
  getSlideClasses(e) {
    const t = this
    return t.destroyed
      ? ''
      : e.className
          .split(' ')
          .filter(
            s =>
              s.indexOf('swiper-slide') === 0 ||
              s.indexOf(t.params.slideClass) === 0
          )
          .join(' ')
  }
  emitSlidesClasses() {
    const e = this
    if (!e.params._emitClasses || !e.el) return
    const t = []
    ;(e.slides.forEach(s => {
      const r = e.getSlideClasses(s)
      ;(t.push({ slideEl: s, classNames: r }), e.emit('_slideClass', s, r))
    }),
      e.emit('_slideClasses', t))
  }
  slidesPerViewDynamic(e, t) {
    ;(e === void 0 && (e = 'current'), t === void 0 && (t = !1))
    const s = this,
      {
        params: r,
        slides: a,
        slidesGrid: p,
        slidesSizesGrid: c,
        size: f,
        activeIndex: d,
      } = s
    let l = 1
    if (typeof r.slidesPerView == 'number') return r.slidesPerView
    if (r.centeredSlides) {
      let u = a[d] ? Math.ceil(a[d].swiperSlideSize) : 0,
        w
      for (let h = d + 1; h < a.length; h += 1)
        a[h] &&
          !w &&
          ((u += Math.ceil(a[h].swiperSlideSize)), (l += 1), u > f && (w = !0))
      for (let h = d - 1; h >= 0; h -= 1)
        a[h] && !w && ((u += a[h].swiperSlideSize), (l += 1), u > f && (w = !0))
    } else if (e === 'current')
      for (let u = d + 1; u < a.length; u += 1)
        (t ? p[u] + c[u] - p[d] < f : p[u] - p[d] < f) && (l += 1)
    else for (let u = d - 1; u >= 0; u -= 1) p[d] - p[u] < f && (l += 1)
    return l
  }
  update() {
    const e = this
    if (!e || e.destroyed) return
    const { snapGrid: t, params: s } = e
    ;(s.breakpoints && e.setBreakpoint(),
      [...e.el.querySelectorAll('[loading="lazy"]')].forEach(p => {
        p.complete && Ae(e, p)
      }),
      e.updateSize(),
      e.updateSlides(),
      e.updateProgress(),
      e.updateSlidesClasses())
    function r() {
      const p = e.rtlTranslate ? e.translate * -1 : e.translate,
        c = Math.min(Math.max(p, e.maxTranslate()), e.minTranslate())
      ;(e.setTranslate(c), e.updateActiveIndex(), e.updateSlidesClasses())
    }
    let a
    if (s.freeMode && s.freeMode.enabled && !s.cssMode)
      (r(), s.autoHeight && e.updateAutoHeight())
    else {
      if (
        (s.slidesPerView === 'auto' || s.slidesPerView > 1) &&
        e.isEnd &&
        !s.centeredSlides
      ) {
        const p = e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides
        a = e.slideTo(p.length - 1, 0, !1, !0)
      } else a = e.slideTo(e.activeIndex, 0, !1, !0)
      a || r()
    }
    ;(s.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
      e.emit('update'))
  }
  changeDirection(e, t) {
    t === void 0 && (t = !0)
    const s = this,
      r = s.params.direction
    return (
      e || (e = r === 'horizontal' ? 'vertical' : 'horizontal'),
      e === r ||
        (e !== 'horizontal' && e !== 'vertical') ||
        (s.el.classList.remove(`${s.params.containerModifierClass}${r}`),
        s.el.classList.add(`${s.params.containerModifierClass}${e}`),
        s.emitContainerClasses(),
        (s.params.direction = e),
        s.slides.forEach(a => {
          e === 'vertical' ? (a.style.width = '') : (a.style.height = '')
        }),
        s.emit('changeDirection'),
        t && s.update()),
      s
    )
  }
  changeLanguageDirection(e) {
    const t = this
    ;(t.rtl && e === 'rtl') ||
      (!t.rtl && e === 'ltr') ||
      ((t.rtl = e === 'rtl'),
      (t.rtlTranslate = t.params.direction === 'horizontal' && t.rtl),
      t.rtl
        ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`),
          (t.el.dir = 'rtl'))
        : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`),
          (t.el.dir = 'ltr')),
      t.update())
  }
  mount(e) {
    const t = this
    if (t.mounted) return !0
    let s = e || t.params.el
    if ((typeof s == 'string' && (s = document.querySelector(s)), !s)) return !1
    ;((s.swiper = t),
      s.parentNode &&
        s.parentNode.host &&
        s.parentNode.host.nodeName ===
          t.params.swiperElementNodeName.toUpperCase() &&
        (t.isElement = !0))
    const r = () =>
      `.${(t.params.wrapperClass || '').trim().split(' ').join('.')}`
    let p =
      s && s.shadowRoot && s.shadowRoot.querySelector
        ? s.shadowRoot.querySelector(r())
        : j(s, r())[0]
    return (
      !p &&
        t.params.createElements &&
        ((p = Q('div', t.params.wrapperClass)),
        s.append(p),
        j(s, `.${t.params.slideClass}`).forEach(c => {
          p.append(c)
        })),
      Object.assign(t, {
        el: s,
        wrapperEl: p,
        slidesEl:
          t.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : p,
        hostEl: t.isElement ? s.parentNode.host : s,
        mounted: !0,
        rtl: s.dir.toLowerCase() === 'rtl' || ce(s, 'direction') === 'rtl',
        rtlTranslate:
          t.params.direction === 'horizontal' &&
          (s.dir.toLowerCase() === 'rtl' || ce(s, 'direction') === 'rtl'),
        wrongRTL: ce(p, 'display') === '-webkit-box',
      }),
      !0
    )
  }
  init(e) {
    const t = this
    if (t.initialized || t.mount(e) === !1) return t
    ;(t.emit('beforeInit'),
      t.params.breakpoints && t.setBreakpoint(),
      t.addClasses(),
      t.updateSize(),
      t.updateSlides(),
      t.params.watchOverflow && t.checkOverflow(),
      t.params.grabCursor && t.enabled && t.setGrabCursor(),
      t.params.loop && t.virtual && t.params.virtual.enabled
        ? t.slideTo(
            t.params.initialSlide + t.virtual.slidesBefore,
            0,
            t.params.runCallbacksOnInit,
            !1,
            !0
          )
        : t.slideTo(
            t.params.initialSlide,
            0,
            t.params.runCallbacksOnInit,
            !1,
            !0
          ),
      t.params.loop && t.loopCreate(void 0, !0),
      t.attachEvents())
    const r = [...t.el.querySelectorAll('[loading="lazy"]')]
    return (
      t.isElement && r.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
      r.forEach(a => {
        a.complete
          ? Ae(t, a)
          : a.addEventListener('load', p => {
              Ae(t, p.target)
            })
      }),
      Je(t),
      (t.initialized = !0),
      Je(t),
      t.emit('init'),
      t.emit('afterInit'),
      t
    )
  }
  destroy(e, t) {
    ;(e === void 0 && (e = !0), t === void 0 && (t = !0))
    const s = this,
      { params: r, el: a, wrapperEl: p, slides: c } = s
    return (
      typeof s.params > 'u' ||
        s.destroyed ||
        (s.emit('beforeDestroy'),
        (s.initialized = !1),
        s.detachEvents(),
        r.loop && s.loopDestroy(),
        t &&
          (s.removeClasses(),
          a && typeof a != 'string' && a.removeAttribute('style'),
          p && p.removeAttribute('style'),
          c &&
            c.length &&
            c.forEach(f => {
              ;(f.classList.remove(
                r.slideVisibleClass,
                r.slideFullyVisibleClass,
                r.slideActiveClass,
                r.slideNextClass,
                r.slidePrevClass
              ),
                f.removeAttribute('style'),
                f.removeAttribute('data-swiper-slide-index'))
            })),
        s.emit('destroy'),
        Object.keys(s.eventsListeners).forEach(f => {
          s.off(f)
        }),
        e !== !1 &&
          (s.el && typeof s.el != 'string' && (s.el.swiper = null), Ct(s)),
        (s.destroyed = !0)),
      null
    )
  }
  static extendDefaults(e) {
    Z(Ue, e)
  }
  static get extendedDefaults() {
    return Ue
  }
  static get defaults() {
    return et
  }
  static installModule(e) {
    K.prototype.__modules__ || (K.prototype.__modules__ = [])
    const t = K.prototype.__modules__
    typeof e == 'function' && t.indexOf(e) < 0 && t.push(e)
  }
  static use(e) {
    return Array.isArray(e)
      ? (e.forEach(t => K.installModule(t)), K)
      : (K.installModule(e), K)
  }
}
Object.keys(qe).forEach(i => {
  Object.keys(qe[i]).forEach(e => {
    K.prototype[e] = qe[i][e]
  })
})
K.use([kt, Rt])
function Xi(i) {
  let { swiper: e, extendParams: t, on: s, emit: r } = i
  t({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0,
    },
  })
  let a
  const p = W()
  e.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: [],
  }
  const c = p.createElement('div')
  function f(n, o) {
    const v = e.params.virtual
    if (v.cache && e.virtual.cache[o]) return e.virtual.cache[o]
    let b
    return (
      v.renderSlide
        ? ((b = v.renderSlide.call(e, n, o)),
          typeof b == 'string' && (ee(c, b), (b = c.children[0])))
        : e.isElement
          ? (b = Q('swiper-slide'))
          : (b = Q('div', e.params.slideClass)),
      b.setAttribute('data-swiper-slide-index', o),
      v.renderSlide || ee(b, n),
      v.cache && (e.virtual.cache[o] = b),
      b
    )
  }
  function d(n, o, v) {
    const {
      slidesPerView: b,
      slidesPerGroup: g,
      centeredSlides: m,
      loop: y,
      initialSlide: x,
    } = e.params
    if (o && !y && x > 0) return
    const { addSlidesBefore: O, addSlidesAfter: L } = e.params.virtual,
      { from: z, to: S, slides: T, slidesGrid: I, offset: P } = e.virtual
    e.params.cssMode || e.updateActiveIndex()
    const C = typeof v > 'u' ? e.activeIndex || 0 : v
    let A
    e.rtlTranslate ? (A = 'right') : (A = e.isHorizontal() ? 'left' : 'top')
    let $, k
    m
      ? (($ = Math.floor(b / 2) + g + L), (k = Math.floor(b / 2) + g + O))
      : (($ = b + (g - 1) + L), (k = (y ? b : g) + O))
    let E = C - k,
      M = C + $
    y || ((E = Math.max(E, 0)), (M = Math.min(M, T.length - 1)))
    let B = (e.slidesGrid[E] || 0) - (e.slidesGrid[0] || 0)
    ;(y && C >= k
      ? ((E -= k), m || (B += e.slidesGrid[0]))
      : y && C < k && ((E = -k), m && (B += e.slidesGrid[0])),
      Object.assign(e.virtual, {
        from: E,
        to: M,
        offset: B,
        slidesGrid: e.slidesGrid,
        slidesBefore: k,
        slidesAfter: $,
      }))
    function G() {
      ;(e.updateSlides(),
        e.updateProgress(),
        e.updateSlidesClasses(),
        r('virtualUpdate'))
    }
    if (z === E && S === M && !n) {
      ;(e.slidesGrid !== I &&
        B !== P &&
        e.slides.forEach(D => {
          D.style[A] = `${B - Math.abs(e.cssOverflowAdjustment())}px`
        }),
        e.updateProgress(),
        r('virtualUpdate'))
      return
    }
    if (e.params.virtual.renderExternal) {
      ;(e.params.virtual.renderExternal.call(e, {
        offset: B,
        from: E,
        to: M,
        slides: (function () {
          const R = []
          for (let V = E; V <= M; V += 1) R.push(T[V])
          return R
        })(),
      }),
        e.params.virtual.renderExternalUpdate ? G() : r('virtualUpdate'))
      return
    }
    const Y = [],
      F = [],
      ie = D => {
        let R = D
        return (
          D < 0 ? (R = T.length + D) : R >= T.length && (R = R - T.length),
          R
        )
      }
    if (n)
      e.slides
        .filter(D => D.matches(`.${e.params.slideClass}, swiper-slide`))
        .forEach(D => {
          D.remove()
        })
    else
      for (let D = z; D <= S; D += 1)
        if (D < E || D > M) {
          const R = ie(D)
          e.slides
            .filter(V =>
              V.matches(
                `.${e.params.slideClass}[data-swiper-slide-index="${R}"], swiper-slide[data-swiper-slide-index="${R}"]`
              )
            )
            .forEach(V => {
              V.remove()
            })
        }
    const ye = y ? -T.length : 0,
      _ = y ? T.length * 2 : T.length
    for (let D = ye; D < _; D += 1)
      if (D >= E && D <= M) {
        const R = ie(D)
        typeof S > 'u' || n
          ? F.push(R)
          : (D > S && F.push(R), D < z && Y.push(R))
      }
    if (
      (F.forEach(D => {
        e.slidesEl.append(f(T[D], D))
      }),
      y)
    )
      for (let D = Y.length - 1; D >= 0; D -= 1) {
        const R = Y[D]
        e.slidesEl.prepend(f(T[R], R))
      }
    else
      (Y.sort((D, R) => R - D),
        Y.forEach(D => {
          e.slidesEl.prepend(f(T[D], D))
        }))
    ;(j(e.slidesEl, '.swiper-slide, swiper-slide').forEach(D => {
      D.style[A] = `${B - Math.abs(e.cssOverflowAdjustment())}px`
    }),
      G())
  }
  function l(n) {
    if (typeof n == 'object' && 'length' in n)
      for (let o = 0; o < n.length; o += 1) n[o] && e.virtual.slides.push(n[o])
    else e.virtual.slides.push(n)
    d(!0)
  }
  function u(n) {
    const o = e.activeIndex
    let v = o + 1,
      b = 1
    if (Array.isArray(n)) {
      for (let g = 0; g < n.length; g += 1)
        n[g] && e.virtual.slides.unshift(n[g])
      ;((v = o + n.length), (b = n.length))
    } else e.virtual.slides.unshift(n)
    if (e.params.virtual.cache) {
      const g = e.virtual.cache,
        m = {}
      ;(Object.keys(g).forEach(y => {
        const x = g[y],
          O = x.getAttribute('data-swiper-slide-index')
        ;(O && x.setAttribute('data-swiper-slide-index', parseInt(O, 10) + b),
          (m[parseInt(y, 10) + b] = x))
      }),
        (e.virtual.cache = m))
    }
    ;(d(!0), e.slideTo(v, 0))
  }
  function w(n) {
    if (typeof n > 'u' || n === null) return
    let o = e.activeIndex
    if (Array.isArray(n))
      for (let v = n.length - 1; v >= 0; v -= 1)
        (e.params.virtual.cache &&
          (delete e.virtual.cache[n[v]],
          Object.keys(e.virtual.cache).forEach(b => {
            b > n &&
              ((e.virtual.cache[b - 1] = e.virtual.cache[b]),
              e.virtual.cache[b - 1].setAttribute(
                'data-swiper-slide-index',
                b - 1
              ),
              delete e.virtual.cache[b])
          })),
          e.virtual.slides.splice(n[v], 1),
          n[v] < o && (o -= 1),
          (o = Math.max(o, 0)))
    else
      (e.params.virtual.cache &&
        (delete e.virtual.cache[n],
        Object.keys(e.virtual.cache).forEach(v => {
          v > n &&
            ((e.virtual.cache[v - 1] = e.virtual.cache[v]),
            e.virtual.cache[v - 1].setAttribute(
              'data-swiper-slide-index',
              v - 1
            ),
            delete e.virtual.cache[v])
        })),
        e.virtual.slides.splice(n, 1),
        n < o && (o -= 1),
        (o = Math.max(o, 0)))
    ;(d(!0), e.slideTo(o, 0))
  }
  function h() {
    ;((e.virtual.slides = []),
      e.params.virtual.cache && (e.virtual.cache = {}),
      d(!0),
      e.slideTo(0, 0))
  }
  ;(s('beforeInit', () => {
    if (!e.params.virtual.enabled) return
    let n
    if (typeof e.passedParams.virtual.slides > 'u') {
      const o = [...e.slidesEl.children].filter(v =>
        v.matches(`.${e.params.slideClass}, swiper-slide`)
      )
      o &&
        o.length &&
        ((e.virtual.slides = [...o]),
        (n = !0),
        o.forEach((v, b) => {
          ;(v.setAttribute('data-swiper-slide-index', b),
            (e.virtual.cache[b] = v),
            v.remove())
        }))
    }
    ;(n || (e.virtual.slides = e.params.virtual.slides),
      e.classNames.push(`${e.params.containerModifierClass}virtual`),
      (e.params.watchSlidesProgress = !0),
      (e.originalParams.watchSlidesProgress = !0),
      d(!1, !0))
  }),
    s('setTranslate', () => {
      e.params.virtual.enabled &&
        (e.params.cssMode && !e._immediateVirtual
          ? (clearTimeout(a),
            (a = setTimeout(() => {
              d()
            }, 100)))
          : d())
    }),
    s('init update resize', () => {
      e.params.virtual.enabled &&
        e.params.cssMode &&
        Te(e.wrapperEl, '--swiper-virtual-size', `${e.virtualSize}px`)
    }),
    Object.assign(e.virtual, {
      appendSlide: l,
      prependSlide: u,
      removeSlide: w,
      removeAllSlides: h,
      update: d,
    }))
}
function Yi(i) {
  let { swiper: e, extendParams: t, on: s, emit: r } = i
  const a = W(),
    p = X()
  ;((e.keyboard = { enabled: !1 }),
    t({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }))
  function c(l) {
    if (!e.enabled) return
    const { rtlTranslate: u } = e
    let w = l
    w.originalEvent && (w = w.originalEvent)
    const h = w.keyCode || w.charCode,
      n = e.params.keyboard.pageUpDown,
      o = n && h === 33,
      v = n && h === 34,
      b = h === 37,
      g = h === 39,
      m = h === 38,
      y = h === 40
    if (
      (!e.allowSlideNext &&
        ((e.isHorizontal() && g) || (e.isVertical() && y) || v)) ||
      (!e.allowSlidePrev &&
        ((e.isHorizontal() && b) || (e.isVertical() && m) || o))
    )
      return !1
    if (
      !(w.shiftKey || w.altKey || w.ctrlKey || w.metaKey) &&
      !(
        a.activeElement &&
        (a.activeElement.isContentEditable ||
          (a.activeElement.nodeName &&
            (a.activeElement.nodeName.toLowerCase() === 'input' ||
              a.activeElement.nodeName.toLowerCase() === 'textarea')))
      )
    ) {
      if (e.params.keyboard.onlyInViewport && (o || v || b || g || m || y)) {
        let x = !1
        if (
          pe(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 &&
          pe(e.el, `.${e.params.slideActiveClass}`).length === 0
        )
          return
        const O = e.el,
          L = O.clientWidth,
          z = O.clientHeight,
          S = p.innerWidth,
          T = p.innerHeight,
          I = $e(O)
        u && (I.left -= O.scrollLeft)
        const P = [
          [I.left, I.top],
          [I.left + L, I.top],
          [I.left, I.top + z],
          [I.left + L, I.top + z],
        ]
        for (let C = 0; C < P.length; C += 1) {
          const A = P[C]
          if (A[0] >= 0 && A[0] <= S && A[1] >= 0 && A[1] <= T) {
            if (A[0] === 0 && A[1] === 0) continue
            x = !0
          }
        }
        if (!x) return
      }
      ;(e.isHorizontal()
        ? ((o || v || b || g) &&
            (w.preventDefault ? w.preventDefault() : (w.returnValue = !1)),
          (((v || g) && !u) || ((o || b) && u)) && e.slideNext(),
          (((o || b) && !u) || ((v || g) && u)) && e.slidePrev())
        : ((o || v || m || y) &&
            (w.preventDefault ? w.preventDefault() : (w.returnValue = !1)),
          (v || y) && e.slideNext(),
          (o || m) && e.slidePrev()),
        r('keyPress', h))
    }
  }
  function f() {
    e.keyboard.enabled ||
      (a.addEventListener('keydown', c), (e.keyboard.enabled = !0))
  }
  function d() {
    e.keyboard.enabled &&
      (a.removeEventListener('keydown', c), (e.keyboard.enabled = !1))
  }
  ;(s('init', () => {
    e.params.keyboard.enabled && f()
  }),
    s('destroy', () => {
      e.keyboard.enabled && d()
    }),
    Object.assign(e.keyboard, { enable: f, disable: d }))
}
function Ni(i) {
  let { swiper: e, extendParams: t, on: s, emit: r } = i
  const a = X()
  ;(t({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: 'swiper-no-mousewheel',
    },
  }),
    (e.mousewheel = { enabled: !1 }))
  let p,
    c = J(),
    f
  const d = []
  function l(m) {
    let L = 0,
      z = 0,
      S = 0,
      T = 0
    return (
      'detail' in m && (z = m.detail),
      'wheelDelta' in m && (z = -m.wheelDelta / 120),
      'wheelDeltaY' in m && (z = -m.wheelDeltaY / 120),
      'wheelDeltaX' in m && (L = -m.wheelDeltaX / 120),
      'axis' in m && m.axis === m.HORIZONTAL_AXIS && ((L = z), (z = 0)),
      (S = L * 10),
      (T = z * 10),
      'deltaY' in m && (T = m.deltaY),
      'deltaX' in m && (S = m.deltaX),
      m.shiftKey && !S && ((S = T), (T = 0)),
      (S || T) &&
        m.deltaMode &&
        (m.deltaMode === 1 ? ((S *= 40), (T *= 40)) : ((S *= 800), (T *= 800))),
      S && !L && (L = S < 1 ? -1 : 1),
      T && !z && (z = T < 1 ? -1 : 1),
      { spinX: L, spinY: z, pixelX: S, pixelY: T }
    )
  }
  function u() {
    e.enabled && (e.mouseEntered = !0)
  }
  function w() {
    e.enabled && (e.mouseEntered = !1)
  }
  function h(m) {
    return (e.params.mousewheel.thresholdDelta &&
      m.delta < e.params.mousewheel.thresholdDelta) ||
      (e.params.mousewheel.thresholdTime &&
        J() - c < e.params.mousewheel.thresholdTime)
      ? !1
      : m.delta >= 6 && J() - c < 60
        ? !0
        : (m.direction < 0
            ? (!e.isEnd || e.params.loop) &&
              !e.animating &&
              (e.slideNext(), r('scroll', m.raw))
            : (!e.isBeginning || e.params.loop) &&
              !e.animating &&
              (e.slidePrev(), r('scroll', m.raw)),
          (c = new a.Date().getTime()),
          !1)
  }
  function n(m) {
    const y = e.params.mousewheel
    if (m.direction < 0) {
      if (e.isEnd && !e.params.loop && y.releaseOnEdges) return !0
    } else if (e.isBeginning && !e.params.loop && y.releaseOnEdges) return !0
    return !1
  }
  function o(m) {
    let y = m,
      x = !0
    if (
      !e.enabled ||
      m.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)
    )
      return
    const O = e.params.mousewheel
    e.params.cssMode && y.preventDefault()
    let L = e.el
    e.params.mousewheel.eventsTarget !== 'container' &&
      (L = document.querySelector(e.params.mousewheel.eventsTarget))
    const z = L && L.contains(y.target)
    if (!e.mouseEntered && !z && !O.releaseOnEdges) return !0
    y.originalEvent && (y = y.originalEvent)
    let S = 0
    const T = e.rtlTranslate ? -1 : 1,
      I = l(y)
    if (O.forceToAxis)
      if (e.isHorizontal())
        if (Math.abs(I.pixelX) > Math.abs(I.pixelY)) S = -I.pixelX * T
        else return !0
      else if (Math.abs(I.pixelY) > Math.abs(I.pixelX)) S = -I.pixelY
      else return !0
    else S = Math.abs(I.pixelX) > Math.abs(I.pixelY) ? -I.pixelX * T : -I.pixelY
    if (S === 0) return !0
    O.invert && (S = -S)
    let P = e.getTranslate() + S * O.sensitivity
    if (
      (P >= e.minTranslate() && (P = e.minTranslate()),
      P <= e.maxTranslate() && (P = e.maxTranslate()),
      (x = e.params.loop
        ? !0
        : !(P === e.minTranslate() || P === e.maxTranslate())),
      x && e.params.nested && y.stopPropagation(),
      !e.params.freeMode || !e.params.freeMode.enabled)
    ) {
      const C = {
        time: J(),
        delta: Math.abs(S),
        direction: Math.sign(S),
        raw: m,
      }
      d.length >= 2 && d.shift()
      const A = d.length ? d[d.length - 1] : void 0
      if (
        (d.push(C),
        A
          ? (C.direction !== A.direction ||
              C.delta > A.delta ||
              C.time > A.time + 150) &&
            h(C)
          : h(C),
        n(C))
      )
        return !0
    } else {
      const C = { time: J(), delta: Math.abs(S), direction: Math.sign(S) },
        A =
          f &&
          C.time < f.time + 500 &&
          C.delta <= f.delta &&
          C.direction === f.direction
      if (!A) {
        f = void 0
        let $ = e.getTranslate() + S * O.sensitivity
        const k = e.isBeginning,
          E = e.isEnd
        if (
          ($ >= e.minTranslate() && ($ = e.minTranslate()),
          $ <= e.maxTranslate() && ($ = e.maxTranslate()),
          e.setTransition(0),
          e.setTranslate($),
          e.updateProgress(),
          e.updateActiveIndex(),
          e.updateSlidesClasses(),
          ((!k && e.isBeginning) || (!E && e.isEnd)) && e.updateSlidesClasses(),
          e.params.loop &&
            e.loopFix({
              direction: C.direction < 0 ? 'next' : 'prev',
              byMousewheel: !0,
            }),
          e.params.freeMode.sticky)
        ) {
          ;(clearTimeout(p), (p = void 0), d.length >= 15 && d.shift())
          const M = d.length ? d[d.length - 1] : void 0,
            B = d[0]
          if (
            (d.push(C), M && (C.delta > M.delta || C.direction !== M.direction))
          )
            d.splice(0)
          else if (
            d.length >= 15 &&
            C.time - B.time < 500 &&
            B.delta - C.delta >= 1 &&
            C.delta <= 6
          ) {
            const G = S > 0 ? 0.8 : 0.2
            ;((f = C),
              d.splice(0),
              (p = ge(() => {
                e.destroyed ||
                  !e.params ||
                  e.slideToClosest(e.params.speed, !0, void 0, G)
              }, 0)))
          }
          p ||
            (p = ge(() => {
              if (e.destroyed || !e.params) return
              const G = 0.5
              ;((f = C),
                d.splice(0),
                e.slideToClosest(e.params.speed, !0, void 0, G))
            }, 500))
        }
        if (
          (A || r('scroll', y),
          e.params.autoplay &&
            e.params.autoplay.disableOnInteraction &&
            e.autoplay.stop(),
          O.releaseOnEdges &&
            ($ === e.minTranslate() || $ === e.maxTranslate()))
        )
          return !0
      }
    }
    return (y.preventDefault ? y.preventDefault() : (y.returnValue = !1), !1)
  }
  function v(m) {
    let y = e.el
    ;(e.params.mousewheel.eventsTarget !== 'container' &&
      (y = document.querySelector(e.params.mousewheel.eventsTarget)),
      y[m]('mouseenter', u),
      y[m]('mouseleave', w),
      y[m]('wheel', o))
  }
  function b() {
    return e.params.cssMode
      ? (e.wrapperEl.removeEventListener('wheel', o), !0)
      : e.mousewheel.enabled
        ? !1
        : (v('addEventListener'), (e.mousewheel.enabled = !0), !0)
  }
  function g() {
    return e.params.cssMode
      ? (e.wrapperEl.addEventListener(event, o), !0)
      : e.mousewheel.enabled
        ? (v('removeEventListener'), (e.mousewheel.enabled = !1), !0)
        : !1
  }
  ;(s('init', () => {
    ;(!e.params.mousewheel.enabled && e.params.cssMode && g(),
      e.params.mousewheel.enabled && b())
  }),
    s('destroy', () => {
      ;(e.params.cssMode && b(), e.mousewheel.enabled && g())
    }),
    Object.assign(e.mousewheel, { enable: b, disable: g }))
}
function st(i, e, t, s) {
  return (
    i.params.createElements &&
      Object.keys(s).forEach(r => {
        if (!t[r] && t.auto === !0) {
          let a = j(i.el, `.${s[r]}`)[0]
          ;(a || ((a = Q('div', s[r])), (a.className = s[r]), i.el.append(a)),
            (t[r] = a),
            (e[r] = a))
        }
      }),
    t
  )
}
function Fi(i) {
  let { swiper: e, extendParams: t, on: s, emit: r } = i
  ;(t({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled',
    },
  }),
    (e.navigation = { nextEl: null, prevEl: null }))
  function a(n) {
    let o
    return n &&
      typeof n == 'string' &&
      e.isElement &&
      ((o = e.el.querySelector(n) || e.hostEl.querySelector(n)), o)
      ? o
      : (n &&
          (typeof n == 'string' && (o = [...document.querySelectorAll(n)]),
          e.params.uniqueNavElements &&
          typeof n == 'string' &&
          o &&
          o.length > 1 &&
          e.el.querySelectorAll(n).length === 1
            ? (o = e.el.querySelector(n))
            : o && o.length === 1 && (o = o[0])),
        n && !o ? n : o)
  }
  function p(n, o) {
    const v = e.params.navigation
    ;((n = H(n)),
      n.forEach(b => {
        b &&
          (b.classList[o ? 'add' : 'remove'](...v.disabledClass.split(' ')),
          b.tagName === 'BUTTON' && (b.disabled = o),
          e.params.watchOverflow &&
            e.enabled &&
            b.classList[e.isLocked ? 'add' : 'remove'](v.lockClass))
      }))
  }
  function c() {
    const { nextEl: n, prevEl: o } = e.navigation
    if (e.params.loop) {
      ;(p(o, !1), p(n, !1))
      return
    }
    ;(p(o, e.isBeginning && !e.params.rewind),
      p(n, e.isEnd && !e.params.rewind))
  }
  function f(n) {
    ;(n.preventDefault(),
      !(e.isBeginning && !e.params.loop && !e.params.rewind) &&
        (e.slidePrev(), r('navigationPrev')))
  }
  function d(n) {
    ;(n.preventDefault(),
      !(e.isEnd && !e.params.loop && !e.params.rewind) &&
        (e.slideNext(), r('navigationNext')))
  }
  function l() {
    const n = e.params.navigation
    if (
      ((e.params.navigation = st(
        e,
        e.originalParams.navigation,
        e.params.navigation,
        { nextEl: 'swiper-button-next', prevEl: 'swiper-button-prev' }
      )),
      !(n.nextEl || n.prevEl))
    )
      return
    let o = a(n.nextEl),
      v = a(n.prevEl)
    ;(Object.assign(e.navigation, { nextEl: o, prevEl: v }),
      (o = H(o)),
      (v = H(v)))
    const b = (g, m) => {
      ;(g && g.addEventListener('click', m === 'next' ? d : f),
        !e.enabled && g && g.classList.add(...n.lockClass.split(' ')))
    }
    ;(o.forEach(g => b(g, 'next')), v.forEach(g => b(g, 'prev')))
  }
  function u() {
    let { nextEl: n, prevEl: o } = e.navigation
    ;((n = H(n)), (o = H(o)))
    const v = (b, g) => {
      ;(b.removeEventListener('click', g === 'next' ? d : f),
        b.classList.remove(...e.params.navigation.disabledClass.split(' ')))
    }
    ;(n.forEach(b => v(b, 'next')), o.forEach(b => v(b, 'prev')))
  }
  ;(s('init', () => {
    e.params.navigation.enabled === !1 ? h() : (l(), c())
  }),
    s('toEdge fromEdge lock unlock', () => {
      c()
    }),
    s('destroy', () => {
      u()
    }),
    s('enable disable', () => {
      let { nextEl: n, prevEl: o } = e.navigation
      if (((n = H(n)), (o = H(o)), e.enabled)) {
        c()
        return
      }
      ;[...n, ...o]
        .filter(v => !!v)
        .forEach(v => v.classList.add(e.params.navigation.lockClass))
    }),
    s('click', (n, o) => {
      let { nextEl: v, prevEl: b } = e.navigation
      ;((v = H(v)), (b = H(b)))
      const g = o.target
      let m = b.includes(g) || v.includes(g)
      if (e.isElement && !m) {
        const y = o.path || (o.composedPath && o.composedPath())
        y && (m = y.find(x => v.includes(x) || b.includes(x)))
      }
      if (e.params.navigation.hideOnClick && !m) {
        if (
          e.pagination &&
          e.params.pagination &&
          e.params.pagination.clickable &&
          (e.pagination.el === g || e.pagination.el.contains(g))
        )
          return
        let y
        ;(v.length
          ? (y = v[0].classList.contains(e.params.navigation.hiddenClass))
          : b.length &&
            (y = b[0].classList.contains(e.params.navigation.hiddenClass)),
          r(y === !0 ? 'navigationShow' : 'navigationHide'),
          [...v, ...b]
            .filter(x => !!x)
            .forEach(x => x.classList.toggle(e.params.navigation.hiddenClass)))
      }
    }))
  const w = () => {
      ;(e.el.classList.remove(
        ...e.params.navigation.navigationDisabledClass.split(' ')
      ),
        l(),
        c())
    },
    h = () => {
      ;(e.el.classList.add(
        ...e.params.navigation.navigationDisabledClass.split(' ')
      ),
        u())
    }
  Object.assign(e.navigation, {
    enable: w,
    disable: h,
    update: c,
    init: l,
    destroy: u,
  })
}
function ae(i) {
  return (
    i === void 0 && (i = ''),
    `.${i
      .trim()
      .replace(/([\.:!+\/()[\]])/g, '\\$1')
      .replace(/ /g, '.')}`
  )
}
function Wi(i) {
  let { swiper: e, extendParams: t, on: s, emit: r } = i
  const a = 'swiper-pagination'
  ;(t({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: 'bullets',
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: g => g,
      formatFractionTotal: g => g,
      bulletClass: `${a}-bullet`,
      bulletActiveClass: `${a}-bullet-active`,
      modifierClass: `${a}-`,
      currentClass: `${a}-current`,
      totalClass: `${a}-total`,
      hiddenClass: `${a}-hidden`,
      progressbarFillClass: `${a}-progressbar-fill`,
      progressbarOppositeClass: `${a}-progressbar-opposite`,
      clickableClass: `${a}-clickable`,
      lockClass: `${a}-lock`,
      horizontalClass: `${a}-horizontal`,
      verticalClass: `${a}-vertical`,
      paginationDisabledClass: `${a}-disabled`,
    },
  }),
    (e.pagination = { el: null, bullets: [] }))
  let p,
    c = 0
  function f() {
    return (
      !e.params.pagination.el ||
      !e.pagination.el ||
      (Array.isArray(e.pagination.el) && e.pagination.el.length === 0)
    )
  }
  function d(g, m) {
    const { bulletActiveClass: y } = e.params.pagination
    g &&
      ((g = g[`${m === 'prev' ? 'previous' : 'next'}ElementSibling`]),
      g &&
        (g.classList.add(`${y}-${m}`),
        (g = g[`${m === 'prev' ? 'previous' : 'next'}ElementSibling`]),
        g && g.classList.add(`${y}-${m}-${m}`)))
  }
  function l(g, m, y) {
    if (((g = g % y), (m = m % y), m === g + 1)) return 'next'
    if (m === g - 1) return 'previous'
  }
  function u(g) {
    const m = g.target.closest(ae(e.params.pagination.bulletClass))
    if (!m) return
    g.preventDefault()
    const y = Ce(m) * e.params.slidesPerGroup
    if (e.params.loop) {
      if (e.realIndex === y) return
      const x = l(e.realIndex, y, e.slides.length)
      x === 'next'
        ? e.slideNext()
        : x === 'previous'
          ? e.slidePrev()
          : e.slideToLoop(y)
    } else e.slideTo(y)
  }
  function w() {
    const g = e.rtl,
      m = e.params.pagination
    if (f()) return
    let y = e.pagination.el
    y = H(y)
    let x, O
    const L =
        e.virtual && e.params.virtual.enabled
          ? e.virtual.slides.length
          : e.slides.length,
      z = e.params.loop
        ? Math.ceil(L / e.params.slidesPerGroup)
        : e.snapGrid.length
    if (
      (e.params.loop
        ? ((O = e.previousRealIndex || 0),
          (x =
            e.params.slidesPerGroup > 1
              ? Math.floor(e.realIndex / e.params.slidesPerGroup)
              : e.realIndex))
        : typeof e.snapIndex < 'u'
          ? ((x = e.snapIndex), (O = e.previousSnapIndex))
          : ((O = e.previousIndex || 0), (x = e.activeIndex || 0)),
      m.type === 'bullets' &&
        e.pagination.bullets &&
        e.pagination.bullets.length > 0)
    ) {
      const S = e.pagination.bullets
      let T, I, P
      if (
        (m.dynamicBullets &&
          ((p = Qe(S[0], e.isHorizontal() ? 'width' : 'height')),
          y.forEach(C => {
            C.style[e.isHorizontal() ? 'width' : 'height'] =
              `${p * (m.dynamicMainBullets + 4)}px`
          }),
          m.dynamicMainBullets > 1 &&
            O !== void 0 &&
            ((c += x - (O || 0)),
            c > m.dynamicMainBullets - 1
              ? (c = m.dynamicMainBullets - 1)
              : c < 0 && (c = 0)),
          (T = Math.max(x - c, 0)),
          (I = T + (Math.min(S.length, m.dynamicMainBullets) - 1)),
          (P = (I + T) / 2)),
        S.forEach(C => {
          const A = [
            ...['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(
              $ => `${m.bulletActiveClass}${$}`
            ),
          ]
            .map($ =>
              typeof $ == 'string' && $.includes(' ') ? $.split(' ') : $
            )
            .flat()
          C.classList.remove(...A)
        }),
        y.length > 1)
      )
        S.forEach(C => {
          const A = Ce(C)
          ;(A === x
            ? C.classList.add(...m.bulletActiveClass.split(' '))
            : e.isElement && C.setAttribute('part', 'bullet'),
            m.dynamicBullets &&
              (A >= T &&
                A <= I &&
                C.classList.add(...`${m.bulletActiveClass}-main`.split(' ')),
              A === T && d(C, 'prev'),
              A === I && d(C, 'next')))
        })
      else {
        const C = S[x]
        if (
          (C && C.classList.add(...m.bulletActiveClass.split(' ')),
          e.isElement &&
            S.forEach((A, $) => {
              A.setAttribute('part', $ === x ? 'bullet-active' : 'bullet')
            }),
          m.dynamicBullets)
        ) {
          const A = S[T],
            $ = S[I]
          for (let k = T; k <= I; k += 1)
            S[k] &&
              S[k].classList.add(...`${m.bulletActiveClass}-main`.split(' '))
          ;(d(A, 'prev'), d($, 'next'))
        }
      }
      if (m.dynamicBullets) {
        const C = Math.min(S.length, m.dynamicMainBullets + 4),
          A = (p * C - p) / 2 - P * p,
          $ = g ? 'right' : 'left'
        S.forEach(k => {
          k.style[e.isHorizontal() ? $ : 'top'] = `${A}px`
        })
      }
    }
    y.forEach((S, T) => {
      if (
        (m.type === 'fraction' &&
          (S.querySelectorAll(ae(m.currentClass)).forEach(I => {
            I.textContent = m.formatFractionCurrent(x + 1)
          }),
          S.querySelectorAll(ae(m.totalClass)).forEach(I => {
            I.textContent = m.formatFractionTotal(z)
          })),
        m.type === 'progressbar')
      ) {
        let I
        m.progressbarOpposite
          ? (I = e.isHorizontal() ? 'vertical' : 'horizontal')
          : (I = e.isHorizontal() ? 'horizontal' : 'vertical')
        const P = (x + 1) / z
        let C = 1,
          A = 1
        ;(I === 'horizontal' ? (C = P) : (A = P),
          S.querySelectorAll(ae(m.progressbarFillClass)).forEach($ => {
            ;(($.style.transform = `translate3d(0,0,0) scaleX(${C}) scaleY(${A})`),
              ($.style.transitionDuration = `${e.params.speed}ms`))
          }))
      }
      ;(m.type === 'custom' && m.renderCustom
        ? (ee(S, m.renderCustom(e, x + 1, z)),
          T === 0 && r('paginationRender', S))
        : (T === 0 && r('paginationRender', S), r('paginationUpdate', S)),
        e.params.watchOverflow &&
          e.enabled &&
          S.classList[e.isLocked ? 'add' : 'remove'](m.lockClass))
    })
  }
  function h() {
    const g = e.params.pagination
    if (f()) return
    const m =
      e.virtual && e.params.virtual.enabled
        ? e.virtual.slides.length
        : e.grid && e.params.grid.rows > 1
          ? e.slides.length / Math.ceil(e.params.grid.rows)
          : e.slides.length
    let y = e.pagination.el
    y = H(y)
    let x = ''
    if (g.type === 'bullets') {
      let O = e.params.loop
        ? Math.ceil(m / e.params.slidesPerGroup)
        : e.snapGrid.length
      e.params.freeMode && e.params.freeMode.enabled && O > m && (O = m)
      for (let L = 0; L < O; L += 1)
        g.renderBullet
          ? (x += g.renderBullet.call(e, L, g.bulletClass))
          : (x += `<${g.bulletElement} ${e.isElement ? 'part="bullet"' : ''} class="${g.bulletClass}"></${g.bulletElement}>`)
    }
    ;(g.type === 'fraction' &&
      (g.renderFraction
        ? (x = g.renderFraction.call(e, g.currentClass, g.totalClass))
        : (x = `<span class="${g.currentClass}"></span> / <span class="${g.totalClass}"></span>`)),
      g.type === 'progressbar' &&
        (g.renderProgressbar
          ? (x = g.renderProgressbar.call(e, g.progressbarFillClass))
          : (x = `<span class="${g.progressbarFillClass}"></span>`)),
      (e.pagination.bullets = []),
      y.forEach(O => {
        ;(g.type !== 'custom' && ee(O, x || ''),
          g.type === 'bullets' &&
            e.pagination.bullets.push(...O.querySelectorAll(ae(g.bulletClass))))
      }),
      g.type !== 'custom' && r('paginationRender', y[0]))
  }
  function n() {
    e.params.pagination = st(
      e,
      e.originalParams.pagination,
      e.params.pagination,
      { el: 'swiper-pagination' }
    )
    const g = e.params.pagination
    if (!g.el) return
    let m
    ;(typeof g.el == 'string' && e.isElement && (m = e.el.querySelector(g.el)),
      !m &&
        typeof g.el == 'string' &&
        (m = [...document.querySelectorAll(g.el)]),
      m || (m = g.el),
      !(!m || m.length === 0) &&
        (e.params.uniqueNavElements &&
          typeof g.el == 'string' &&
          Array.isArray(m) &&
          m.length > 1 &&
          ((m = [...e.el.querySelectorAll(g.el)]),
          m.length > 1 && (m = m.find(y => pe(y, '.swiper')[0] === e.el))),
        Array.isArray(m) && m.length === 1 && (m = m[0]),
        Object.assign(e.pagination, { el: m }),
        (m = H(m)),
        m.forEach(y => {
          ;(g.type === 'bullets' &&
            g.clickable &&
            y.classList.add(...(g.clickableClass || '').split(' ')),
            y.classList.add(g.modifierClass + g.type),
            y.classList.add(
              e.isHorizontal() ? g.horizontalClass : g.verticalClass
            ),
            g.type === 'bullets' &&
              g.dynamicBullets &&
              (y.classList.add(`${g.modifierClass}${g.type}-dynamic`),
              (c = 0),
              g.dynamicMainBullets < 1 && (g.dynamicMainBullets = 1)),
            g.type === 'progressbar' &&
              g.progressbarOpposite &&
              y.classList.add(g.progressbarOppositeClass),
            g.clickable && y.addEventListener('click', u),
            e.enabled || y.classList.add(g.lockClass))
        })))
  }
  function o() {
    const g = e.params.pagination
    if (f()) return
    let m = e.pagination.el
    ;(m &&
      ((m = H(m)),
      m.forEach(y => {
        ;(y.classList.remove(g.hiddenClass),
          y.classList.remove(g.modifierClass + g.type),
          y.classList.remove(
            e.isHorizontal() ? g.horizontalClass : g.verticalClass
          ),
          g.clickable &&
            (y.classList.remove(...(g.clickableClass || '').split(' ')),
            y.removeEventListener('click', u)))
      })),
      e.pagination.bullets &&
        e.pagination.bullets.forEach(y =>
          y.classList.remove(...g.bulletActiveClass.split(' '))
        ))
  }
  ;(s('changeDirection', () => {
    if (!e.pagination || !e.pagination.el) return
    const g = e.params.pagination
    let { el: m } = e.pagination
    ;((m = H(m)),
      m.forEach(y => {
        ;(y.classList.remove(g.horizontalClass, g.verticalClass),
          y.classList.add(
            e.isHorizontal() ? g.horizontalClass : g.verticalClass
          ))
      }))
  }),
    s('init', () => {
      e.params.pagination.enabled === !1 ? b() : (n(), h(), w())
    }),
    s('activeIndexChange', () => {
      typeof e.snapIndex > 'u' && w()
    }),
    s('snapIndexChange', () => {
      w()
    }),
    s('snapGridLengthChange', () => {
      ;(h(), w())
    }),
    s('destroy', () => {
      o()
    }),
    s('enable disable', () => {
      let { el: g } = e.pagination
      g &&
        ((g = H(g)),
        g.forEach(m =>
          m.classList[e.enabled ? 'remove' : 'add'](
            e.params.pagination.lockClass
          )
        ))
    }),
    s('lock unlock', () => {
      w()
    }),
    s('click', (g, m) => {
      const y = m.target,
        x = H(e.pagination.el)
      if (
        e.params.pagination.el &&
        e.params.pagination.hideOnClick &&
        x &&
        x.length > 0 &&
        !y.classList.contains(e.params.pagination.bulletClass)
      ) {
        if (
          e.navigation &&
          ((e.navigation.nextEl && y === e.navigation.nextEl) ||
            (e.navigation.prevEl && y === e.navigation.prevEl))
        )
          return
        const O = x[0].classList.contains(e.params.pagination.hiddenClass)
        ;(r(O === !0 ? 'paginationShow' : 'paginationHide'),
          x.forEach(L => L.classList.toggle(e.params.pagination.hiddenClass)))
      }
    }))
  const v = () => {
      e.el.classList.remove(e.params.pagination.paginationDisabledClass)
      let { el: g } = e.pagination
      ;(g &&
        ((g = H(g)),
        g.forEach(m =>
          m.classList.remove(e.params.pagination.paginationDisabledClass)
        )),
        n(),
        h(),
        w())
    },
    b = () => {
      e.el.classList.add(e.params.pagination.paginationDisabledClass)
      let { el: g } = e.pagination
      ;(g &&
        ((g = H(g)),
        g.forEach(m =>
          m.classList.add(e.params.pagination.paginationDisabledClass)
        )),
        o())
    }
  Object.assign(e.pagination, {
    enable: v,
    disable: b,
    render: h,
    update: w,
    init: n,
    destroy: o,
  })
}
function ji(i) {
  let { swiper: e, extendParams: t, on: s, emit: r } = i
  const a = W()
  let p = !1,
    c = null,
    f = null,
    d,
    l,
    u,
    w
  ;(t({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: 'swiper-scrollbar-horizontal',
      verticalClass: 'swiper-scrollbar-vertical',
    },
  }),
    (e.scrollbar = { el: null, dragEl: null }))
  function h() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return
    const { scrollbar: P, rtlTranslate: C } = e,
      { dragEl: A, el: $ } = P,
      k = e.params.scrollbar,
      E = e.params.loop ? e.progressLoop : e.progress
    let M = l,
      B = (u - l) * E
    ;(C
      ? ((B = -B), B > 0 ? ((M = l - B), (B = 0)) : -B + l > u && (M = u + B))
      : B < 0
        ? ((M = l + B), (B = 0))
        : B + l > u && (M = u - B),
      e.isHorizontal()
        ? ((A.style.transform = `translate3d(${B}px, 0, 0)`),
          (A.style.width = `${M}px`))
        : ((A.style.transform = `translate3d(0px, ${B}px, 0)`),
          (A.style.height = `${M}px`)),
      k.hide &&
        (clearTimeout(c),
        ($.style.opacity = 1),
        (c = setTimeout(() => {
          ;(($.style.opacity = 0), ($.style.transitionDuration = '400ms'))
        }, 1e3))))
  }
  function n(P) {
    !e.params.scrollbar.el ||
      !e.scrollbar.el ||
      (e.scrollbar.dragEl.style.transitionDuration = `${P}ms`)
  }
  function o() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return
    const { scrollbar: P } = e,
      { dragEl: C, el: A } = P
    ;((C.style.width = ''),
      (C.style.height = ''),
      (u = e.isHorizontal() ? A.offsetWidth : A.offsetHeight),
      (w =
        e.size /
        (e.virtualSize +
          e.params.slidesOffsetBefore -
          (e.params.centeredSlides ? e.snapGrid[0] : 0))),
      e.params.scrollbar.dragSize === 'auto'
        ? (l = u * w)
        : (l = parseInt(e.params.scrollbar.dragSize, 10)),
      e.isHorizontal()
        ? (C.style.width = `${l}px`)
        : (C.style.height = `${l}px`),
      w >= 1 ? (A.style.display = 'none') : (A.style.display = ''),
      e.params.scrollbar.hide && (A.style.opacity = 0),
      e.params.watchOverflow &&
        e.enabled &&
        P.el.classList[e.isLocked ? 'add' : 'remove'](
          e.params.scrollbar.lockClass
        ))
  }
  function v(P) {
    return e.isHorizontal() ? P.clientX : P.clientY
  }
  function b(P) {
    const { scrollbar: C, rtlTranslate: A } = e,
      { el: $ } = C
    let k
    ;((k =
      (v(P) -
        $e($)[e.isHorizontal() ? 'left' : 'top'] -
        (d !== null ? d : l / 2)) /
      (u - l)),
      (k = Math.max(Math.min(k, 1), 0)),
      A && (k = 1 - k))
    const E = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * k
    ;(e.updateProgress(E),
      e.setTranslate(E),
      e.updateActiveIndex(),
      e.updateSlidesClasses())
  }
  function g(P) {
    const C = e.params.scrollbar,
      { scrollbar: A, wrapperEl: $ } = e,
      { el: k, dragEl: E } = A
    ;((p = !0),
      (d =
        P.target === E
          ? v(P) -
            P.target.getBoundingClientRect()[e.isHorizontal() ? 'left' : 'top']
          : null),
      P.preventDefault(),
      P.stopPropagation(),
      ($.style.transitionDuration = '100ms'),
      (E.style.transitionDuration = '100ms'),
      b(P),
      clearTimeout(f),
      (k.style.transitionDuration = '0ms'),
      C.hide && (k.style.opacity = 1),
      e.params.cssMode && (e.wrapperEl.style['scroll-snap-type'] = 'none'),
      r('scrollbarDragStart', P))
  }
  function m(P) {
    const { scrollbar: C, wrapperEl: A } = e,
      { el: $, dragEl: k } = C
    p &&
      (P.preventDefault && P.cancelable
        ? P.preventDefault()
        : (P.returnValue = !1),
      b(P),
      (A.style.transitionDuration = '0ms'),
      ($.style.transitionDuration = '0ms'),
      (k.style.transitionDuration = '0ms'),
      r('scrollbarDragMove', P))
  }
  function y(P) {
    const C = e.params.scrollbar,
      { scrollbar: A, wrapperEl: $ } = e,
      { el: k } = A
    p &&
      ((p = !1),
      e.params.cssMode &&
        ((e.wrapperEl.style['scroll-snap-type'] = ''),
        ($.style.transitionDuration = '')),
      C.hide &&
        (clearTimeout(f),
        (f = ge(() => {
          ;((k.style.opacity = 0), (k.style.transitionDuration = '400ms'))
        }, 1e3))),
      r('scrollbarDragEnd', P),
      C.snapOnRelease && e.slideToClosest())
  }
  function x(P) {
    const { scrollbar: C, params: A } = e,
      $ = C.el
    if (!$) return
    const k = $,
      E = A.passiveListeners ? { passive: !1, capture: !1 } : !1,
      M = A.passiveListeners ? { passive: !0, capture: !1 } : !1
    if (!k) return
    const B = P === 'on' ? 'addEventListener' : 'removeEventListener'
    ;(k[B]('pointerdown', g, E),
      a[B]('pointermove', m, E),
      a[B]('pointerup', y, M))
  }
  function O() {
    !e.params.scrollbar.el || !e.scrollbar.el || x('on')
  }
  function L() {
    !e.params.scrollbar.el || !e.scrollbar.el || x('off')
  }
  function z() {
    const { scrollbar: P, el: C } = e
    e.params.scrollbar = st(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: 'swiper-scrollbar',
    })
    const A = e.params.scrollbar
    if (!A.el) return
    let $
    if (
      (typeof A.el == 'string' && e.isElement && ($ = e.el.querySelector(A.el)),
      !$ && typeof A.el == 'string')
    ) {
      if ((($ = a.querySelectorAll(A.el)), !$.length)) return
    } else $ || ($ = A.el)
    ;(e.params.uniqueNavElements &&
      typeof A.el == 'string' &&
      $.length > 1 &&
      C.querySelectorAll(A.el).length === 1 &&
      ($ = C.querySelector(A.el)),
      $.length > 0 && ($ = $[0]),
      $.classList.add(e.isHorizontal() ? A.horizontalClass : A.verticalClass))
    let k
    ;($ &&
      ((k = $.querySelector(ae(e.params.scrollbar.dragClass))),
      k || ((k = Q('div', e.params.scrollbar.dragClass)), $.append(k))),
      Object.assign(P, { el: $, dragEl: k }),
      A.draggable && O(),
      $ &&
        $.classList[e.enabled ? 'remove' : 'add'](
          ...de(e.params.scrollbar.lockClass)
        ))
  }
  function S() {
    const P = e.params.scrollbar,
      C = e.scrollbar.el
    ;(C &&
      C.classList.remove(
        ...de(e.isHorizontal() ? P.horizontalClass : P.verticalClass)
      ),
      L())
  }
  ;(s('changeDirection', () => {
    if (!e.scrollbar || !e.scrollbar.el) return
    const P = e.params.scrollbar
    let { el: C } = e.scrollbar
    ;((C = H(C)),
      C.forEach(A => {
        ;(A.classList.remove(P.horizontalClass, P.verticalClass),
          A.classList.add(
            e.isHorizontal() ? P.horizontalClass : P.verticalClass
          ))
      }))
  }),
    s('init', () => {
      e.params.scrollbar.enabled === !1 ? I() : (z(), o(), h())
    }),
    s('update resize observerUpdate lock unlock changeDirection', () => {
      o()
    }),
    s('setTranslate', () => {
      h()
    }),
    s('setTransition', (P, C) => {
      n(C)
    }),
    s('enable disable', () => {
      const { el: P } = e.scrollbar
      P &&
        P.classList[e.enabled ? 'remove' : 'add'](
          ...de(e.params.scrollbar.lockClass)
        )
    }),
    s('destroy', () => {
      S()
    }))
  const T = () => {
      ;(e.el.classList.remove(...de(e.params.scrollbar.scrollbarDisabledClass)),
        e.scrollbar.el &&
          e.scrollbar.el.classList.remove(
            ...de(e.params.scrollbar.scrollbarDisabledClass)
          ),
        z(),
        o(),
        h())
    },
    I = () => {
      ;(e.el.classList.add(...de(e.params.scrollbar.scrollbarDisabledClass)),
        e.scrollbar.el &&
          e.scrollbar.el.classList.add(
            ...de(e.params.scrollbar.scrollbarDisabledClass)
          ),
        S())
    }
  Object.assign(e.scrollbar, {
    enable: T,
    disable: I,
    updateSize: o,
    setTranslate: h,
    init: z,
    destroy: S,
  })
}
function qi(i) {
  let { swiper: e, extendParams: t, on: s } = i
  t({ parallax: { enabled: !1 } })
  const r =
      '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]',
    a = (f, d) => {
      const { rtl: l } = e,
        u = l ? -1 : 1,
        w = f.getAttribute('data-swiper-parallax') || '0'
      let h = f.getAttribute('data-swiper-parallax-x'),
        n = f.getAttribute('data-swiper-parallax-y')
      const o = f.getAttribute('data-swiper-parallax-scale'),
        v = f.getAttribute('data-swiper-parallax-opacity'),
        b = f.getAttribute('data-swiper-parallax-rotate')
      if (
        (h || n
          ? ((h = h || '0'), (n = n || '0'))
          : e.isHorizontal()
            ? ((h = w), (n = '0'))
            : ((n = w), (h = '0')),
        h.indexOf('%') >= 0
          ? (h = `${parseInt(h, 10) * d * u}%`)
          : (h = `${h * d * u}px`),
        n.indexOf('%') >= 0
          ? (n = `${parseInt(n, 10) * d}%`)
          : (n = `${n * d}px`),
        typeof v < 'u' && v !== null)
      ) {
        const m = v - (v - 1) * (1 - Math.abs(d))
        f.style.opacity = m
      }
      let g = `translate3d(${h}, ${n}, 0px)`
      if (typeof o < 'u' && o !== null) {
        const m = o - (o - 1) * (1 - Math.abs(d))
        g += ` scale(${m})`
      }
      if (b && typeof b < 'u' && b !== null) {
        const m = b * d * -1
        g += ` rotate(${m}deg)`
      }
      f.style.transform = g
    },
    p = () => {
      const { el: f, slides: d, progress: l, snapGrid: u, isElement: w } = e,
        h = j(f, r)
      ;(e.isElement && h.push(...j(e.hostEl, r)),
        h.forEach(n => {
          a(n, l)
        }),
        d.forEach((n, o) => {
          let v = n.progress
          ;(e.params.slidesPerGroup > 1 &&
            e.params.slidesPerView !== 'auto' &&
            (v += Math.ceil(o / 2) - l * (u.length - 1)),
            (v = Math.min(Math.max(v, -1), 1)),
            n
              .querySelectorAll(`${r}, [data-swiper-parallax-rotate]`)
              .forEach(b => {
                a(b, v)
              }))
        }))
    },
    c = function (f) {
      f === void 0 && (f = e.params.speed)
      const { el: d, hostEl: l } = e,
        u = [...d.querySelectorAll(r)]
      ;(e.isElement && u.push(...l.querySelectorAll(r)),
        u.forEach(w => {
          let h =
            parseInt(w.getAttribute('data-swiper-parallax-duration'), 10) || f
          ;(f === 0 && (h = 0), (w.style.transitionDuration = `${h}ms`))
        }))
    }
  ;(s('beforeInit', () => {
    e.params.parallax.enabled &&
      ((e.params.watchSlidesProgress = !0),
      (e.originalParams.watchSlidesProgress = !0))
  }),
    s('init', () => {
      e.params.parallax.enabled && p()
    }),
    s('setTranslate', () => {
      e.params.parallax.enabled && p()
    }),
    s('setTransition', (f, d) => {
      e.params.parallax.enabled && c(d)
    }))
}
function Ui(i) {
  let { swiper: e, extendParams: t, on: s, emit: r } = i
  const a = X()
  ;(t({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      panOnMouseMove: !1,
      toggle: !0,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed',
    },
  }),
    (e.zoom = { enabled: !1 }))
  let p = 1,
    c = !1,
    f = !1,
    d = { x: 0, y: 0 }
  const l = -3
  let u, w
  const h = [],
    n = {
      originX: 0,
      originY: 0,
      slideEl: void 0,
      slideWidth: void 0,
      slideHeight: void 0,
      imageEl: void 0,
      imageWrapEl: void 0,
      maxRatio: 3,
    },
    o = {
      isTouched: void 0,
      isMoved: void 0,
      currentX: void 0,
      currentY: void 0,
      minX: void 0,
      minY: void 0,
      maxX: void 0,
      maxY: void 0,
      width: void 0,
      height: void 0,
      startX: void 0,
      startY: void 0,
      touchesStart: {},
      touchesCurrent: {},
    },
    v = {
      x: void 0,
      y: void 0,
      prevPositionX: void 0,
      prevPositionY: void 0,
      prevTime: void 0,
    }
  let b = 1
  Object.defineProperty(e.zoom, 'scale', {
    get() {
      return b
    },
    set(_) {
      if (b !== _) {
        const D = n.imageEl,
          R = n.slideEl
        r('zoomChange', _, D, R)
      }
      b = _
    },
  })
  function g() {
    if (h.length < 2) return 1
    const _ = h[0].pageX,
      D = h[0].pageY,
      R = h[1].pageX,
      V = h[1].pageY
    return Math.sqrt((R - _) ** 2 + (V - D) ** 2)
  }
  function m() {
    const _ = e.params.zoom,
      D = n.imageWrapEl.getAttribute('data-swiper-zoom') || _.maxRatio
    if (_.limitToOriginalSize && n.imageEl && n.imageEl.naturalWidth) {
      const R = n.imageEl.naturalWidth / n.imageEl.offsetWidth
      return Math.min(R, D)
    }
    return D
  }
  function y() {
    if (h.length < 2) return { x: null, y: null }
    const _ = n.imageEl.getBoundingClientRect()
    return [
      (h[0].pageX + (h[1].pageX - h[0].pageX) / 2 - _.x - a.scrollX) / p,
      (h[0].pageY + (h[1].pageY - h[0].pageY) / 2 - _.y - a.scrollY) / p,
    ]
  }
  function x() {
    return e.isElement ? 'swiper-slide' : `.${e.params.slideClass}`
  }
  function O(_) {
    const D = x()
    return !!(
      _.target.matches(D) ||
      e.slides.filter(R => R.contains(_.target)).length > 0
    )
  }
  function L(_) {
    const D = `.${e.params.zoom.containerClass}`
    return !!(
      _.target.matches(D) ||
      [...e.hostEl.querySelectorAll(D)].filter(R => R.contains(_.target))
        .length > 0
    )
  }
  function z(_) {
    if ((_.pointerType === 'mouse' && h.splice(0, h.length), !O(_))) return
    const D = e.params.zoom
    if (((u = !1), (w = !1), h.push(_), !(h.length < 2))) {
      if (((u = !0), (n.scaleStart = g()), !n.slideEl)) {
        ;((n.slideEl = _.target.closest(
          `.${e.params.slideClass}, swiper-slide`
        )),
          n.slideEl || (n.slideEl = e.slides[e.activeIndex]))
        let R = n.slideEl.querySelector(`.${D.containerClass}`)
        if (
          (R &&
            (R = R.querySelectorAll(
              'picture, img, svg, canvas, .swiper-zoom-target'
            )[0]),
          (n.imageEl = R),
          R
            ? (n.imageWrapEl = pe(n.imageEl, `.${D.containerClass}`)[0])
            : (n.imageWrapEl = void 0),
          !n.imageWrapEl)
        ) {
          n.imageEl = void 0
          return
        }
        n.maxRatio = m()
      }
      if (n.imageEl) {
        const [R, V] = y()
        ;((n.originX = R),
          (n.originY = V),
          (n.imageEl.style.transitionDuration = '0ms'))
      }
      c = !0
    }
  }
  function S(_) {
    if (!O(_)) return
    const D = e.params.zoom,
      R = e.zoom,
      V = h.findIndex(q => q.pointerId === _.pointerId)
    ;(V >= 0 && (h[V] = _),
      !(h.length < 2) &&
        ((w = !0),
        (n.scaleMove = g()),
        n.imageEl &&
          ((R.scale = (n.scaleMove / n.scaleStart) * p),
          R.scale > n.maxRatio &&
            (R.scale = n.maxRatio - 1 + (R.scale - n.maxRatio + 1) ** 0.5),
          R.scale < D.minRatio &&
            (R.scale = D.minRatio + 1 - (D.minRatio - R.scale + 1) ** 0.5),
          (n.imageEl.style.transform = `translate3d(0,0,0) scale(${R.scale})`))))
  }
  function T(_) {
    if (!O(_) || (_.pointerType === 'mouse' && _.type === 'pointerout')) return
    const D = e.params.zoom,
      R = e.zoom,
      V = h.findIndex(q => q.pointerId === _.pointerId)
    ;(V >= 0 && h.splice(V, 1),
      !(!u || !w) &&
        ((u = !1),
        (w = !1),
        n.imageEl &&
          ((R.scale = Math.max(Math.min(R.scale, n.maxRatio), D.minRatio)),
          (n.imageEl.style.transitionDuration = `${e.params.speed}ms`),
          (n.imageEl.style.transform = `translate3d(0,0,0) scale(${R.scale})`),
          (p = R.scale),
          (c = !1),
          R.scale > 1 && n.slideEl
            ? n.slideEl.classList.add(`${D.zoomedSlideClass}`)
            : R.scale <= 1 &&
              n.slideEl &&
              n.slideEl.classList.remove(`${D.zoomedSlideClass}`),
          R.scale === 1 &&
            ((n.originX = 0), (n.originY = 0), (n.slideEl = void 0)))))
  }
  let I
  function P() {
    e.touchEventsData.preventTouchMoveFromPointerMove = !1
  }
  function C() {
    ;(clearTimeout(I),
      (e.touchEventsData.preventTouchMoveFromPointerMove = !0),
      (I = setTimeout(() => {
        e.destroyed || P()
      })))
  }
  function A(_) {
    const D = e.device
    if (!n.imageEl || o.isTouched) return
    ;(D.android && _.cancelable && _.preventDefault(), (o.isTouched = !0))
    const R = h.length > 0 ? h[0] : _
    ;((o.touchesStart.x = R.pageX), (o.touchesStart.y = R.pageY))
  }
  function $(_) {
    const R = _.pointerType === 'mouse' && e.params.zoom.panOnMouseMove
    if (!O(_) || !L(_)) return
    const V = e.zoom
    if (!n.imageEl) return
    if (!o.isTouched || !n.slideEl) {
      R && M(_)
      return
    }
    if (R) {
      M(_)
      return
    }
    o.isMoved ||
      ((o.width = n.imageEl.offsetWidth || n.imageEl.clientWidth),
      (o.height = n.imageEl.offsetHeight || n.imageEl.clientHeight),
      (o.startX = Ze(n.imageWrapEl, 'x') || 0),
      (o.startY = Ze(n.imageWrapEl, 'y') || 0),
      (n.slideWidth = n.slideEl.offsetWidth),
      (n.slideHeight = n.slideEl.offsetHeight),
      (n.imageWrapEl.style.transitionDuration = '0ms'))
    const q = o.width * V.scale,
      ne = o.height * V.scale
    if (
      ((o.minX = Math.min(n.slideWidth / 2 - q / 2, 0)),
      (o.maxX = -o.minX),
      (o.minY = Math.min(n.slideHeight / 2 - ne / 2, 0)),
      (o.maxY = -o.minY),
      (o.touchesCurrent.x = h.length > 0 ? h[0].pageX : _.pageX),
      (o.touchesCurrent.y = h.length > 0 ? h[0].pageY : _.pageY),
      Math.max(
        Math.abs(o.touchesCurrent.x - o.touchesStart.x),
        Math.abs(o.touchesCurrent.y - o.touchesStart.y)
      ) > 5 && (e.allowClick = !1),
      !o.isMoved && !c)
    ) {
      if (
        e.isHorizontal() &&
        ((Math.floor(o.minX) === Math.floor(o.startX) &&
          o.touchesCurrent.x < o.touchesStart.x) ||
          (Math.floor(o.maxX) === Math.floor(o.startX) &&
            o.touchesCurrent.x > o.touchesStart.x))
      ) {
        ;((o.isTouched = !1), P())
        return
      }
      if (
        !e.isHorizontal() &&
        ((Math.floor(o.minY) === Math.floor(o.startY) &&
          o.touchesCurrent.y < o.touchesStart.y) ||
          (Math.floor(o.maxY) === Math.floor(o.startY) &&
            o.touchesCurrent.y > o.touchesStart.y))
      ) {
        ;((o.isTouched = !1), P())
        return
      }
    }
    ;(_.cancelable && _.preventDefault(),
      _.stopPropagation(),
      C(),
      (o.isMoved = !0))
    const re = (V.scale - p) / (n.maxRatio - e.params.zoom.minRatio),
      { originX: le, originY: U } = n
    ;((o.currentX =
      o.touchesCurrent.x -
      o.touchesStart.x +
      o.startX +
      re * (o.width - le * 2)),
      (o.currentY =
        o.touchesCurrent.y -
        o.touchesStart.y +
        o.startY +
        re * (o.height - U * 2)),
      o.currentX < o.minX &&
        (o.currentX = o.minX + 1 - (o.minX - o.currentX + 1) ** 0.8),
      o.currentX > o.maxX &&
        (o.currentX = o.maxX - 1 + (o.currentX - o.maxX + 1) ** 0.8),
      o.currentY < o.minY &&
        (o.currentY = o.minY + 1 - (o.minY - o.currentY + 1) ** 0.8),
      o.currentY > o.maxY &&
        (o.currentY = o.maxY - 1 + (o.currentY - o.maxY + 1) ** 0.8),
      v.prevPositionX || (v.prevPositionX = o.touchesCurrent.x),
      v.prevPositionY || (v.prevPositionY = o.touchesCurrent.y),
      v.prevTime || (v.prevTime = Date.now()),
      (v.x =
        (o.touchesCurrent.x - v.prevPositionX) / (Date.now() - v.prevTime) / 2),
      (v.y =
        (o.touchesCurrent.y - v.prevPositionY) / (Date.now() - v.prevTime) / 2),
      Math.abs(o.touchesCurrent.x - v.prevPositionX) < 2 && (v.x = 0),
      Math.abs(o.touchesCurrent.y - v.prevPositionY) < 2 && (v.y = 0),
      (v.prevPositionX = o.touchesCurrent.x),
      (v.prevPositionY = o.touchesCurrent.y),
      (v.prevTime = Date.now()),
      (n.imageWrapEl.style.transform = `translate3d(${o.currentX}px, ${o.currentY}px,0)`))
  }
  function k() {
    const _ = e.zoom
    if (((h.length = 0), !n.imageEl)) return
    if (!o.isTouched || !o.isMoved) {
      ;((o.isTouched = !1), (o.isMoved = !1))
      return
    }
    ;((o.isTouched = !1), (o.isMoved = !1))
    let D = 300,
      R = 300
    const V = v.x * D,
      q = o.currentX + V,
      ne = v.y * R,
      oe = o.currentY + ne
    ;(v.x !== 0 && (D = Math.abs((q - o.currentX) / v.x)),
      v.y !== 0 && (R = Math.abs((oe - o.currentY) / v.y)))
    const re = Math.max(D, R)
    ;((o.currentX = q), (o.currentY = oe))
    const le = o.width * _.scale,
      U = o.height * _.scale
    ;((o.minX = Math.min(n.slideWidth / 2 - le / 2, 0)),
      (o.maxX = -o.minX),
      (o.minY = Math.min(n.slideHeight / 2 - U / 2, 0)),
      (o.maxY = -o.minY),
      (o.currentX = Math.max(Math.min(o.currentX, o.maxX), o.minX)),
      (o.currentY = Math.max(Math.min(o.currentY, o.maxY), o.minY)),
      (n.imageWrapEl.style.transitionDuration = `${re}ms`),
      (n.imageWrapEl.style.transform = `translate3d(${o.currentX}px, ${o.currentY}px,0)`))
  }
  function E() {
    const _ = e.zoom
    n.slideEl &&
      e.activeIndex !== e.slides.indexOf(n.slideEl) &&
      (n.imageEl && (n.imageEl.style.transform = 'translate3d(0,0,0) scale(1)'),
      n.imageWrapEl && (n.imageWrapEl.style.transform = 'translate3d(0,0,0)'),
      n.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`),
      (_.scale = 1),
      (p = 1),
      (n.slideEl = void 0),
      (n.imageEl = void 0),
      (n.imageWrapEl = void 0),
      (n.originX = 0),
      (n.originY = 0))
  }
  function M(_) {
    if (p <= 1 || !n.imageWrapEl || !O(_) || !L(_)) return
    const D = a.getComputedStyle(n.imageWrapEl).transform,
      R = new a.DOMMatrix(D)
    if (!f) {
      ;((f = !0),
        (d.x = _.clientX),
        (d.y = _.clientY),
        (o.startX = R.e),
        (o.startY = R.f),
        (o.width = n.imageEl.offsetWidth || n.imageEl.clientWidth),
        (o.height = n.imageEl.offsetHeight || n.imageEl.clientHeight),
        (n.slideWidth = n.slideEl.offsetWidth),
        (n.slideHeight = n.slideEl.offsetHeight))
      return
    }
    const V = (_.clientX - d.x) * l,
      q = (_.clientY - d.y) * l,
      ne = o.width * p,
      oe = o.height * p,
      re = n.slideWidth,
      le = n.slideHeight,
      U = Math.min(re / 2 - ne / 2, 0),
      te = -U,
      Se = Math.min(le / 2 - oe / 2, 0),
      Le = -Se,
      ue = Math.max(Math.min(o.startX + V, te), U),
      me = Math.max(Math.min(o.startY + q, Le), Se)
    ;((n.imageWrapEl.style.transitionDuration = '0ms'),
      (n.imageWrapEl.style.transform = `translate3d(${ue}px, ${me}px, 0)`),
      (d.x = _.clientX),
      (d.y = _.clientY),
      (o.startX = ue),
      (o.startY = me),
      (o.currentX = ue),
      (o.currentY = me))
  }
  function B(_) {
    const D = e.zoom,
      R = e.params.zoom
    if (!n.slideEl) {
      ;(_ &&
        _.target &&
        (n.slideEl = _.target.closest(`.${e.params.slideClass}, swiper-slide`)),
        n.slideEl ||
          (e.params.virtual && e.params.virtual.enabled && e.virtual
            ? (n.slideEl = j(e.slidesEl, `.${e.params.slideActiveClass}`)[0])
            : (n.slideEl = e.slides[e.activeIndex])))
      let Ee = n.slideEl.querySelector(`.${R.containerClass}`)
      ;(Ee &&
        (Ee = Ee.querySelectorAll(
          'picture, img, svg, canvas, .swiper-zoom-target'
        )[0]),
        (n.imageEl = Ee),
        Ee
          ? (n.imageWrapEl = pe(n.imageEl, `.${R.containerClass}`)[0])
          : (n.imageWrapEl = void 0))
    }
    if (!n.imageEl || !n.imageWrapEl) return
    ;(e.params.cssMode &&
      ((e.wrapperEl.style.overflow = 'hidden'),
      (e.wrapperEl.style.touchAction = 'none')),
      n.slideEl.classList.add(`${R.zoomedSlideClass}`))
    let V, q, ne, oe, re, le, U, te, Se, Le, ue, me, ze, Ie, Be, Ge, He, Ve
    typeof o.touchesStart.x > 'u' && _
      ? ((V = _.pageX), (q = _.pageY))
      : ((V = o.touchesStart.x), (q = o.touchesStart.y))
    const Xe = p,
      he = typeof _ == 'number' ? _ : null
    p === 1 &&
      he &&
      ((V = void 0),
      (q = void 0),
      (o.touchesStart.x = void 0),
      (o.touchesStart.y = void 0))
    const rt = m()
    ;((D.scale = he || rt),
      (p = he || rt),
      _ && !(p === 1 && he)
        ? ((He = n.slideEl.offsetWidth),
          (Ve = n.slideEl.offsetHeight),
          (ne = $e(n.slideEl).left + a.scrollX),
          (oe = $e(n.slideEl).top + a.scrollY),
          (re = ne + He / 2 - V),
          (le = oe + Ve / 2 - q),
          (Se = n.imageEl.offsetWidth || n.imageEl.clientWidth),
          (Le = n.imageEl.offsetHeight || n.imageEl.clientHeight),
          (ue = Se * D.scale),
          (me = Le * D.scale),
          (ze = Math.min(He / 2 - ue / 2, 0)),
          (Ie = Math.min(Ve / 2 - me / 2, 0)),
          (Be = -ze),
          (Ge = -Ie),
          Xe > 0 &&
          he &&
          typeof o.currentX == 'number' &&
          typeof o.currentY == 'number'
            ? ((U = (o.currentX * D.scale) / Xe),
              (te = (o.currentY * D.scale) / Xe))
            : ((U = re * D.scale), (te = le * D.scale)),
          U < ze && (U = ze),
          U > Be && (U = Be),
          te < Ie && (te = Ie),
          te > Ge && (te = Ge))
        : ((U = 0), (te = 0)),
      he && D.scale === 1 && ((n.originX = 0), (n.originY = 0)),
      (o.currentX = U),
      (o.currentY = te),
      (n.imageWrapEl.style.transitionDuration = '300ms'),
      (n.imageWrapEl.style.transform = `translate3d(${U}px, ${te}px,0)`),
      (n.imageEl.style.transitionDuration = '300ms'),
      (n.imageEl.style.transform = `translate3d(0,0,0) scale(${D.scale})`))
  }
  function G() {
    const _ = e.zoom,
      D = e.params.zoom
    if (!n.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual
        ? (n.slideEl = j(e.slidesEl, `.${e.params.slideActiveClass}`)[0])
        : (n.slideEl = e.slides[e.activeIndex])
      let R = n.slideEl.querySelector(`.${D.containerClass}`)
      ;(R &&
        (R = R.querySelectorAll(
          'picture, img, svg, canvas, .swiper-zoom-target'
        )[0]),
        (n.imageEl = R),
        R
          ? (n.imageWrapEl = pe(n.imageEl, `.${D.containerClass}`)[0])
          : (n.imageWrapEl = void 0))
    }
    !n.imageEl ||
      !n.imageWrapEl ||
      (e.params.cssMode &&
        ((e.wrapperEl.style.overflow = ''),
        (e.wrapperEl.style.touchAction = '')),
      (_.scale = 1),
      (p = 1),
      (o.currentX = void 0),
      (o.currentY = void 0),
      (o.touchesStart.x = void 0),
      (o.touchesStart.y = void 0),
      (n.imageWrapEl.style.transitionDuration = '300ms'),
      (n.imageWrapEl.style.transform = 'translate3d(0,0,0)'),
      (n.imageEl.style.transitionDuration = '300ms'),
      (n.imageEl.style.transform = 'translate3d(0,0,0) scale(1)'),
      n.slideEl.classList.remove(`${D.zoomedSlideClass}`),
      (n.slideEl = void 0),
      (n.originX = 0),
      (n.originY = 0),
      e.params.zoom.panOnMouseMove &&
        ((d = { x: 0, y: 0 }), f && ((f = !1), (o.startX = 0), (o.startY = 0))))
  }
  function Y(_) {
    const D = e.zoom
    D.scale && D.scale !== 1 ? G() : B(_)
  }
  function F() {
    const _ = e.params.passiveListeners ? { passive: !0, capture: !1 } : !1,
      D = e.params.passiveListeners ? { passive: !1, capture: !0 } : !0
    return { passiveListener: _, activeListenerWithCapture: D }
  }
  function ie() {
    const _ = e.zoom
    if (_.enabled) return
    _.enabled = !0
    const { passiveListener: D, activeListenerWithCapture: R } = F()
    ;(e.wrapperEl.addEventListener('pointerdown', z, D),
      e.wrapperEl.addEventListener('pointermove', S, R),
      ['pointerup', 'pointercancel', 'pointerout'].forEach(V => {
        e.wrapperEl.addEventListener(V, T, D)
      }),
      e.wrapperEl.addEventListener('pointermove', $, R))
  }
  function ye() {
    const _ = e.zoom
    if (!_.enabled) return
    _.enabled = !1
    const { passiveListener: D, activeListenerWithCapture: R } = F()
    ;(e.wrapperEl.removeEventListener('pointerdown', z, D),
      e.wrapperEl.removeEventListener('pointermove', S, R),
      ['pointerup', 'pointercancel', 'pointerout'].forEach(V => {
        e.wrapperEl.removeEventListener(V, T, D)
      }),
      e.wrapperEl.removeEventListener('pointermove', $, R))
  }
  ;(s('init', () => {
    e.params.zoom.enabled && ie()
  }),
    s('destroy', () => {
      ye()
    }),
    s('touchStart', (_, D) => {
      e.zoom.enabled && A(D)
    }),
    s('touchEnd', (_, D) => {
      e.zoom.enabled && k()
    }),
    s('doubleTap', (_, D) => {
      !e.animating &&
        e.params.zoom.enabled &&
        e.zoom.enabled &&
        e.params.zoom.toggle &&
        Y(D)
    }),
    s('transitionEnd', () => {
      e.zoom.enabled && e.params.zoom.enabled && E()
    }),
    s('slideChange', () => {
      e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && E()
    }),
    Object.assign(e.zoom, {
      enable: ie,
      disable: ye,
      in: B,
      out: G,
      toggle: Y,
    }))
}
function Ki(i) {
  let { swiper: e, extendParams: t, on: s } = i
  ;(t({ controller: { control: void 0, inverse: !1, by: 'slide' } }),
    (e.controller = { control: void 0 }))
  function r(d, l) {
    const u = (function () {
      let o, v, b
      return (g, m) => {
        for (v = -1, o = g.length; o - v > 1; )
          ((b = (o + v) >> 1), g[b] <= m ? (v = b) : (o = b))
        return o
      }
    })()
    ;((this.x = d), (this.y = l), (this.lastIndex = d.length - 1))
    let w, h
    return (
      (this.interpolate = function (o) {
        return o
          ? ((h = u(this.x, o)),
            (w = h - 1),
            ((o - this.x[w]) * (this.y[h] - this.y[w])) /
              (this.x[h] - this.x[w]) +
              this.y[w])
          : 0
      }),
      this
    )
  }
  function a(d) {
    e.controller.spline = e.params.loop
      ? new r(e.slidesGrid, d.slidesGrid)
      : new r(e.snapGrid, d.snapGrid)
  }
  function p(d, l) {
    const u = e.controller.control
    let w, h
    const n = e.constructor
    function o(v) {
      if (v.destroyed) return
      const b = e.rtlTranslate ? -e.translate : e.translate
      ;(e.params.controller.by === 'slide' &&
        (a(v), (h = -e.controller.spline.interpolate(-b))),
        (!h || e.params.controller.by === 'container') &&
          ((w =
            (v.maxTranslate() - v.minTranslate()) /
            (e.maxTranslate() - e.minTranslate())),
          (Number.isNaN(w) || !Number.isFinite(w)) && (w = 1),
          (h = (b - e.minTranslate()) * w + v.minTranslate())),
        e.params.controller.inverse && (h = v.maxTranslate() - h),
        v.updateProgress(h),
        v.setTranslate(h, e),
        v.updateActiveIndex(),
        v.updateSlidesClasses())
    }
    if (Array.isArray(u))
      for (let v = 0; v < u.length; v += 1)
        u[v] !== l && u[v] instanceof n && o(u[v])
    else u instanceof n && l !== u && o(u)
  }
  function c(d, l) {
    const u = e.constructor,
      w = e.controller.control
    let h
    function n(o) {
      o.destroyed ||
        (o.setTransition(d, e),
        d !== 0 &&
          (o.transitionStart(),
          o.params.autoHeight &&
            ge(() => {
              o.updateAutoHeight()
            }),
          Me(o.wrapperEl, () => {
            w && o.transitionEnd()
          })))
    }
    if (Array.isArray(w))
      for (h = 0; h < w.length; h += 1)
        w[h] !== l && w[h] instanceof u && n(w[h])
    else w instanceof u && l !== w && n(w)
  }
  function f() {
    e.controller.control &&
      e.controller.spline &&
      ((e.controller.spline = void 0), delete e.controller.spline)
  }
  ;(s('beforeInit', () => {
    if (
      typeof window < 'u' &&
      (typeof e.params.controller.control == 'string' ||
        e.params.controller.control instanceof HTMLElement)
    ) {
      ;(typeof e.params.controller.control == 'string'
        ? [...document.querySelectorAll(e.params.controller.control)]
        : [e.params.controller.control]
      ).forEach(l => {
        if (
          (e.controller.control || (e.controller.control = []), l && l.swiper)
        )
          e.controller.control.push(l.swiper)
        else if (l) {
          const u = `${e.params.eventsPrefix}init`,
            w = h => {
              ;(e.controller.control.push(h.detail[0]),
                e.update(),
                l.removeEventListener(u, w))
            }
          l.addEventListener(u, w)
        }
      })
      return
    }
    e.controller.control = e.params.controller.control
  }),
    s('update', () => {
      f()
    }),
    s('resize', () => {
      f()
    }),
    s('observerUpdate', () => {
      f()
    }),
    s('setTranslate', (d, l, u) => {
      !e.controller.control ||
        e.controller.control.destroyed ||
        e.controller.setTranslate(l, u)
    }),
    s('setTransition', (d, l, u) => {
      !e.controller.control ||
        e.controller.control.destroyed ||
        e.controller.setTransition(l, u)
    }),
    Object.assign(e.controller, { setTranslate: p, setTransition: c }))
}
function Zi(i) {
  let { swiper: e, extendParams: t, on: s } = i
  ;(t({
    a11y: {
      enabled: !0,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null,
      scrollOnFocus: !0,
    },
  }),
    (e.a11y = { clicked: !1 }))
  let r = null,
    a,
    p,
    c = new Date().getTime()
  function f(E) {
    const M = r
    M.length !== 0 && ee(M, E)
  }
  function d(E) {
    const M = () => Math.round(16 * Math.random()).toString(16)
    return 'x'.repeat(E).replace(/x/g, M)
  }
  function l(E) {
    ;((E = H(E)),
      E.forEach(M => {
        M.setAttribute('tabIndex', '0')
      }))
  }
  function u(E) {
    ;((E = H(E)),
      E.forEach(M => {
        M.setAttribute('tabIndex', '-1')
      }))
  }
  function w(E, M) {
    ;((E = H(E)),
      E.forEach(B => {
        B.setAttribute('role', M)
      }))
  }
  function h(E, M) {
    ;((E = H(E)),
      E.forEach(B => {
        B.setAttribute('aria-roledescription', M)
      }))
  }
  function n(E, M) {
    ;((E = H(E)),
      E.forEach(B => {
        B.setAttribute('aria-controls', M)
      }))
  }
  function o(E, M) {
    ;((E = H(E)),
      E.forEach(B => {
        B.setAttribute('aria-label', M)
      }))
  }
  function v(E, M) {
    ;((E = H(E)),
      E.forEach(B => {
        B.setAttribute('id', M)
      }))
  }
  function b(E, M) {
    ;((E = H(E)),
      E.forEach(B => {
        B.setAttribute('aria-live', M)
      }))
  }
  function g(E) {
    ;((E = H(E)),
      E.forEach(M => {
        M.setAttribute('aria-disabled', !0)
      }))
  }
  function m(E) {
    ;((E = H(E)),
      E.forEach(M => {
        M.setAttribute('aria-disabled', !1)
      }))
  }
  function y(E) {
    if (E.keyCode !== 13 && E.keyCode !== 32) return
    const M = e.params.a11y,
      B = E.target
    if (
      !(
        e.pagination &&
        e.pagination.el &&
        (B === e.pagination.el || e.pagination.el.contains(E.target)) &&
        !E.target.matches(ae(e.params.pagination.bulletClass))
      )
    ) {
      if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
        const G = H(e.navigation.prevEl)
        ;(H(e.navigation.nextEl).includes(B) &&
          ((e.isEnd && !e.params.loop) || e.slideNext(),
          e.isEnd ? f(M.lastSlideMessage) : f(M.nextSlideMessage)),
          G.includes(B) &&
            ((e.isBeginning && !e.params.loop) || e.slidePrev(),
            e.isBeginning ? f(M.firstSlideMessage) : f(M.prevSlideMessage)))
      }
      e.pagination &&
        B.matches(ae(e.params.pagination.bulletClass)) &&
        B.click()
    }
  }
  function x() {
    if (e.params.loop || e.params.rewind || !e.navigation) return
    const { nextEl: E, prevEl: M } = e.navigation
    ;(M && (e.isBeginning ? (g(M), u(M)) : (m(M), l(M))),
      E && (e.isEnd ? (g(E), u(E)) : (m(E), l(E))))
  }
  function O() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length
  }
  function L() {
    return O() && e.params.pagination.clickable
  }
  function z() {
    const E = e.params.a11y
    O() &&
      e.pagination.bullets.forEach(M => {
        ;(e.params.pagination.clickable &&
          (l(M),
          e.params.pagination.renderBullet ||
            (w(M, 'button'),
            o(
              M,
              E.paginationBulletMessage.replace(/\{\{index\}\}/, Ce(M) + 1)
            ))),
          M.matches(ae(e.params.pagination.bulletActiveClass))
            ? M.setAttribute('aria-current', 'true')
            : M.removeAttribute('aria-current'))
      })
  }
  const S = (E, M, B) => {
      ;(l(E),
        E.tagName !== 'BUTTON' &&
          (w(E, 'button'), E.addEventListener('keydown', y)),
        o(E, B),
        n(E, M))
    },
    T = E => {
      ;(p && p !== E.target && !p.contains(E.target) && (a = !0),
        (e.a11y.clicked = !0))
    },
    I = () => {
      ;((a = !1),
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            e.destroyed || (e.a11y.clicked = !1)
          })
        }))
    },
    P = E => {
      c = new Date().getTime()
    },
    C = E => {
      if (
        e.a11y.clicked ||
        !e.params.a11y.scrollOnFocus ||
        new Date().getTime() - c < 100
      )
        return
      const M = E.target.closest(`.${e.params.slideClass}, swiper-slide`)
      if (!M || !e.slides.includes(M)) return
      p = M
      const B = e.slides.indexOf(M) === e.activeIndex,
        G =
          e.params.watchSlidesProgress &&
          e.visibleSlides &&
          e.visibleSlides.includes(M)
      B ||
        G ||
        (E.sourceCapabilities && E.sourceCapabilities.firesTouchEvents) ||
        (e.isHorizontal() ? (e.el.scrollLeft = 0) : (e.el.scrollTop = 0),
        requestAnimationFrame(() => {
          a ||
            (e.params.loop
              ? e.slideToLoop(
                  e.getSlideIndexWhenGrid(
                    parseInt(M.getAttribute('data-swiper-slide-index'))
                  ),
                  0
                )
              : e.slideTo(e.getSlideIndexWhenGrid(e.slides.indexOf(M)), 0),
            (a = !1))
        }))
    },
    A = () => {
      const E = e.params.a11y
      ;(E.itemRoleDescriptionMessage &&
        h(e.slides, E.itemRoleDescriptionMessage),
        E.slideRole && w(e.slides, E.slideRole))
      const M = e.slides.length
      E.slideLabelMessage &&
        e.slides.forEach((B, G) => {
          const Y = e.params.loop
              ? parseInt(B.getAttribute('data-swiper-slide-index'), 10)
              : G,
            F = E.slideLabelMessage
              .replace(/\{\{index\}\}/, Y + 1)
              .replace(/\{\{slidesLength\}\}/, M)
          o(B, F)
        })
    },
    $ = () => {
      const E = e.params.a11y
      e.el.append(r)
      const M = e.el
      ;(E.containerRoleDescriptionMessage &&
        h(M, E.containerRoleDescriptionMessage),
        E.containerMessage && o(M, E.containerMessage),
        E.containerRole && w(M, E.containerRole))
      const B = e.wrapperEl,
        G = E.id || B.getAttribute('id') || `swiper-wrapper-${d(16)}`,
        Y = e.params.autoplay && e.params.autoplay.enabled ? 'off' : 'polite'
      ;(v(B, G), b(B, Y), A())
      let { nextEl: F, prevEl: ie } = e.navigation ? e.navigation : {}
      ;((F = H(F)),
        (ie = H(ie)),
        F && F.forEach(_ => S(_, G, E.nextSlideMessage)),
        ie && ie.forEach(_ => S(_, G, E.prevSlideMessage)),
        L() &&
          H(e.pagination.el).forEach(D => {
            D.addEventListener('keydown', y)
          }),
        W().addEventListener('visibilitychange', P),
        e.el.addEventListener('focus', C, !0),
        e.el.addEventListener('focus', C, !0),
        e.el.addEventListener('pointerdown', T, !0),
        e.el.addEventListener('pointerup', I, !0))
    }
  function k() {
    r && r.remove()
    let { nextEl: E, prevEl: M } = e.navigation ? e.navigation : {}
    ;((E = H(E)),
      (M = H(M)),
      E && E.forEach(G => G.removeEventListener('keydown', y)),
      M && M.forEach(G => G.removeEventListener('keydown', y)),
      L() &&
        H(e.pagination.el).forEach(Y => {
          Y.removeEventListener('keydown', y)
        }),
      W().removeEventListener('visibilitychange', P),
      e.el &&
        typeof e.el != 'string' &&
        (e.el.removeEventListener('focus', C, !0),
        e.el.removeEventListener('pointerdown', T, !0),
        e.el.removeEventListener('pointerup', I, !0)))
  }
  ;(s('beforeInit', () => {
    ;((r = Q('span', e.params.a11y.notificationClass)),
      r.setAttribute('aria-live', 'assertive'),
      r.setAttribute('aria-atomic', 'true'))
  }),
    s('afterInit', () => {
      e.params.a11y.enabled && $()
    }),
    s('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
      e.params.a11y.enabled && A()
    }),
    s('fromEdge toEdge afterInit lock unlock', () => {
      e.params.a11y.enabled && x()
    }),
    s('paginationUpdate', () => {
      e.params.a11y.enabled && z()
    }),
    s('destroy', () => {
      e.params.a11y.enabled && k()
    }))
}
function Qi(i) {
  let { swiper: e, extendParams: t, on: s } = i
  t({
    history: {
      enabled: !1,
      root: '',
      replaceState: !1,
      key: 'slides',
      keepQuery: !1,
    },
  })
  let r = !1,
    a = {}
  const p = h =>
      h
        .toString()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, ''),
    c = h => {
      const n = X()
      let o
      h ? (o = new URL(h)) : (o = n.location)
      const v = o.pathname
          .slice(1)
          .split('/')
          .filter(y => y !== ''),
        b = v.length,
        g = v[b - 2],
        m = v[b - 1]
      return { key: g, value: m }
    },
    f = (h, n) => {
      const o = X()
      if (!r || !e.params.history.enabled) return
      let v
      e.params.url ? (v = new URL(e.params.url)) : (v = o.location)
      const b =
        e.virtual && e.params.virtual.enabled
          ? e.slidesEl.querySelector(`[data-swiper-slide-index="${n}"]`)
          : e.slides[n]
      let g = p(b.getAttribute('data-history'))
      if (e.params.history.root.length > 0) {
        let y = e.params.history.root
        ;(y[y.length - 1] === '/' && (y = y.slice(0, y.length - 1)),
          (g = `${y}/${h ? `${h}/` : ''}${g}`))
      } else v.pathname.includes(h) || (g = `${h ? `${h}/` : ''}${g}`)
      e.params.history.keepQuery && (g += v.search)
      const m = o.history.state
      ;(m && m.value === g) ||
        (e.params.history.replaceState
          ? o.history.replaceState({ value: g }, null, g)
          : o.history.pushState({ value: g }, null, g))
    },
    d = (h, n, o) => {
      if (n)
        for (let v = 0, b = e.slides.length; v < b; v += 1) {
          const g = e.slides[v]
          if (p(g.getAttribute('data-history')) === n) {
            const y = e.getSlideIndex(g)
            e.slideTo(y, h, o)
          }
        }
      else e.slideTo(0, h, o)
    },
    l = () => {
      ;((a = c(e.params.url)), d(e.params.speed, a.value, !1))
    },
    u = () => {
      const h = X()
      if (e.params.history) {
        if (!h.history || !h.history.pushState) {
          ;((e.params.history.enabled = !1),
            (e.params.hashNavigation.enabled = !0))
          return
        }
        if (((r = !0), (a = c(e.params.url)), !a.key && !a.value)) {
          e.params.history.replaceState || h.addEventListener('popstate', l)
          return
        }
        ;(d(0, a.value, e.params.runCallbacksOnInit),
          e.params.history.replaceState || h.addEventListener('popstate', l))
      }
    },
    w = () => {
      const h = X()
      e.params.history.replaceState || h.removeEventListener('popstate', l)
    }
  ;(s('init', () => {
    e.params.history.enabled && u()
  }),
    s('destroy', () => {
      e.params.history.enabled && w()
    }),
    s('transitionEnd _freeModeNoMomentumRelease', () => {
      r && f(e.params.history.key, e.activeIndex)
    }),
    s('slideChange', () => {
      r && e.params.cssMode && f(e.params.history.key, e.activeIndex)
    }))
}
function Ji(i) {
  let { swiper: e, extendParams: t, emit: s, on: r } = i,
    a = !1
  const p = W(),
    c = X()
  t({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(w, h) {
        if (e.virtual && e.params.virtual.enabled) {
          const n = e.slides.find(v => v.getAttribute('data-hash') === h)
          return n ? parseInt(n.getAttribute('data-swiper-slide-index'), 10) : 0
        }
        return e.getSlideIndex(
          j(
            e.slidesEl,
            `.${e.params.slideClass}[data-hash="${h}"], swiper-slide[data-hash="${h}"]`
          )[0]
        )
      },
    },
  })
  const f = () => {
      s('hashChange')
      const w = p.location.hash.replace('#', ''),
        h =
          e.virtual && e.params.virtual.enabled
            ? e.slidesEl.querySelector(
                `[data-swiper-slide-index="${e.activeIndex}"]`
              )
            : e.slides[e.activeIndex],
        n = h ? h.getAttribute('data-hash') : ''
      if (w !== n) {
        const o = e.params.hashNavigation.getSlideIndex(e, w)
        if (typeof o > 'u' || Number.isNaN(o)) return
        e.slideTo(o)
      }
    },
    d = () => {
      if (!a || !e.params.hashNavigation.enabled) return
      const w =
          e.virtual && e.params.virtual.enabled
            ? e.slidesEl.querySelector(
                `[data-swiper-slide-index="${e.activeIndex}"]`
              )
            : e.slides[e.activeIndex],
        h = w
          ? w.getAttribute('data-hash') || w.getAttribute('data-history')
          : ''
      e.params.hashNavigation.replaceState &&
      c.history &&
      c.history.replaceState
        ? (c.history.replaceState(null, null, `#${h}` || ''), s('hashSet'))
        : ((p.location.hash = h || ''), s('hashSet'))
    },
    l = () => {
      if (
        !e.params.hashNavigation.enabled ||
        (e.params.history && e.params.history.enabled)
      )
        return
      a = !0
      const w = p.location.hash.replace('#', '')
      if (w) {
        const n = e.params.hashNavigation.getSlideIndex(e, w)
        e.slideTo(n || 0, 0, e.params.runCallbacksOnInit, !0)
      }
      e.params.hashNavigation.watchState && c.addEventListener('hashchange', f)
    },
    u = () => {
      e.params.hashNavigation.watchState &&
        c.removeEventListener('hashchange', f)
    }
  ;(r('init', () => {
    e.params.hashNavigation.enabled && l()
  }),
    r('destroy', () => {
      e.params.hashNavigation.enabled && u()
    }),
    r('transitionEnd _freeModeNoMomentumRelease', () => {
      a && d()
    }),
    r('slideChange', () => {
      a && e.params.cssMode && d()
    }))
}
function es(i) {
  let { swiper: e, extendParams: t, on: s, emit: r, params: a } = i
  ;((e.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
    t({
      autoplay: {
        enabled: !1,
        delay: 3e3,
        waitForTransition: !0,
        disableOnInteraction: !1,
        stopOnLastSlide: !1,
        reverseDirection: !1,
        pauseOnMouseEnter: !1,
      },
    }))
  let p,
    c,
    f = a && a.autoplay ? a.autoplay.delay : 3e3,
    d = a && a.autoplay ? a.autoplay.delay : 3e3,
    l,
    u = new Date().getTime(),
    w,
    h,
    n,
    o,
    v,
    b,
    g
  function m(M) {
    !e ||
      e.destroyed ||
      !e.wrapperEl ||
      (M.target === e.wrapperEl &&
        (e.wrapperEl.removeEventListener('transitionend', m),
        !(g || (M.detail && M.detail.bySwiperTouchMove)) && T()))
  }
  const y = () => {
      if (e.destroyed || !e.autoplay.running) return
      e.autoplay.paused ? (w = !0) : w && ((d = l), (w = !1))
      const M = e.autoplay.paused ? l : u + d - new Date().getTime()
      ;((e.autoplay.timeLeft = M),
        r('autoplayTimeLeft', M, M / f),
        (c = requestAnimationFrame(() => {
          y()
        })))
    },
    x = () => {
      let M
      return (
        e.virtual && e.params.virtual.enabled
          ? (M = e.slides.find(G =>
              G.classList.contains('swiper-slide-active')
            ))
          : (M = e.slides[e.activeIndex]),
        M ? parseInt(M.getAttribute('data-swiper-autoplay'), 10) : void 0
      )
    },
    O = M => {
      if (e.destroyed || !e.autoplay.running) return
      ;(cancelAnimationFrame(c), y())
      let B = typeof M > 'u' ? e.params.autoplay.delay : M
      ;((f = e.params.autoplay.delay), (d = e.params.autoplay.delay))
      const G = x()
      ;(!Number.isNaN(G) &&
        G > 0 &&
        typeof M > 'u' &&
        ((B = G), (f = G), (d = G)),
        (l = B))
      const Y = e.params.speed,
        F = () => {
          !e ||
            e.destroyed ||
            (e.params.autoplay.reverseDirection
              ? !e.isBeginning || e.params.loop || e.params.rewind
                ? (e.slidePrev(Y, !0, !0), r('autoplay'))
                : e.params.autoplay.stopOnLastSlide ||
                  (e.slideTo(e.slides.length - 1, Y, !0, !0), r('autoplay'))
              : !e.isEnd || e.params.loop || e.params.rewind
                ? (e.slideNext(Y, !0, !0), r('autoplay'))
                : e.params.autoplay.stopOnLastSlide ||
                  (e.slideTo(0, Y, !0, !0), r('autoplay')),
            e.params.cssMode &&
              ((u = new Date().getTime()),
              requestAnimationFrame(() => {
                O()
              })))
        }
      return (
        B > 0
          ? (clearTimeout(p),
            (p = setTimeout(() => {
              F()
            }, B)))
          : requestAnimationFrame(() => {
              F()
            }),
        B
      )
    },
    L = () => {
      ;((u = new Date().getTime()),
        (e.autoplay.running = !0),
        O(),
        r('autoplayStart'))
    },
    z = () => {
      ;((e.autoplay.running = !1),
        clearTimeout(p),
        cancelAnimationFrame(c),
        r('autoplayStop'))
    },
    S = (M, B) => {
      if (e.destroyed || !e.autoplay.running) return
      ;(clearTimeout(p), M || (b = !0))
      const G = () => {
        ;(r('autoplayPause'),
          e.params.autoplay.waitForTransition
            ? e.wrapperEl.addEventListener('transitionend', m)
            : T())
      }
      if (((e.autoplay.paused = !0), B)) {
        ;(v && (l = e.params.autoplay.delay), (v = !1), G())
        return
      }
      ;((l = (l || e.params.autoplay.delay) - (new Date().getTime() - u)),
        !(e.isEnd && l < 0 && !e.params.loop) && (l < 0 && (l = 0), G()))
    },
    T = () => {
      ;(e.isEnd && l < 0 && !e.params.loop) ||
        e.destroyed ||
        !e.autoplay.running ||
        ((u = new Date().getTime()),
        b ? ((b = !1), O(l)) : O(),
        (e.autoplay.paused = !1),
        r('autoplayResume'))
    },
    I = () => {
      if (e.destroyed || !e.autoplay.running) return
      const M = W()
      ;(M.visibilityState === 'hidden' && ((b = !0), S(!0)),
        M.visibilityState === 'visible' && T())
    },
    P = M => {
      M.pointerType === 'mouse' &&
        ((b = !0), (g = !0), !(e.animating || e.autoplay.paused) && S(!0))
    },
    C = M => {
      M.pointerType === 'mouse' && ((g = !1), e.autoplay.paused && T())
    },
    A = () => {
      e.params.autoplay.pauseOnMouseEnter &&
        (e.el.addEventListener('pointerenter', P),
        e.el.addEventListener('pointerleave', C))
    },
    $ = () => {
      e.el &&
        typeof e.el != 'string' &&
        (e.el.removeEventListener('pointerenter', P),
        e.el.removeEventListener('pointerleave', C))
    },
    k = () => {
      W().addEventListener('visibilitychange', I)
    },
    E = () => {
      W().removeEventListener('visibilitychange', I)
    }
  ;(s('init', () => {
    e.params.autoplay.enabled && (A(), k(), L())
  }),
    s('destroy', () => {
      ;($(), E(), e.autoplay.running && z())
    }),
    s('_freeModeStaticRelease', () => {
      ;(n || b) && T()
    }),
    s('_freeModeNoMomentumRelease', () => {
      e.params.autoplay.disableOnInteraction ? z() : S(!0, !0)
    }),
    s('beforeTransitionStart', (M, B, G) => {
      e.destroyed ||
        !e.autoplay.running ||
        (G || !e.params.autoplay.disableOnInteraction ? S(!0, !0) : z())
    }),
    s('sliderFirstMove', () => {
      if (!(e.destroyed || !e.autoplay.running)) {
        if (e.params.autoplay.disableOnInteraction) {
          z()
          return
        }
        ;((h = !0),
          (n = !1),
          (b = !1),
          (o = setTimeout(() => {
            ;((b = !0), (n = !0), S(!0))
          }, 200)))
      }
    }),
    s('touchEnd', () => {
      if (!(e.destroyed || !e.autoplay.running || !h)) {
        if (
          (clearTimeout(o),
          clearTimeout(p),
          e.params.autoplay.disableOnInteraction)
        ) {
          ;((n = !1), (h = !1))
          return
        }
        ;(n && e.params.cssMode && T(), (n = !1), (h = !1))
      }
    }),
    s('slideChange', () => {
      e.destroyed || !e.autoplay.running || (v = !0)
    }),
    Object.assign(e.autoplay, { start: L, stop: z, pause: S, resume: T }))
}
function ts(i) {
  let { swiper: e, extendParams: t, on: s } = i
  t({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs',
    },
  })
  let r = !1,
    a = !1
  e.thumbs = { swiper: null }
  function p() {
    const d = e.thumbs.swiper
    if (!d || d.destroyed) return
    const l = d.clickedIndex,
      u = d.clickedSlide
    if (
      (u && u.classList.contains(e.params.thumbs.slideThumbActiveClass)) ||
      typeof l > 'u' ||
      l === null
    )
      return
    let w
    ;(d.params.loop
      ? (w = parseInt(
          d.clickedSlide.getAttribute('data-swiper-slide-index'),
          10
        ))
      : (w = l),
      e.params.loop ? e.slideToLoop(w) : e.slideTo(w))
  }
  function c() {
    const { thumbs: d } = e.params
    if (r) return !1
    r = !0
    const l = e.constructor
    if (d.swiper instanceof l) {
      if (d.swiper.destroyed) return ((r = !1), !1)
      ;((e.thumbs.swiper = d.swiper),
        Object.assign(e.thumbs.swiper.originalParams, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1,
        }),
        Object.assign(e.thumbs.swiper.params, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1,
        }),
        e.thumbs.swiper.update())
    } else if (xe(d.swiper)) {
      const u = Object.assign({}, d.swiper)
      ;(Object.assign(u, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
        (e.thumbs.swiper = new l(u)),
        (a = !0))
    }
    return (
      e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass),
      e.thumbs.swiper.on('tap', p),
      !0
    )
  }
  function f(d) {
    const l = e.thumbs.swiper
    if (!l || l.destroyed) return
    const u =
      l.params.slidesPerView === 'auto'
        ? l.slidesPerViewDynamic()
        : l.params.slidesPerView
    let w = 1
    const h = e.params.thumbs.slideThumbActiveClass
    if (
      (e.params.slidesPerView > 1 &&
        !e.params.centeredSlides &&
        (w = e.params.slidesPerView),
      e.params.thumbs.multipleActiveThumbs || (w = 1),
      (w = Math.floor(w)),
      l.slides.forEach(v => v.classList.remove(h)),
      l.params.loop || (l.params.virtual && l.params.virtual.enabled))
    )
      for (let v = 0; v < w; v += 1)
        j(l.slidesEl, `[data-swiper-slide-index="${e.realIndex + v}"]`).forEach(
          b => {
            b.classList.add(h)
          }
        )
    else
      for (let v = 0; v < w; v += 1)
        l.slides[e.realIndex + v] && l.slides[e.realIndex + v].classList.add(h)
    const n = e.params.thumbs.autoScrollOffset,
      o = n && !l.params.loop
    if (e.realIndex !== l.realIndex || o) {
      const v = l.activeIndex
      let b, g
      if (l.params.loop) {
        const m = l.slides.find(
          y => y.getAttribute('data-swiper-slide-index') === `${e.realIndex}`
        )
        ;((b = l.slides.indexOf(m)),
          (g = e.activeIndex > e.previousIndex ? 'next' : 'prev'))
      } else ((b = e.realIndex), (g = b > e.previousIndex ? 'next' : 'prev'))
      ;(o && (b += g === 'next' ? n : -1 * n),
        l.visibleSlidesIndexes &&
          l.visibleSlidesIndexes.indexOf(b) < 0 &&
          (l.params.centeredSlides
            ? b > v
              ? (b = b - Math.floor(u / 2) + 1)
              : (b = b + Math.floor(u / 2) - 1)
            : b > v && l.params.slidesPerGroup,
          l.slideTo(b, d ? 0 : void 0)))
    }
  }
  ;(s('beforeInit', () => {
    const { thumbs: d } = e.params
    if (!(!d || !d.swiper))
      if (typeof d.swiper == 'string' || d.swiper instanceof HTMLElement) {
        const l = W(),
          u = () => {
            const h =
              typeof d.swiper == 'string' ? l.querySelector(d.swiper) : d.swiper
            if (h && h.swiper) ((d.swiper = h.swiper), c(), f(!0))
            else if (h) {
              const n = `${e.params.eventsPrefix}init`,
                o = v => {
                  ;((d.swiper = v.detail[0]),
                    h.removeEventListener(n, o),
                    c(),
                    f(!0),
                    d.swiper.update(),
                    e.update())
                }
              h.addEventListener(n, o)
            }
            return h
          },
          w = () => {
            if (e.destroyed) return
            u() || requestAnimationFrame(w)
          }
        requestAnimationFrame(w)
      } else (c(), f(!0))
  }),
    s('slideChange update resize observerUpdate', () => {
      f()
    }),
    s('setTransition', (d, l) => {
      const u = e.thumbs.swiper
      !u || u.destroyed || u.setTransition(l)
    }),
    s('beforeDestroy', () => {
      const d = e.thumbs.swiper
      !d || d.destroyed || (a && d.destroy())
    }),
    Object.assign(e.thumbs, { init: c, update: f }))
}
function is(i) {
  let { swiper: e, extendParams: t, emit: s, once: r } = i
  t({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02,
    },
  })
  function a() {
    if (e.params.cssMode) return
    const f = e.getTranslate()
    ;(e.setTranslate(f),
      e.setTransition(0),
      (e.touchEventsData.velocities.length = 0),
      e.freeMode.onTouchEnd({ currentPos: e.rtl ? e.translate : -e.translate }))
  }
  function p() {
    if (e.params.cssMode) return
    const { touchEventsData: f, touches: d } = e
    ;(f.velocities.length === 0 &&
      f.velocities.push({
        position: d[e.isHorizontal() ? 'startX' : 'startY'],
        time: f.touchStartTime,
      }),
      f.velocities.push({
        position: d[e.isHorizontal() ? 'currentX' : 'currentY'],
        time: J(),
      }))
  }
  function c(f) {
    let { currentPos: d } = f
    if (e.params.cssMode) return
    const {
        params: l,
        wrapperEl: u,
        rtlTranslate: w,
        snapGrid: h,
        touchEventsData: n,
      } = e,
      v = J() - n.touchStartTime
    if (d < -e.minTranslate()) {
      e.slideTo(e.activeIndex)
      return
    }
    if (d > -e.maxTranslate()) {
      e.slides.length < h.length
        ? e.slideTo(h.length - 1)
        : e.slideTo(e.slides.length - 1)
      return
    }
    if (l.freeMode.momentum) {
      if (n.velocities.length > 1) {
        const z = n.velocities.pop(),
          S = n.velocities.pop(),
          T = z.position - S.position,
          I = z.time - S.time
        ;((e.velocity = T / I),
          (e.velocity /= 2),
          Math.abs(e.velocity) < l.freeMode.minimumVelocity && (e.velocity = 0),
          (I > 150 || J() - z.time > 300) && (e.velocity = 0))
      } else e.velocity = 0
      ;((e.velocity *= l.freeMode.momentumVelocityRatio),
        (n.velocities.length = 0))
      let b = 1e3 * l.freeMode.momentumRatio
      const g = e.velocity * b
      let m = e.translate + g
      w && (m = -m)
      let y = !1,
        x
      const O = Math.abs(e.velocity) * 20 * l.freeMode.momentumBounceRatio
      let L
      if (m < e.maxTranslate())
        (l.freeMode.momentumBounce
          ? (m + e.maxTranslate() < -O && (m = e.maxTranslate() - O),
            (x = e.maxTranslate()),
            (y = !0),
            (n.allowMomentumBounce = !0))
          : (m = e.maxTranslate()),
          l.loop && l.centeredSlides && (L = !0))
      else if (m > e.minTranslate())
        (l.freeMode.momentumBounce
          ? (m - e.minTranslate() > O && (m = e.minTranslate() + O),
            (x = e.minTranslate()),
            (y = !0),
            (n.allowMomentumBounce = !0))
          : (m = e.minTranslate()),
          l.loop && l.centeredSlides && (L = !0))
      else if (l.freeMode.sticky) {
        let z
        for (let S = 0; S < h.length; S += 1)
          if (h[S] > -m) {
            z = S
            break
          }
        ;(Math.abs(h[z] - m) < Math.abs(h[z - 1] - m) ||
        e.swipeDirection === 'next'
          ? (m = h[z])
          : (m = h[z - 1]),
          (m = -m))
      }
      if (
        (L &&
          r('transitionEnd', () => {
            e.loopFix()
          }),
        e.velocity !== 0)
      ) {
        if (
          (w
            ? (b = Math.abs((-m - e.translate) / e.velocity))
            : (b = Math.abs((m - e.translate) / e.velocity)),
          l.freeMode.sticky)
        ) {
          const z = Math.abs((w ? -m : m) - e.translate),
            S = e.slidesSizesGrid[e.activeIndex]
          z < S
            ? (b = l.speed)
            : z < 2 * S
              ? (b = l.speed * 1.5)
              : (b = l.speed * 2.5)
        }
      } else if (l.freeMode.sticky) {
        e.slideToClosest()
        return
      }
      ;(l.freeMode.momentumBounce && y
        ? (e.updateProgress(x),
          e.setTransition(b),
          e.setTranslate(m),
          e.transitionStart(!0, e.swipeDirection),
          (e.animating = !0),
          Me(u, () => {
            !e ||
              e.destroyed ||
              !n.allowMomentumBounce ||
              (s('momentumBounce'),
              e.setTransition(l.speed),
              setTimeout(() => {
                ;(e.setTranslate(x),
                  Me(u, () => {
                    !e || e.destroyed || e.transitionEnd()
                  }))
              }, 0))
          }))
        : e.velocity
          ? (s('_freeModeNoMomentumRelease'),
            e.updateProgress(m),
            e.setTransition(b),
            e.setTranslate(m),
            e.transitionStart(!0, e.swipeDirection),
            e.animating ||
              ((e.animating = !0),
              Me(u, () => {
                !e || e.destroyed || e.transitionEnd()
              })))
          : e.updateProgress(m),
        e.updateActiveIndex(),
        e.updateSlidesClasses())
    } else if (l.freeMode.sticky) {
      e.slideToClosest()
      return
    } else l.freeMode && s('_freeModeNoMomentumRelease')
    ;(!l.freeMode.momentum || v >= l.longSwipesMs) &&
      (s('_freeModeStaticRelease'),
      e.updateProgress(),
      e.updateActiveIndex(),
      e.updateSlidesClasses())
  }
  Object.assign(e, {
    freeMode: { onTouchStart: a, onTouchMove: p, onTouchEnd: c },
  })
}
function ss(i) {
  let { swiper: e, extendParams: t, on: s } = i
  t({ grid: { rows: 1, fill: 'column' } })
  let r, a, p, c
  const f = () => {
      let o = e.params.spaceBetween
      return (
        typeof o == 'string' && o.indexOf('%') >= 0
          ? (o = (parseFloat(o.replace('%', '')) / 100) * e.size)
          : typeof o == 'string' && (o = parseFloat(o)),
        o
      )
    },
    d = o => {
      const { slidesPerView: v } = e.params,
        { rows: b, fill: g } = e.params.grid,
        m =
          e.virtual && e.params.virtual.enabled
            ? e.virtual.slides.length
            : o.length
      ;((p = Math.floor(m / b)),
        Math.floor(m / b) === m / b ? (r = m) : (r = Math.ceil(m / b) * b),
        v !== 'auto' && g === 'row' && (r = Math.max(r, v * b)),
        (a = r / b))
    },
    l = () => {
      e.slides &&
        e.slides.forEach(o => {
          o.swiperSlideGridSet &&
            ((o.style.height = ''),
            (o.style[e.getDirectionLabel('margin-top')] = ''))
        })
    },
    u = (o, v, b) => {
      const { slidesPerGroup: g } = e.params,
        m = f(),
        { rows: y, fill: x } = e.params.grid,
        O =
          e.virtual && e.params.virtual.enabled
            ? e.virtual.slides.length
            : b.length
      let L, z, S
      if (x === 'row' && g > 1) {
        const T = Math.floor(o / (g * y)),
          I = o - y * g * T,
          P = T === 0 ? g : Math.min(Math.ceil((O - T * y * g) / y), g)
        ;((S = Math.floor(I / P)),
          (z = I - S * P + T * g),
          (L = z + (S * r) / y),
          (v.style.order = L))
      } else
        x === 'column'
          ? ((z = Math.floor(o / y)),
            (S = o - z * y),
            (z > p || (z === p && S === y - 1)) &&
              ((S += 1), S >= y && ((S = 0), (z += 1))))
          : ((S = Math.floor(o / a)), (z = o - S * a))
      ;((v.row = S),
        (v.column = z),
        (v.style.height = `calc((100% - ${(y - 1) * m}px) / ${y})`),
        (v.style[e.getDirectionLabel('margin-top')] =
          S !== 0 ? m && `${m}px` : ''),
        (v.swiperSlideGridSet = !0))
    },
    w = (o, v) => {
      const { centeredSlides: b, roundLengths: g } = e.params,
        m = f(),
        { rows: y } = e.params.grid
      if (
        ((e.virtualSize = (o + m) * r),
        (e.virtualSize = Math.ceil(e.virtualSize / y) - m),
        e.params.cssMode ||
          (e.wrapperEl.style[e.getDirectionLabel('width')] =
            `${e.virtualSize + m}px`),
        b)
      ) {
        const x = []
        for (let O = 0; O < v.length; O += 1) {
          let L = v[O]
          ;(g && (L = Math.floor(L)), v[O] < e.virtualSize + v[0] && x.push(L))
        }
        ;(v.splice(0, v.length), v.push(...x))
      }
    },
    h = () => {
      c = e.params.grid && e.params.grid.rows > 1
    },
    n = () => {
      const { params: o, el: v } = e,
        b = o.grid && o.grid.rows > 1
      ;(c && !b
        ? (v.classList.remove(
            `${o.containerModifierClass}grid`,
            `${o.containerModifierClass}grid-column`
          ),
          (p = 1),
          e.emitContainerClasses())
        : !c &&
          b &&
          (v.classList.add(`${o.containerModifierClass}grid`),
          o.grid.fill === 'column' &&
            v.classList.add(`${o.containerModifierClass}grid-column`),
          e.emitContainerClasses()),
        (c = b))
    }
  ;(s('init', h),
    s('update', n),
    (e.grid = {
      initSlides: d,
      unsetSlides: l,
      updateSlide: u,
      updateWrapperSize: w,
    }))
}
function rs(i) {
  const e = this,
    { params: t, slidesEl: s } = e
  t.loop && e.loopDestroy()
  const r = a => {
    if (typeof a == 'string') {
      const p = document.createElement('div')
      ;(ee(p, a), s.append(p.children[0]), ee(p, ''))
    } else s.append(a)
  }
  if (typeof i == 'object' && 'length' in i)
    for (let a = 0; a < i.length; a += 1) i[a] && r(i[a])
  else r(i)
  ;(e.recalcSlides(),
    t.loop && e.loopCreate(),
    (!t.observer || e.isElement) && e.update())
}
function as(i) {
  const e = this,
    { params: t, activeIndex: s, slidesEl: r } = e
  t.loop && e.loopDestroy()
  let a = s + 1
  const p = c => {
    if (typeof c == 'string') {
      const f = document.createElement('div')
      ;(ee(f, c), r.prepend(f.children[0]), ee(f, ''))
    } else r.prepend(c)
  }
  if (typeof i == 'object' && 'length' in i) {
    for (let c = 0; c < i.length; c += 1) i[c] && p(i[c])
    a = s + i.length
  } else p(i)
  ;(e.recalcSlides(),
    t.loop && e.loopCreate(),
    (!t.observer || e.isElement) && e.update(),
    e.slideTo(a, 0, !1))
}
function ns(i, e) {
  const t = this,
    { params: s, activeIndex: r, slidesEl: a } = t
  let p = r
  s.loop && ((p -= t.loopedSlides), t.loopDestroy(), t.recalcSlides())
  const c = t.slides.length
  if (i <= 0) {
    t.prependSlide(e)
    return
  }
  if (i >= c) {
    t.appendSlide(e)
    return
  }
  let f = p > i ? p + 1 : p
  const d = []
  for (let l = c - 1; l >= i; l -= 1) {
    const u = t.slides[l]
    ;(u.remove(), d.unshift(u))
  }
  if (typeof e == 'object' && 'length' in e) {
    for (let l = 0; l < e.length; l += 1) e[l] && a.append(e[l])
    f = p > i ? p + e.length : p
  } else a.append(e)
  for (let l = 0; l < d.length; l += 1) a.append(d[l])
  ;(t.recalcSlides(),
    s.loop && t.loopCreate(),
    (!s.observer || t.isElement) && t.update(),
    s.loop ? t.slideTo(f + t.loopedSlides, 0, !1) : t.slideTo(f, 0, !1))
}
function os(i) {
  const e = this,
    { params: t, activeIndex: s } = e
  let r = s
  t.loop && ((r -= e.loopedSlides), e.loopDestroy())
  let a = r,
    p
  if (typeof i == 'object' && 'length' in i) {
    for (let c = 0; c < i.length; c += 1)
      ((p = i[c]), e.slides[p] && e.slides[p].remove(), p < a && (a -= 1))
    a = Math.max(a, 0)
  } else
    ((p = i),
      e.slides[p] && e.slides[p].remove(),
      p < a && (a -= 1),
      (a = Math.max(a, 0)))
  ;(e.recalcSlides(),
    t.loop && e.loopCreate(),
    (!t.observer || e.isElement) && e.update(),
    t.loop ? e.slideTo(a + e.loopedSlides, 0, !1) : e.slideTo(a, 0, !1))
}
function ls() {
  const i = this,
    e = []
  for (let t = 0; t < i.slides.length; t += 1) e.push(t)
  i.removeSlide(e)
}
function ds(i) {
  let { swiper: e } = i
  Object.assign(e, {
    appendSlide: rs.bind(e),
    prependSlide: as.bind(e),
    addSlide: ns.bind(e),
    removeSlide: os.bind(e),
    removeAllSlides: ls.bind(e),
  })
}
function be(i) {
  const {
    effect: e,
    swiper: t,
    on: s,
    setTranslate: r,
    setTransition: a,
    overwriteParams: p,
    perspective: c,
    recreateShadows: f,
    getEffectParams: d,
  } = i
  ;(s('beforeInit', () => {
    if (t.params.effect !== e) return
    ;(t.classNames.push(`${t.params.containerModifierClass}${e}`),
      c && c() && t.classNames.push(`${t.params.containerModifierClass}3d`))
    const u = p ? p() : {}
    ;(Object.assign(t.params, u), Object.assign(t.originalParams, u))
  }),
    s('setTranslate _virtualUpdated', () => {
      t.params.effect === e && r()
    }),
    s('setTransition', (u, w) => {
      t.params.effect === e && a(w)
    }),
    s('transitionEnd', () => {
      if (t.params.effect === e && f) {
        if (!d || !d().slideShadows) return
        ;(t.slides.forEach(u => {
          u.querySelectorAll(
            '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
          ).forEach(w => w.remove())
        }),
          f())
      }
    }))
  let l
  s('virtualUpdate', () => {
    t.params.effect === e &&
      (t.slides.length || (l = !0),
      requestAnimationFrame(() => {
        l && t.slides && t.slides.length && (r(), (l = !1))
      }))
  })
}
function Pe(i, e) {
  const t = fe(e)
  return (
    t !== e &&
      ((t.style.backfaceVisibility = 'hidden'),
      (t.style['-webkit-backface-visibility'] = 'hidden')),
    t
  )
}
function ke(i) {
  let { swiper: e, duration: t, transformElements: s, allSlides: r } = i
  const { activeIndex: a } = e,
    p = c =>
      c.parentElement
        ? c.parentElement
        : e.slides.find(d => d.shadowRoot && d.shadowRoot === c.parentNode)
  if (e.params.virtualTranslate && t !== 0) {
    let c = !1,
      f
    ;(r
      ? (f = s)
      : (f = s.filter(d => {
          const l = d.classList.contains('swiper-slide-transform') ? p(d) : d
          return e.getSlideIndex(l) === a
        })),
      f.forEach(d => {
        Me(d, () => {
          if (c || !e || e.destroyed) return
          ;((c = !0), (e.animating = !1))
          const l = new window.CustomEvent('transitionend', {
            bubbles: !0,
            cancelable: !0,
          })
          e.wrapperEl.dispatchEvent(l)
        })
      }))
  }
}
function cs(i) {
  let { swiper: e, extendParams: t, on: s } = i
  ;(t({ fadeEffect: { crossFade: !1 } }),
    be({
      effect: 'fade',
      swiper: e,
      on: s,
      setTranslate: () => {
        const { slides: p } = e,
          c = e.params.fadeEffect
        for (let f = 0; f < p.length; f += 1) {
          const d = e.slides[f]
          let u = -d.swiperSlideOffset
          e.params.virtualTranslate || (u -= e.translate)
          let w = 0
          e.isHorizontal() || ((w = u), (u = 0))
          const h = e.params.fadeEffect.crossFade
              ? Math.max(1 - Math.abs(d.progress), 0)
              : 1 + Math.min(Math.max(d.progress, -1), 0),
            n = Pe(c, d)
          ;((n.style.opacity = h),
            (n.style.transform = `translate3d(${u}px, ${w}px, 0px)`))
        }
      },
      setTransition: p => {
        const c = e.slides.map(f => fe(f))
        ;(c.forEach(f => {
          f.style.transitionDuration = `${p}ms`
        }),
          ke({ swiper: e, duration: p, transformElements: c, allSlides: !0 }))
      },
      overwriteParams: () => ({
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: !0,
        spaceBetween: 0,
        virtualTranslate: !e.params.cssMode,
      }),
    }))
}
function ps(i) {
  let { swiper: e, extendParams: t, on: s } = i
  t({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94,
    },
  })
  const r = (f, d, l) => {
    let u = l
        ? f.querySelector('.swiper-slide-shadow-left')
        : f.querySelector('.swiper-slide-shadow-top'),
      w = l
        ? f.querySelector('.swiper-slide-shadow-right')
        : f.querySelector('.swiper-slide-shadow-bottom')
    ;(u ||
      ((u = Q(
        'div',
        `swiper-slide-shadow-cube swiper-slide-shadow-${l ? 'left' : 'top'}`.split(
          ' '
        )
      )),
      f.append(u)),
      w ||
        ((w = Q(
          'div',
          `swiper-slide-shadow-cube swiper-slide-shadow-${l ? 'right' : 'bottom'}`.split(
            ' '
          )
        )),
        f.append(w)),
      u && (u.style.opacity = Math.max(-d, 0)),
      w && (w.style.opacity = Math.max(d, 0)))
  }
  be({
    effect: 'cube',
    swiper: e,
    on: s,
    setTranslate: () => {
      const {
          el: f,
          wrapperEl: d,
          slides: l,
          width: u,
          height: w,
          rtlTranslate: h,
          size: n,
          browser: o,
        } = e,
        v = _e(e),
        b = e.params.cubeEffect,
        g = e.isHorizontal(),
        m = e.virtual && e.params.virtual.enabled
      let y = 0,
        x
      b.shadow &&
        (g
          ? ((x = e.wrapperEl.querySelector('.swiper-cube-shadow')),
            x || ((x = Q('div', 'swiper-cube-shadow')), e.wrapperEl.append(x)),
            (x.style.height = `${u}px`))
          : ((x = f.querySelector('.swiper-cube-shadow')),
            x || ((x = Q('div', 'swiper-cube-shadow')), f.append(x))))
      for (let L = 0; L < l.length; L += 1) {
        const z = l[L]
        let S = L
        m && (S = parseInt(z.getAttribute('data-swiper-slide-index'), 10))
        let T = S * 90,
          I = Math.floor(T / 360)
        h && ((T = -T), (I = Math.floor(-T / 360)))
        const P = Math.max(Math.min(z.progress, 1), -1)
        let C = 0,
          A = 0,
          $ = 0
        ;(S % 4 === 0
          ? ((C = -I * 4 * n), ($ = 0))
          : (S - 1) % 4 === 0
            ? ((C = 0), ($ = -I * 4 * n))
            : (S - 2) % 4 === 0
              ? ((C = n + I * 4 * n), ($ = n))
              : (S - 3) % 4 === 0 && ((C = -n), ($ = 3 * n + n * 4 * I)),
          h && (C = -C),
          g || ((A = C), (C = 0)))
        const k = `rotateX(${v(g ? 0 : -T)}deg) rotateY(${v(g ? T : 0)}deg) translate3d(${C}px, ${A}px, ${$}px)`
        ;(P <= 1 &&
          P > -1 &&
          ((y = S * 90 + P * 90), h && (y = -S * 90 - P * 90)),
          (z.style.transform = k),
          b.slideShadows && r(z, P, g))
      }
      if (
        ((d.style.transformOrigin = `50% 50% -${n / 2}px`),
        (d.style['-webkit-transform-origin'] = `50% 50% -${n / 2}px`),
        b.shadow)
      )
        if (g)
          x.style.transform = `translate3d(0px, ${u / 2 + b.shadowOffset}px, ${-u / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${b.shadowScale})`
        else {
          const L = Math.abs(y) - Math.floor(Math.abs(y) / 90) * 90,
            z =
              1.5 -
              (Math.sin((L * 2 * Math.PI) / 360) / 2 +
                Math.cos((L * 2 * Math.PI) / 360) / 2),
            S = b.shadowScale,
            T = b.shadowScale / z,
            I = b.shadowOffset
          x.style.transform = `scale3d(${S}, 1, ${T}) translate3d(0px, ${w / 2 + I}px, ${-w / 2 / T}px) rotateX(-89.99deg)`
        }
      const O = (o.isSafari || o.isWebView) && o.needPerspectiveFix ? -n / 2 : 0
      ;((d.style.transform = `translate3d(0px,0,${O}px) rotateX(${v(e.isHorizontal() ? 0 : y)}deg) rotateY(${v(e.isHorizontal() ? -y : 0)}deg)`),
        d.style.setProperty('--swiper-cube-translate-z', `${O}px`))
    },
    setTransition: f => {
      const { el: d, slides: l } = e
      if (
        (l.forEach(u => {
          ;((u.style.transitionDuration = `${f}ms`),
            u
              .querySelectorAll(
                '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
              )
              .forEach(w => {
                w.style.transitionDuration = `${f}ms`
              }))
        }),
        e.params.cubeEffect.shadow && !e.isHorizontal())
      ) {
        const u = d.querySelector('.swiper-cube-shadow')
        u && (u.style.transitionDuration = `${f}ms`)
      }
    },
    recreateShadows: () => {
      const f = e.isHorizontal()
      e.slides.forEach(d => {
        const l = Math.max(Math.min(d.progress, 1), -1)
        r(d, l, f)
      })
    },
    getEffectParams: () => e.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0,
    }),
  })
}
function we(i, e, t) {
  const s = `swiper-slide-shadow${t ? `-${t}` : ''}${i ? ` swiper-slide-shadow-${i}` : ''}`,
    r = fe(e)
  let a = r.querySelector(`.${s.split(' ').join('.')}`)
  return (a || ((a = Q('div', s.split(' '))), r.append(a)), a)
}
function fs(i) {
  let { swiper: e, extendParams: t, on: s } = i
  t({ flipEffect: { slideShadows: !0, limitRotation: !0 } })
  const r = (f, d) => {
    let l = e.isHorizontal()
        ? f.querySelector('.swiper-slide-shadow-left')
        : f.querySelector('.swiper-slide-shadow-top'),
      u = e.isHorizontal()
        ? f.querySelector('.swiper-slide-shadow-right')
        : f.querySelector('.swiper-slide-shadow-bottom')
    ;(l || (l = we('flip', f, e.isHorizontal() ? 'left' : 'top')),
      u || (u = we('flip', f, e.isHorizontal() ? 'right' : 'bottom')),
      l && (l.style.opacity = Math.max(-d, 0)),
      u && (u.style.opacity = Math.max(d, 0)))
  }
  be({
    effect: 'flip',
    swiper: e,
    on: s,
    setTranslate: () => {
      const { slides: f, rtlTranslate: d } = e,
        l = e.params.flipEffect,
        u = _e(e)
      for (let w = 0; w < f.length; w += 1) {
        const h = f[w]
        let n = h.progress
        e.params.flipEffect.limitRotation &&
          (n = Math.max(Math.min(h.progress, 1), -1))
        const o = h.swiperSlideOffset
        let b = -180 * n,
          g = 0,
          m = e.params.cssMode ? -o - e.translate : -o,
          y = 0
        ;(e.isHorizontal()
          ? d && (b = -b)
          : ((y = m), (m = 0), (g = -b), (b = 0)),
          (h.style.zIndex = -Math.abs(Math.round(n)) + f.length),
          l.slideShadows && r(h, n))
        const x = `translate3d(${m}px, ${y}px, 0px) rotateX(${u(g)}deg) rotateY(${u(b)}deg)`,
          O = Pe(l, h)
        O.style.transform = x
      }
    },
    setTransition: f => {
      const d = e.slides.map(l => fe(l))
      ;(d.forEach(l => {
        ;((l.style.transitionDuration = `${f}ms`),
          l
            .querySelectorAll(
              '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
            )
            .forEach(u => {
              u.style.transitionDuration = `${f}ms`
            }))
      }),
        ke({ swiper: e, duration: f, transformElements: d }))
    },
    recreateShadows: () => {
      ;(e.params.flipEffect,
        e.slides.forEach(f => {
          let d = f.progress
          ;(e.params.flipEffect.limitRotation &&
            (d = Math.max(Math.min(f.progress, 1), -1)),
            r(f, d))
        }))
    },
    getEffectParams: () => e.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode,
    }),
  })
}
function us(i) {
  let { swiper: e, extendParams: t, on: s } = i
  ;(t({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0,
    },
  }),
    be({
      effect: 'coverflow',
      swiper: e,
      on: s,
      setTranslate: () => {
        const { width: p, height: c, slides: f, slidesSizesGrid: d } = e,
          l = e.params.coverflowEffect,
          u = e.isHorizontal(),
          w = e.translate,
          h = u ? -w + p / 2 : -w + c / 2,
          n = u ? l.rotate : -l.rotate,
          o = l.depth,
          v = _e(e)
        for (let b = 0, g = f.length; b < g; b += 1) {
          const m = f[b],
            y = d[b],
            x = m.swiperSlideOffset,
            O = (h - x - y / 2) / y,
            L = typeof l.modifier == 'function' ? l.modifier(O) : O * l.modifier
          let z = u ? n * L : 0,
            S = u ? 0 : n * L,
            T = -o * Math.abs(L),
            I = l.stretch
          typeof I == 'string' &&
            I.indexOf('%') !== -1 &&
            (I = (parseFloat(l.stretch) / 100) * y)
          let P = u ? 0 : I * L,
            C = u ? I * L : 0,
            A = 1 - (1 - l.scale) * Math.abs(L)
          ;(Math.abs(C) < 0.001 && (C = 0),
            Math.abs(P) < 0.001 && (P = 0),
            Math.abs(T) < 0.001 && (T = 0),
            Math.abs(z) < 0.001 && (z = 0),
            Math.abs(S) < 0.001 && (S = 0),
            Math.abs(A) < 0.001 && (A = 0))
          const $ = `translate3d(${C}px,${P}px,${T}px)  rotateX(${v(S)}deg) rotateY(${v(z)}deg) scale(${A})`,
            k = Pe(l, m)
          if (
            ((k.style.transform = $),
            (m.style.zIndex = -Math.abs(Math.round(L)) + 1),
            l.slideShadows)
          ) {
            let E = u
                ? m.querySelector('.swiper-slide-shadow-left')
                : m.querySelector('.swiper-slide-shadow-top'),
              M = u
                ? m.querySelector('.swiper-slide-shadow-right')
                : m.querySelector('.swiper-slide-shadow-bottom')
            ;(E || (E = we('coverflow', m, u ? 'left' : 'top')),
              M || (M = we('coverflow', m, u ? 'right' : 'bottom')),
              E && (E.style.opacity = L > 0 ? L : 0),
              M && (M.style.opacity = -L > 0 ? -L : 0))
          }
        }
      },
      setTransition: p => {
        e.slides
          .map(f => fe(f))
          .forEach(f => {
            ;((f.style.transitionDuration = `${p}ms`),
              f
                .querySelectorAll(
                  '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                )
                .forEach(d => {
                  d.style.transitionDuration = `${p}ms`
                }))
          })
      },
      perspective: () => !0,
      overwriteParams: () => ({ watchSlidesProgress: !0 }),
    }))
}
function ms(i) {
  let { swiper: e, extendParams: t, on: s } = i
  t({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
      next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
    },
  })
  const r = c => (typeof c == 'string' ? c : `${c}px`)
  be({
    effect: 'creative',
    swiper: e,
    on: s,
    setTranslate: () => {
      const { slides: c, wrapperEl: f, slidesSizesGrid: d } = e,
        l = e.params.creativeEffect,
        { progressMultiplier: u } = l,
        w = e.params.centeredSlides,
        h = _e(e)
      if (w) {
        const n = d[0] / 2 - e.params.slidesOffsetBefore || 0
        f.style.transform = `translateX(calc(50% - ${n}px))`
      }
      for (let n = 0; n < c.length; n += 1) {
        const o = c[n],
          v = o.progress,
          b = Math.min(Math.max(o.progress, -l.limitProgress), l.limitProgress)
        let g = b
        w ||
          (g = Math.min(
            Math.max(o.originalProgress, -l.limitProgress),
            l.limitProgress
          ))
        const m = o.swiperSlideOffset,
          y = [e.params.cssMode ? -m - e.translate : -m, 0, 0],
          x = [0, 0, 0]
        let O = !1
        e.isHorizontal() || ((y[1] = y[0]), (y[0] = 0))
        let L = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1,
        }
        ;(b < 0 ? ((L = l.next), (O = !0)) : b > 0 && ((L = l.prev), (O = !0)),
          y.forEach((A, $) => {
            y[$] = `calc(${A}px + (${r(L.translate[$])} * ${Math.abs(b * u)}))`
          }),
          x.forEach((A, $) => {
            let k = L.rotate[$] * Math.abs(b * u)
            x[$] = k
          }),
          (o.style.zIndex = -Math.abs(Math.round(v)) + c.length))
        const z = y.join(', '),
          S = `rotateX(${h(x[0])}deg) rotateY(${h(x[1])}deg) rotateZ(${h(x[2])}deg)`,
          T =
            g < 0
              ? `scale(${1 + (1 - L.scale) * g * u})`
              : `scale(${1 - (1 - L.scale) * g * u})`,
          I = g < 0 ? 1 + (1 - L.opacity) * g * u : 1 - (1 - L.opacity) * g * u,
          P = `translate3d(${z}) ${S} ${T}`
        if ((O && L.shadow) || !O) {
          let A = o.querySelector('.swiper-slide-shadow')
          if ((!A && L.shadow && (A = we('creative', o)), A)) {
            const $ = l.shadowPerProgress ? b * (1 / l.limitProgress) : b
            A.style.opacity = Math.min(Math.max(Math.abs($), 0), 1)
          }
        }
        const C = Pe(l, o)
        ;((C.style.transform = P),
          (C.style.opacity = I),
          L.origin && (C.style.transformOrigin = L.origin))
      }
    },
    setTransition: c => {
      const f = e.slides.map(d => fe(d))
      ;(f.forEach(d => {
        ;((d.style.transitionDuration = `${c}ms`),
          d.querySelectorAll('.swiper-slide-shadow').forEach(l => {
            l.style.transitionDuration = `${c}ms`
          }))
      }),
        ke({ swiper: e, duration: c, transformElements: f, allSlides: !0 }))
    },
    perspective: () => e.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode,
    }),
  })
}
function hs(i) {
  let { swiper: e, extendParams: t, on: s } = i
  ;(t({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8,
    },
  }),
    be({
      effect: 'cards',
      swiper: e,
      on: s,
      setTranslate: () => {
        const { slides: p, activeIndex: c, rtlTranslate: f } = e,
          d = e.params.cardsEffect,
          { startTranslate: l, isTouched: u } = e.touchEventsData,
          w = f ? -e.translate : e.translate
        for (let h = 0; h < p.length; h += 1) {
          const n = p[h],
            o = n.progress,
            v = Math.min(Math.max(o, -4), 4)
          let b = n.swiperSlideOffset
          ;(e.params.centeredSlides &&
            !e.params.cssMode &&
            (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`),
            e.params.centeredSlides &&
              e.params.cssMode &&
              (b -= p[0].swiperSlideOffset))
          let g = e.params.cssMode ? -b - e.translate : -b,
            m = 0
          const y = -100 * Math.abs(v)
          let x = 1,
            O = -d.perSlideRotate * v,
            L = d.perSlideOffset - Math.abs(v) * 0.75
          const z =
              e.virtual && e.params.virtual.enabled ? e.virtual.from + h : h,
            S =
              (z === c || z === c - 1) &&
              v > 0 &&
              v < 1 &&
              (u || e.params.cssMode) &&
              w < l,
            T =
              (z === c || z === c + 1) &&
              v < 0 &&
              v > -1 &&
              (u || e.params.cssMode) &&
              w > l
          if (S || T) {
            const A = (1 - Math.abs((Math.abs(v) - 0.5) / 0.5)) ** 0.5
            ;((O += -28 * v * A),
              (x += -0.5 * A),
              (L += 96 * A),
              (m = `${-25 * A * Math.abs(v)}%`))
          }
          if (
            (v < 0
              ? (g = `calc(${g}px ${f ? '-' : '+'} (${L * Math.abs(v)}%))`)
              : v > 0
                ? (g = `calc(${g}px ${f ? '-' : '+'} (-${L * Math.abs(v)}%))`)
                : (g = `${g}px`),
            !e.isHorizontal())
          ) {
            const A = m
            ;((m = g), (g = A))
          }
          const I = v < 0 ? `${1 + (1 - x) * v}` : `${1 - (1 - x) * v}`,
            P = `
        translate3d(${g}, ${m}, ${y}px)
        rotateZ(${d.rotate ? (f ? -O : O) : 0}deg)
        scale(${I})
      `
          if (d.slideShadows) {
            let A = n.querySelector('.swiper-slide-shadow')
            ;(A || (A = we('cards', n)),
              A &&
                (A.style.opacity = Math.min(
                  Math.max((Math.abs(v) - 0.5) / 0.5, 0),
                  1
                )))
          }
          n.style.zIndex = -Math.abs(Math.round(o)) + p.length
          const C = Pe(d, n)
          C.style.transform = P
        }
      },
      setTransition: p => {
        const c = e.slides.map(f => fe(f))
        ;(c.forEach(f => {
          ;((f.style.transitionDuration = `${p}ms`),
            f.querySelectorAll('.swiper-slide-shadow').forEach(d => {
              d.style.transitionDuration = `${p}ms`
            }))
        }),
          ke({ swiper: e, duration: p, transformElements: c }))
      },
      perspective: () => !0,
      overwriteParams: () => ({
        _loopSwapReset: !1,
        watchSlidesProgress: !0,
        loopAdditionalSlides: e.params.cardsEffect.rotate ? 3 : 2,
        centeredSlides: !0,
        virtualTranslate: !e.params.cssMode,
      }),
    }))
}
const gs = [
  Xi,
  Yi,
  Ni,
  Fi,
  Wi,
  ji,
  qi,
  Ui,
  Ki,
  Zi,
  Qi,
  Ji,
  es,
  ts,
  is,
  ss,
  ds,
  cs,
  ps,
  fs,
  us,
  ms,
  hs,
]
K.use(gs)
const Re = [
  'eventsPrefix',
  'injectStyles',
  'injectStylesUrls',
  'modules',
  'init',
  '_direction',
  'oneWayMovement',
  'swiperElementNodeName',
  'touchEventsTarget',
  'initialSlide',
  '_speed',
  'cssMode',
  'updateOnWindowResize',
  'resizeObserver',
  'nested',
  'focusableElements',
  '_enabled',
  '_width',
  '_height',
  'preventInteractionOnTransition',
  'userAgent',
  'url',
  '_edgeSwipeDetection',
  '_edgeSwipeThreshold',
  '_freeMode',
  '_autoHeight',
  'setWrapperSize',
  'virtualTranslate',
  '_effect',
  'breakpoints',
  'breakpointsBase',
  '_spaceBetween',
  '_slidesPerView',
  'maxBackfaceHiddenSlides',
  '_grid',
  '_slidesPerGroup',
  '_slidesPerGroupSkip',
  '_slidesPerGroupAuto',
  '_centeredSlides',
  '_centeredSlidesBounds',
  '_slidesOffsetBefore',
  '_slidesOffsetAfter',
  'normalizeSlideIndex',
  '_centerInsufficientSlides',
  '_watchOverflow',
  'roundLengths',
  'touchRatio',
  'touchAngle',
  'simulateTouch',
  '_shortSwipes',
  '_longSwipes',
  'longSwipesRatio',
  'longSwipesMs',
  '_followFinger',
  'allowTouchMove',
  '_threshold',
  'touchMoveStopPropagation',
  'touchStartPreventDefault',
  'touchStartForcePreventDefault',
  'touchReleaseOnEdges',
  'uniqueNavElements',
  '_resistance',
  '_resistanceRatio',
  '_watchSlidesProgress',
  '_grabCursor',
  'preventClicks',
  'preventClicksPropagation',
  '_slideToClickedSlide',
  '_loop',
  'loopAdditionalSlides',
  'loopAddBlankSlides',
  'loopPreventsSliding',
  '_rewind',
  '_allowSlidePrev',
  '_allowSlideNext',
  '_swipeHandler',
  '_noSwiping',
  'noSwipingClass',
  'noSwipingSelector',
  'passiveListeners',
  'containerModifierClass',
  'slideClass',
  'slideActiveClass',
  'slideVisibleClass',
  'slideFullyVisibleClass',
  'slideNextClass',
  'slidePrevClass',
  'slideBlankClass',
  'wrapperClass',
  'lazyPreloaderClass',
  'lazyPreloadPrevNext',
  'runCallbacksOnInit',
  'observer',
  'observeParents',
  'observeSlideChildren',
  'a11y',
  '_autoplay',
  '_controller',
  'coverflowEffect',
  'cubeEffect',
  'fadeEffect',
  'flipEffect',
  'creativeEffect',
  'cardsEffect',
  'hashNavigation',
  'history',
  'keyboard',
  'mousewheel',
  '_navigation',
  '_pagination',
  'parallax',
  '_scrollbar',
  '_thumbs',
  'virtual',
  'zoom',
  'control',
]
function ve(i) {
  return (
    typeof i == 'object' &&
    i !== null &&
    i.constructor &&
    Object.prototype.toString.call(i).slice(8, -1) === 'Object' &&
    !i.__swiper__
  )
}
function tt(i, e) {
  const t = ['__proto__', 'constructor', 'prototype']
  Object.keys(e)
    .filter(s => t.indexOf(s) < 0)
    .forEach(s => {
      typeof i[s] > 'u'
        ? (i[s] = e[s])
        : ve(e[s]) && ve(i[s]) && Object.keys(e[s]).length > 0
          ? e[s].__swiper__
            ? (i[s] = e[s])
            : tt(i[s], e[s])
          : (i[s] = e[s])
    })
}
function ws(i) {
  return (
    i === void 0 && (i = {}),
    i.navigation &&
      typeof i.navigation.nextEl > 'u' &&
      typeof i.navigation.prevEl > 'u'
  )
}
function vs(i) {
  return (
    i === void 0 && (i = {}),
    i.pagination && typeof i.pagination.el > 'u'
  )
}
function bs(i) {
  return (i === void 0 && (i = {}), i.scrollbar && typeof i.scrollbar.el > 'u')
}
function Oe(i) {
  return (
    i === void 0 && (i = ''),
    i.replace(/-[a-z]/g, e => e.toUpperCase().replace('-', ''))
  )
}
function ys(i) {
  let {
    swiper: e,
    slides: t,
    passedParams: s,
    changedParams: r,
    nextEl: a,
    prevEl: p,
    scrollbarEl: c,
    paginationEl: f,
  } = i
  const d = r.filter(
      S => S !== 'children' && S !== 'direction' && S !== 'wrapperClass'
    ),
    {
      params: l,
      pagination: u,
      navigation: w,
      scrollbar: h,
      virtual: n,
      thumbs: o,
    } = e
  let v, b, g, m, y, x, O, L
  ;(r.includes('thumbs') &&
    s.thumbs &&
    s.thumbs.swiper &&
    !s.thumbs.swiper.destroyed &&
    l.thumbs &&
    (!l.thumbs.swiper || l.thumbs.swiper.destroyed) &&
    (v = !0),
    r.includes('controller') &&
      s.controller &&
      s.controller.control &&
      l.controller &&
      !l.controller.control &&
      (b = !0),
    r.includes('pagination') &&
      s.pagination &&
      (s.pagination.el || f) &&
      (l.pagination || l.pagination === !1) &&
      u &&
      !u.el &&
      (g = !0),
    r.includes('scrollbar') &&
      s.scrollbar &&
      (s.scrollbar.el || c) &&
      (l.scrollbar || l.scrollbar === !1) &&
      h &&
      !h.el &&
      (m = !0),
    r.includes('navigation') &&
      s.navigation &&
      (s.navigation.prevEl || p) &&
      (s.navigation.nextEl || a) &&
      (l.navigation || l.navigation === !1) &&
      w &&
      !w.prevEl &&
      !w.nextEl &&
      (y = !0))
  const z = S => {
    e[S] &&
      (e[S].destroy(),
      S === 'navigation'
        ? (e.isElement && (e[S].prevEl.remove(), e[S].nextEl.remove()),
          (l[S].prevEl = void 0),
          (l[S].nextEl = void 0),
          (e[S].prevEl = void 0),
          (e[S].nextEl = void 0))
        : (e.isElement && e[S].el.remove(),
          (l[S].el = void 0),
          (e[S].el = void 0)))
  }
  ;(r.includes('loop') &&
    e.isElement &&
    (l.loop && !s.loop ? (x = !0) : !l.loop && s.loop ? (O = !0) : (L = !0)),
    d.forEach(S => {
      if (ve(l[S]) && ve(s[S]))
        (Object.assign(l[S], s[S]),
          (S === 'navigation' || S === 'pagination' || S === 'scrollbar') &&
            'enabled' in s[S] &&
            !s[S].enabled &&
            z(S))
      else {
        const T = s[S]
        ;(T === !0 || T === !1) &&
        (S === 'navigation' || S === 'pagination' || S === 'scrollbar')
          ? T === !1 && z(S)
          : (l[S] = s[S])
      }
    }),
    d.includes('controller') &&
      !b &&
      e.controller &&
      e.controller.control &&
      l.controller &&
      l.controller.control &&
      (e.controller.control = l.controller.control),
    r.includes('children') && t && n && l.virtual.enabled
      ? ((n.slides = t), n.update(!0))
      : r.includes('virtual') &&
        n &&
        l.virtual.enabled &&
        (t && (n.slides = t), n.update(!0)),
    r.includes('children') && t && l.loop && (L = !0),
    v && o.init() && o.update(!0),
    b && (e.controller.control = l.controller.control),
    g &&
      (e.isElement &&
        (!f || typeof f == 'string') &&
        ((f = document.createElement('div')),
        f.classList.add('swiper-pagination'),
        f.part.add('pagination'),
        e.el.appendChild(f)),
      f && (l.pagination.el = f),
      u.init(),
      u.render(),
      u.update()),
    m &&
      (e.isElement &&
        (!c || typeof c == 'string') &&
        ((c = document.createElement('div')),
        c.classList.add('swiper-scrollbar'),
        c.part.add('scrollbar'),
        e.el.appendChild(c)),
      c && (l.scrollbar.el = c),
      h.init(),
      h.updateSize(),
      h.setTranslate()),
    y &&
      (e.isElement &&
        ((!a || typeof a == 'string') &&
          ((a = document.createElement('div')),
          a.classList.add('swiper-button-next'),
          ee(a, e.hostEl.constructor.nextButtonSvg),
          a.part.add('button-next'),
          e.el.appendChild(a)),
        (!p || typeof p == 'string') &&
          ((p = document.createElement('div')),
          p.classList.add('swiper-button-prev'),
          ee(p, e.hostEl.constructor.prevButtonSvg),
          p.part.add('button-prev'),
          e.el.appendChild(p))),
      a && (l.navigation.nextEl = a),
      p && (l.navigation.prevEl = p),
      w.init(),
      w.update()),
    r.includes('allowSlideNext') && (e.allowSlideNext = s.allowSlideNext),
    r.includes('allowSlidePrev') && (e.allowSlidePrev = s.allowSlidePrev),
    r.includes('direction') && e.changeDirection(s.direction, !1),
    (x || L) && e.loopDestroy(),
    (O || L) && e.loopCreate(),
    e.update())
}
const ct = i => {
    if (parseFloat(i) === Number(i)) return Number(i)
    if (i === 'true' || i === '') return !0
    if (i === 'false') return !1
    if (i === 'null') return null
    if (i !== 'undefined') {
      if (
        typeof i == 'string' &&
        i.includes('{') &&
        i.includes('}') &&
        i.includes('"')
      ) {
        let e
        try {
          e = JSON.parse(i)
        } catch {
          e = i
        }
        return e
      }
      return i
    }
  },
  pt = [
    'a11y',
    'autoplay',
    'controller',
    'cards-effect',
    'coverflow-effect',
    'creative-effect',
    'cube-effect',
    'fade-effect',
    'flip-effect',
    'free-mode',
    'grid',
    'hash-navigation',
    'history',
    'keyboard',
    'mousewheel',
    'navigation',
    'pagination',
    'parallax',
    'scrollbar',
    'thumbs',
    'virtual',
    'zoom',
  ]
function ft(i, e, t) {
  const s = {},
    r = {}
  tt(s, et)
  const a = [...Re, 'on'],
    p = a.map(f => f.replace(/_/, ''))
  a.forEach(f => {
    ;((f = f.replace('_', '')), typeof i[f] < 'u' && (r[f] = i[f]))
  })
  const c = [...i.attributes]
  return (
    typeof e == 'string' &&
      typeof t < 'u' &&
      c.push({ name: e, value: ve(t) ? { ...t } : t }),
    c.forEach(f => {
      const d = pt.find(l => f.name.startsWith(`${l}-`))
      if (d) {
        const l = Oe(d),
          u = Oe(f.name.split(`${d}-`)[1])
        ;(typeof r[l] > 'u' && (r[l] = {}),
          r[l] === !0 && (r[l] = { enabled: !0 }),
          r[l] === !1 && (r[l] = { enabled: !1 }),
          (r[l][u] = ct(f.value)))
      } else {
        const l = Oe(f.name)
        if (!p.includes(l)) return
        const u = ct(f.value)
        r[l] && pt.includes(f.name) && !ve(u)
          ? (r[l].constructor !== Object && (r[l] = {}), (r[l].enabled = !!u))
          : (r[l] = u)
      }
    }),
    tt(s, r),
    s.navigation
      ? (s.navigation = {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
          ...(s.navigation !== !0 ? s.navigation : {}),
        })
      : s.navigation === !1 && delete s.navigation,
    s.scrollbar
      ? (s.scrollbar = {
          el: '.swiper-scrollbar',
          ...(s.scrollbar !== !0 ? s.scrollbar : {}),
        })
      : s.scrollbar === !1 && delete s.scrollbar,
    s.pagination
      ? (s.pagination = {
          el: '.swiper-pagination',
          ...(s.pagination !== !0 ? s.pagination : {}),
        })
      : s.pagination === !1 && delete s.pagination,
    { params: s, passedParams: r }
  )
}
const Ss =
    ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}",
  Es =
    '::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}'
class xs {}
const Et = typeof window > 'u' || typeof HTMLElement > 'u' ? xs : HTMLElement,
  ut = `<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
    `,
  xt = (i, e) => {
    if (typeof CSSStyleSheet < 'u' && i.adoptedStyleSheets) {
      const t = new CSSStyleSheet()
      ;(t.replaceSync(e), (i.adoptedStyleSheets = [t]))
    } else {
      const t = document.createElement('style')
      ;((t.rel = 'stylesheet'), (t.textContent = e), i.appendChild(t))
    }
  }
class Tt extends Et {
  constructor() {
    ;(super(), this.attachShadow({ mode: 'open' }))
  }
  static get nextButtonSvg() {
    return ut
  }
  static get prevButtonSvg() {
    return ut.replace(
      '/></svg>',
      ' transform-origin="center" transform="rotate(180)"/></svg>'
    )
  }
  cssStyles() {
    return [
      Ss,
      ...(this.injectStyles && Array.isArray(this.injectStyles)
        ? this.injectStyles
        : []),
    ].join(`
`)
  }
  cssLinks() {
    return this.injectStylesUrls || []
  }
  calcSlideSlots() {
    const e = this.slideSlots || 0,
      t = [...this.querySelectorAll('[slot^=slide-]')].map(s =>
        parseInt(s.getAttribute('slot').split('slide-')[1], 10)
      )
    if (
      ((this.slideSlots = t.length ? Math.max(...t) + 1 : 0), !!this.rendered)
    ) {
      if (this.slideSlots > e)
        for (let s = e; s < this.slideSlots; s += 1) {
          const r = document.createElement('swiper-slide')
          r.setAttribute('part', `slide slide-${s + 1}`)
          const a = document.createElement('slot')
          ;(a.setAttribute('name', `slide-${s + 1}`),
            r.appendChild(a),
            this.shadowRoot.querySelector('.swiper-wrapper').appendChild(r))
        }
      else if (this.slideSlots < e) {
        const s = this.swiper.slides
        for (let r = s.length - 1; r >= 0; r -= 1)
          r > this.slideSlots && s[r].remove()
      }
    }
  }
  render() {
    if (this.rendered) return
    this.calcSlideSlots()
    let e = this.cssStyles()
    ;(this.slideSlots > 0 &&
      (e = e.replace(/::slotted\(([a-z-0-9.]*)\)/g, '$1')),
      e.length && xt(this.shadowRoot, e),
      this.cssLinks().forEach(s => {
        if (this.shadowRoot.querySelector(`link[href="${s}"]`)) return
        const a = document.createElement('link')
        ;((a.rel = 'stylesheet'), (a.href = s), this.shadowRoot.appendChild(a))
      }))
    const t = document.createElement('div')
    ;(t.classList.add('swiper'),
      (t.part = 'container'),
      ee(
        t,
        `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper" part="wrapper">
        <slot></slot>
        ${Array.from({ length: this.slideSlots })
          .map(
            (s, r) => `
        <swiper-slide part="slide slide-${r}">
          <slot name="slide-${r}"></slot>
        </swiper-slide>
        `
          )
          .join('')}
      </div>
      <slot name="container-end"></slot>
      ${
        ws(this.passedParams)
          ? `
        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>
        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>
      `
          : ''
      }
      ${
        vs(this.passedParams)
          ? `
        <div part="pagination" class="swiper-pagination"></div>
      `
          : ''
      }
      ${
        bs(this.passedParams)
          ? `
        <div part="scrollbar" class="swiper-scrollbar"></div>
      `
          : ''
      }
    `
      ),
      this.shadowRoot.appendChild(t),
      (this.rendered = !0))
  }
  initialize() {
    var e = this
    if (this.swiper && this.swiper.initialized) return
    const { params: t, passedParams: s } = ft(this)
    ;((this.swiperParams = t),
      (this.passedParams = s),
      delete this.swiperParams.init,
      this.render(),
      (this.swiper = new K(this.shadowRoot.querySelector('.swiper'), {
        ...(t.virtual ? {} : { observer: !0 }),
        ...t,
        touchEventsTarget: 'container',
        onAny: function (r) {
          r === 'observerUpdate' && e.calcSlideSlots()
          const a = t.eventsPrefix
            ? `${t.eventsPrefix}${r.toLowerCase()}`
            : r.toLowerCase()
          for (
            var p = arguments.length, c = new Array(p > 1 ? p - 1 : 0), f = 1;
            f < p;
            f++
          )
            c[f - 1] = arguments[f]
          const d = new CustomEvent(a, {
            detail: c,
            bubbles: r !== 'hashChange',
            cancelable: !0,
          })
          e.dispatchEvent(d)
        },
      })))
  }
  connectedCallback() {
    ;(this.swiper &&
      this.swiper.initialized &&
      this.nested &&
      this.closest('swiper-slide') &&
      this.closest('swiper-slide').swiperLoopMoveDOM) ||
      this.init === !1 ||
      this.getAttribute('init') === 'false' ||
      this.initialize()
  }
  disconnectedCallback() {
    ;(this.nested &&
      this.closest('swiper-slide') &&
      this.closest('swiper-slide').swiperLoopMoveDOM) ||
      (this.swiper && this.swiper.destroy && this.swiper.destroy())
  }
  updateSwiperOnPropChange(e, t) {
    const { params: s, passedParams: r } = ft(this, e, t)
    ;((this.passedParams = r),
      (this.swiperParams = s),
      !(this.swiper && this.swiper.params[e] === t) &&
        ys({
          swiper: this.swiper,
          passedParams: this.passedParams,
          changedParams: [Oe(e)],
          ...(e === 'navigation' && r[e]
            ? { prevEl: '.swiper-button-prev', nextEl: '.swiper-button-next' }
            : {}),
          ...(e === 'pagination' && r[e]
            ? { paginationEl: '.swiper-pagination' }
            : {}),
          ...(e === 'scrollbar' && r[e]
            ? { scrollbarEl: '.swiper-scrollbar' }
            : {}),
        }))
  }
  attributeChangedCallback(e, t, s) {
    this.swiper &&
      this.swiper.initialized &&
      (t === 'true' && s === null && (s = !1),
      this.updateSwiperOnPropChange(e, s))
  }
  static get observedAttributes() {
    return Re.filter(t => t.includes('_')).map(t =>
      t
        .replace(/[A-Z]/g, s => `-${s}`)
        .replace('_', '')
        .toLowerCase()
    )
  }
}
Re.forEach(i => {
  i !== 'init' &&
    ((i = i.replace('_', '')),
    Object.defineProperty(Tt.prototype, i, {
      configurable: !0,
      get() {
        return (this.passedParams || {})[i]
      },
      set(e) {
        ;(this.passedParams || (this.passedParams = {}),
          (this.passedParams[i] = e),
          this.swiper &&
            this.swiper.initialized &&
            this.updateSwiperOnPropChange(i, e))
      },
    }))
})
class Ts extends Et {
  constructor() {
    ;(super(), this.attachShadow({ mode: 'open' }))
  }
  render() {
    const e =
      this.lazy ||
      this.getAttribute('lazy') === '' ||
      this.getAttribute('lazy') === 'true'
    if (
      (xt(this.shadowRoot, Es),
      this.shadowRoot.appendChild(document.createElement('slot')),
      e)
    ) {
      const t = document.createElement('div')
      ;(t.classList.add('swiper-lazy-preloader'),
        t.part.add('preloader'),
        this.shadowRoot.appendChild(t))
    }
  }
  initialize() {
    this.render()
  }
  connectedCallback() {
    this.swiperLoopMoveDOM || this.initialize()
  }
}
const Ms = () => {
  typeof window > 'u' ||
    (window.customElements.get('swiper-container') ||
      window.customElements.define('swiper-container', Tt),
    window.customElements.get('swiper-slide') ||
      window.customElements.define('swiper-slide', Ts))
}
typeof window < 'u' &&
  (window.SwiperElementRegisterParams = i => {
    Re.push(...i)
  })
function Cs(i) {
  return Array.from(
    i.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter(
    t => !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
  )
}
const se = {}
function Hs(i, e = i) {
  const t = Cs(i),
    s = t[0],
    r = t[t.length - 1]
  ;(Ps(),
    (se.focusin = a => {
      ;(a.target !== i && a.target !== r && a.target !== s) ||
        document.addEventListener('keydown', se.keydown)
    }),
    (se.focusout = function () {
      document.removeEventListener('keydown', se.keydown)
    }),
    (se.keydown = function (a) {
      a.code.toUpperCase() === 'TAB' &&
        (a.target === r && !a.shiftKey && (a.preventDefault(), s.focus()),
        (a.target === i || a.target === s) &&
          a.shiftKey &&
          (a.preventDefault(), r.focus()))
    }),
    document.addEventListener('focusout', se.focusout),
    document.addEventListener('focusin', se.focusin),
    e.focus())
}
function Ps(i = null) {
  ;(document.removeEventListener('focusin', se.focusin),
    document.removeEventListener('focusout', se.focusout),
    document.removeEventListener('keydown', se.keydown),
    i && i.focus())
}
function Ls(i) {
  if (i.code.toUpperCase() !== 'ESCAPE') return
  const e = i.target.closest('details[open]')
  if (!e) return
  const t = e.querySelector('summary')
  ;(e.removeAttribute('open'), t.setAttribute('aria-expanded', !1), t.focus())
}
function zs(i) {
  i.forEach(e => {
    ;(e.setAttribute('role', 'button'),
      e.setAttribute('aria-expanded', e.parentNode.hasAttribute('open')),
      e.nextElementSibling.getAttribute('id') &&
        e.setAttribute('aria-controls', e.nextElementSibling.id),
      e.addEventListener('click', t => {
        t.currentTarget.setAttribute(
          'aria-expanded',
          !t.currentTarget.closest('details').hasAttribute('open')
        )
      }),
      e.parentElement.addEventListener('keyup', Ls))
  })
}
const Is = 'modulepreload',
  As = function (i, e) {
    return new URL(i, e).href
  },
  mt = {},
  N = function (e, t, s) {
    let r = Promise.resolve()
    if (t && t.length > 0) {
      let p = function (l) {
        return Promise.all(
          l.map(u =>
            Promise.resolve(u).then(
              w => ({ status: 'fulfilled', value: w }),
              w => ({ status: 'rejected', reason: w })
            )
          )
        )
      }
      const c = document.getElementsByTagName('link'),
        f = document.querySelector('meta[property=csp-nonce]'),
        d =
          (f == null ? void 0 : f.nonce) ||
          (f == null ? void 0 : f.getAttribute('nonce'))
      r = p(
        t.map(l => {
          if (((l = As(l, s)), l in mt)) return
          mt[l] = !0
          const u = l.endsWith('.css'),
            w = u ? '[rel="stylesheet"]' : ''
          if (!!s)
            for (let o = c.length - 1; o >= 0; o--) {
              const v = c[o]
              if (v.href === l && (!u || v.rel === 'stylesheet')) return
            }
          else if (document.querySelector(`link[href="${l}"]${w}`)) return
          const n = document.createElement('link')
          if (
            ((n.rel = u ? 'stylesheet' : Is),
            u || (n.as = 'script'),
            (n.crossOrigin = ''),
            (n.href = l),
            d && n.setAttribute('nonce', d),
            document.head.appendChild(n),
            u)
          )
            return new Promise((o, v) => {
              ;(n.addEventListener('load', o),
                n.addEventListener('error', () =>
                  v(new Error(`Unable to preload CSS for ${l}`))
                ))
            })
        })
      )
    }
    function a(p) {
      const c = new Event('vite:preloadError', { cancelable: !0 })
      if (((c.payload = p), window.dispatchEvent(c), !c.defaultPrevented))
        throw p
    }
    return r.then(p => {
      for (const c of p || []) c.status === 'rejected' && a(c.reason)
      return e().catch(a)
    })
  }
function Os({ query: i }) {
  const e = window.matchMedia(i)
  return new Promise(function (t) {
    e.matches ? t(!0) : e.addEventListener('change', t, { once: !0 })
  })
}
function Ds({ element: i }) {
  return new Promise(function (e) {
    const t = new window.IntersectionObserver(async function (s) {
      for (const r of s)
        if (r.isIntersecting) {
          ;(t.disconnect(), e(!0))
          break
        }
    })
    t.observe(i)
  })
}
function $s() {
  return new Promise(function (i) {
    'requestIdleCallback' in window
      ? window.requestIdleCallback(i)
      : setTimeout(i, 200)
  })
}
const _s = Object.assign({
  '/src/islands/blog-load-more.js': () =>
    N(() => import('./blog-load-more-3mg7BhfJ.js'), [], import.meta.url),
  '/src/islands/cart-drawer-items.js': () =>
    N(
      () => import('./cart-drawer-items-Bh2R4wgB.js'),
      __vite__mapDeps([0, 1, 2]),
      import.meta.url
    ),
  '/src/islands/cart-drawer.js': () =>
    N(() => import('./cart-drawer-d6WVjBkR.js'), [], import.meta.url),
  '/src/islands/cart-items.js': () =>
    N(
      () => import('./cart-items-BrQubsXJ.js'),
      __vite__mapDeps([1, 2]),
      import.meta.url
    ),
  '/src/islands/cart-remove-button.js': () =>
    N(() => import('./cart-remove-button-DAtlsxCk.js'), [], import.meta.url),
  '/src/islands/compare-table.js': () =>
    N(() => import('./compare-table-BBsGMqyB.js'), [], import.meta.url),
  '/src/islands/dosage-slider.js': () =>
    N(() => import('./dosage-slider-SUb3eWE6.js'), [], import.meta.url),
  '/src/islands/dropdown-list.js': () =>
    N(() => import('./dropdown-list-BfD_m8Lp.js'), [], import.meta.url),
  '/src/islands/figure-carousel.js': () =>
    N(() => import('./figure-carousel-t6LQCKxa.js'), [], import.meta.url),
  '/src/islands/header-predictive-search.js': () =>
    N(
      () => import('./header-predictive-search-Dg5ChYj-.js'),
      [],
      import.meta.url
    ),
  '/src/islands/help-dropdown.js': () =>
    N(() => import('./help-dropdown-g-f4SGCq.js'), [], import.meta.url),
  '/src/islands/product-accordion.js': () =>
    N(() => import('./product-accordion-jt3r3MtP.js'), [], import.meta.url),
  '/src/islands/product-carousel.js': () =>
    N(() => import('./product-carousel-BE5bdjNf.js'), [], import.meta.url),
  '/src/islands/product-carousels.js': () =>
    N(() => import('./product-carousels-BzleBJXf.js'), [], import.meta.url),
  '/src/islands/product-form.js': () =>
    N(
      () => import('./product-form-B5zVRFIO.js'),
      __vite__mapDeps([3, 2]),
      import.meta.url
    ),
  '/src/islands/product-recommendations.js': () =>
    N(
      () => import('./product-recommendations-7JqaDVT-.js'),
      [],
      import.meta.url
    ),
  '/src/islands/purchase-options.js': () =>
    N(() => import('./purchase-options-B6L9Ajtn.js'), [], import.meta.url),
  '/src/islands/quantity-input.js': () =>
    N(() => import('./quantity-input-Bt_gz9nO.js'), [], import.meta.url),
  '/src/islands/recently-viewed.js': () =>
    N(() => import('./recently-viewed-DiEgyF-w.js'), [], import.meta.url),
  '/src/islands/variant-dropdown.js': () =>
    N(() => import('./variant-dropdown-BBIB6Fij.js'), [], import.meta.url),
  '/src/islands/variant-selects.js': () =>
    N(() => import('./variant-selects-00A7-GSy.js'), [], import.meta.url),
  '/src/islands/video-player.js': () =>
    N(() => import('./video-player-8rJONOp_.js'), [], import.meta.url),
})
function ks(i) {
  const e = new window.MutationObserver(s => {
    for (let r = 0; r < s.length; r++) {
      const { addedNodes: a } = s[r]
      for (let p = 0; p < a.length; p++) {
        const c = a[p]
        c.nodeType === 1 && t(c)
      }
    }
  })
  async function t(s) {
    const r = s.tagName.toLowerCase(),
      a = `/src/islands/${r}.js`
    if (/-/.test(r) && i[a]) {
      s.hasAttribute('client:visible') && (await Ds({ element: s }))
      const f = s.getAttribute('client:media')
      ;(f && (await Os({ query: f })),
        s.hasAttribute('client:idle') && (await $s()),
        i[a]())
    }
    let c = s.firstElementChild
    for (; c; ) (t(c), (c = c.nextElementSibling))
  }
  ;(t(document.body), e.observe(document.body, { childList: !0, subtree: !0 }))
}
function Rs() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  const e = document.querySelectorAll('.animate-section')
  if (!e.length) return
  const t = new IntersectionObserver(
    s => {
      s.forEach(r => {
        r.isIntersecting &&
          (r.target.classList.add('animate-visible'), t.unobserve(r.target))
      })
    },
    { threshold: 0, rootMargin: '0px' }
  )
  e.forEach(s => {
    t.observe(s)
  })
}
const Vs = { '2xs': 384, sm: 640, md: 768, xl: 1200 }
function Bs() {
  return new URLSearchParams(window.location.search).get('variant')
}
function Ke() {
  const i = Bs()
  if (!i) return
  document.querySelectorAll('[data-variant-option]').forEach(t => {
    t.dataset.variantOption === i
      ? t.classList.remove('hidden')
      : t.classList.add('hidden')
  })
}
function Gs() {
  ;(Ke(),
    window.addEventListener('popstate', () => {
      Ke()
    }),
    ['pushState', 'replaceState'].forEach(i => {
      const e = history[i]
      history[i] = function () {
        const t = e.apply(this, arguments)
        return (Ke(), t)
      }
    }))
}
document.addEventListener('DOMContentLoaded', () => {
  Gs()
})
Ms()
ks(_s)
zs(document.querySelectorAll('[id^="details-"] summary'))
Rs()
export { Zi as A, Fi as N, Ps as r, Vs as s, Hs as t }
